// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.15.3
//   protoc               v7.36.2
// source: proto/logiblocks/logiblocks.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import {
  VariableDesc,
  VariableSource,
  variableSourceFromJSON,
  variableSourceToJSON,
  VariableType,
  variableTypeFromJSON,
  variableTypeToJSON,
} from "../common";

export const protobufPackage = "protobuf.logiblocks";

export enum IntervalUnit {
  MINUTES = 0,
  HOURS = 1,
  /** SECONDS - Delay durations only (Snooze offers minutes and hours). */
  SECONDS = 2,
  UNRECOGNIZED = -1,
}

export function intervalUnitFromJSON(object: any): IntervalUnit {
  switch (object) {
    case 0:
    case "MINUTES":
      return IntervalUnit.MINUTES;
    case 1:
    case "HOURS":
      return IntervalUnit.HOURS;
    case 2:
    case "SECONDS":
      return IntervalUnit.SECONDS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return IntervalUnit.UNRECOGNIZED;
  }
}

export function intervalUnitToJSON(object: IntervalUnit): string {
  switch (object) {
    case IntervalUnit.MINUTES:
      return "MINUTES";
    case IntervalUnit.HOURS:
      return "HOURS";
    case IntervalUnit.SECONDS:
      return "SECONDS";
    case IntervalUnit.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum DayOfWeek {
  SUNDAY = 0,
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
  UNRECOGNIZED = -1,
}

export function dayOfWeekFromJSON(object: any): DayOfWeek {
  switch (object) {
    case 0:
    case "SUNDAY":
      return DayOfWeek.SUNDAY;
    case 1:
    case "MONDAY":
      return DayOfWeek.MONDAY;
    case 2:
    case "TUESDAY":
      return DayOfWeek.TUESDAY;
    case 3:
    case "WEDNESDAY":
      return DayOfWeek.WEDNESDAY;
    case 4:
    case "THURSDAY":
      return DayOfWeek.THURSDAY;
    case 5:
    case "FRIDAY":
      return DayOfWeek.FRIDAY;
    case 6:
    case "SATURDAY":
      return DayOfWeek.SATURDAY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DayOfWeek.UNRECOGNIZED;
  }
}

export function dayOfWeekToJSON(object: DayOfWeek): string {
  switch (object) {
    case DayOfWeek.SUNDAY:
      return "SUNDAY";
    case DayOfWeek.MONDAY:
      return "MONDAY";
    case DayOfWeek.TUESDAY:
      return "TUESDAY";
    case DayOfWeek.WEDNESDAY:
      return "WEDNESDAY";
    case DayOfWeek.THURSDAY:
      return "THURSDAY";
    case DayOfWeek.FRIDAY:
      return "FRIDAY";
    case DayOfWeek.SATURDAY:
      return "SATURDAY";
    case DayOfWeek.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ActionTaken {
  ACTION_TAKEN_UNSPECIFIED = 0,
  ACTION_TAKEN_MANUAL_RESOLVED = 1,
  ACTION_TAKEN_MANUAL_DISMISSED = 2,
  ACTION_TAKEN_AI_RESOLVED = 3,
  ACTION_TAKEN_AI_DISMISSED = 4,
  ACTION_TAKEN_SYSTEM_DISMISSED = 5,
  ACTION_TAKEN_MANUAL_ASSIGNED = 6,
  ACTION_TAKEN_SYSTEM_ASSIGNED = 7,
  UNRECOGNIZED = -1,
}

export function actionTakenFromJSON(object: any): ActionTaken {
  switch (object) {
    case 0:
    case "ACTION_TAKEN_UNSPECIFIED":
      return ActionTaken.ACTION_TAKEN_UNSPECIFIED;
    case 1:
    case "ACTION_TAKEN_MANUAL_RESOLVED":
      return ActionTaken.ACTION_TAKEN_MANUAL_RESOLVED;
    case 2:
    case "ACTION_TAKEN_MANUAL_DISMISSED":
      return ActionTaken.ACTION_TAKEN_MANUAL_DISMISSED;
    case 3:
    case "ACTION_TAKEN_AI_RESOLVED":
      return ActionTaken.ACTION_TAKEN_AI_RESOLVED;
    case 4:
    case "ACTION_TAKEN_AI_DISMISSED":
      return ActionTaken.ACTION_TAKEN_AI_DISMISSED;
    case 5:
    case "ACTION_TAKEN_SYSTEM_DISMISSED":
      return ActionTaken.ACTION_TAKEN_SYSTEM_DISMISSED;
    case 6:
    case "ACTION_TAKEN_MANUAL_ASSIGNED":
      return ActionTaken.ACTION_TAKEN_MANUAL_ASSIGNED;
    case 7:
    case "ACTION_TAKEN_SYSTEM_ASSIGNED":
      return ActionTaken.ACTION_TAKEN_SYSTEM_ASSIGNED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ActionTaken.UNRECOGNIZED;
  }
}

export function actionTakenToJSON(object: ActionTaken): string {
  switch (object) {
    case ActionTaken.ACTION_TAKEN_UNSPECIFIED:
      return "ACTION_TAKEN_UNSPECIFIED";
    case ActionTaken.ACTION_TAKEN_MANUAL_RESOLVED:
      return "ACTION_TAKEN_MANUAL_RESOLVED";
    case ActionTaken.ACTION_TAKEN_MANUAL_DISMISSED:
      return "ACTION_TAKEN_MANUAL_DISMISSED";
    case ActionTaken.ACTION_TAKEN_AI_RESOLVED:
      return "ACTION_TAKEN_AI_RESOLVED";
    case ActionTaken.ACTION_TAKEN_AI_DISMISSED:
      return "ACTION_TAKEN_AI_DISMISSED";
    case ActionTaken.ACTION_TAKEN_SYSTEM_DISMISSED:
      return "ACTION_TAKEN_SYSTEM_DISMISSED";
    case ActionTaken.ACTION_TAKEN_MANUAL_ASSIGNED:
      return "ACTION_TAKEN_MANUAL_ASSIGNED";
    case ActionTaken.ACTION_TAKEN_SYSTEM_ASSIGNED:
      return "ACTION_TAKEN_SYSTEM_ASSIGNED";
    case ActionTaken.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Recurrence unit for a repeating schedule. */
export enum RepeatUnit {
  UNSPECIFIED = 0,
  DAY = 1,
  WEEK = 2,
  MONTH = 3,
  UNRECOGNIZED = -1,
}

export function repeatUnitFromJSON(object: any): RepeatUnit {
  switch (object) {
    case 0:
    case "UNSPECIFIED":
      return RepeatUnit.UNSPECIFIED;
    case 1:
    case "DAY":
      return RepeatUnit.DAY;
    case 2:
    case "WEEK":
      return RepeatUnit.WEEK;
    case 3:
    case "MONTH":
      return RepeatUnit.MONTH;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RepeatUnit.UNRECOGNIZED;
  }
}

export function repeatUnitToJSON(object: RepeatUnit): string {
  switch (object) {
    case RepeatUnit.UNSPECIFIED:
      return "UNSPECIFIED";
    case RepeatUnit.DAY:
      return "DAY";
    case RepeatUnit.WEEK:
      return "WEEK";
    case RepeatUnit.MONTH:
      return "MONTH";
    case RepeatUnit.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Action data types */
export enum AIChannelType {
  CALL = 0,
  EMAIL = 1,
  USER_PREFERENCE = 2,
  UNRECOGNIZED = -1,
}

export function aIChannelTypeFromJSON(object: any): AIChannelType {
  switch (object) {
    case 0:
    case "CALL":
      return AIChannelType.CALL;
    case 1:
    case "EMAIL":
      return AIChannelType.EMAIL;
    case 2:
    case "USER_PREFERENCE":
      return AIChannelType.USER_PREFERENCE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AIChannelType.UNRECOGNIZED;
  }
}

export function aIChannelTypeToJSON(object: AIChannelType): string {
  switch (object) {
    case AIChannelType.CALL:
      return "CALL";
    case AIChannelType.EMAIL:
      return "EMAIL";
    case AIChannelType.USER_PREFERENCE:
      return "USER_PREFERENCE";
    case AIChannelType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Agent data types */
export enum AIAgentType {
  RECOMMENDED = 0,
  CUSTOMIZED = 1,
  UNRECOGNIZED = -1,
}

export function aIAgentTypeFromJSON(object: any): AIAgentType {
  switch (object) {
    case 0:
    case "RECOMMENDED":
      return AIAgentType.RECOMMENDED;
    case 1:
    case "CUSTOMIZED":
      return AIAgentType.CUSTOMIZED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AIAgentType.UNRECOGNIZED;
  }
}

export function aIAgentTypeToJSON(object: AIAgentType): string {
  switch (object) {
    case AIAgentType.RECOMMENDED:
      return "RECOMMENDED";
    case AIAgentType.CUSTOMIZED:
      return "CUSTOMIZED";
    case AIAgentType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum WebhookFailureAction {
  /** WEBHOOK_FAILURE_CONTINUE - proto3 default: continue to children, no notification */
  WEBHOOK_FAILURE_CONTINUE = 0,
  /** WEBHOOK_FAILURE_NOTIFY - continue to children, and notify the automation owner */
  WEBHOOK_FAILURE_NOTIFY = 1,
  UNRECOGNIZED = -1,
}

export function webhookFailureActionFromJSON(object: any): WebhookFailureAction {
  switch (object) {
    case 0:
    case "WEBHOOK_FAILURE_CONTINUE":
      return WebhookFailureAction.WEBHOOK_FAILURE_CONTINUE;
    case 1:
    case "WEBHOOK_FAILURE_NOTIFY":
      return WebhookFailureAction.WEBHOOK_FAILURE_NOTIFY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return WebhookFailureAction.UNRECOGNIZED;
  }
}

export function webhookFailureActionToJSON(object: WebhookFailureAction): string {
  switch (object) {
    case WebhookFailureAction.WEBHOOK_FAILURE_CONTINUE:
      return "WEBHOOK_FAILURE_CONTINUE";
    case WebhookFailureAction.WEBHOOK_FAILURE_NOTIFY:
      return "WEBHOOK_FAILURE_NOTIFY";
    case WebhookFailureAction.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Where a WEBHOOK_FAILURE_NOTIFY notification is delivered. Both go to the
 * automation's owner; only the channel differs.
 */
export enum WebhookNotifyChannel {
  /** WEBHOOK_NOTIFY_IN_APP - proto3 default */
  WEBHOOK_NOTIFY_IN_APP = 0,
  WEBHOOK_NOTIFY_EMAIL = 1,
  UNRECOGNIZED = -1,
}

export function webhookNotifyChannelFromJSON(object: any): WebhookNotifyChannel {
  switch (object) {
    case 0:
    case "WEBHOOK_NOTIFY_IN_APP":
      return WebhookNotifyChannel.WEBHOOK_NOTIFY_IN_APP;
    case 1:
    case "WEBHOOK_NOTIFY_EMAIL":
      return WebhookNotifyChannel.WEBHOOK_NOTIFY_EMAIL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return WebhookNotifyChannel.UNRECOGNIZED;
  }
}

export function webhookNotifyChannelToJSON(object: WebhookNotifyChannel): string {
  switch (object) {
    case WebhookNotifyChannel.WEBHOOK_NOTIFY_IN_APP:
      return "WEBHOOK_NOTIFY_IN_APP";
    case WebhookNotifyChannel.WEBHOOK_NOTIFY_EMAIL:
      return "WEBHOOK_NOTIFY_EMAIL";
    case WebhookNotifyChannel.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Which of the shipment's locations a "Delay until location opens" waits for. */
export enum LocationTarget {
  LOCATION_TARGET_UNSPECIFIED = 0,
  ORIGIN = 1,
  DESTINATION = 2,
  CONTROLLING_OFFICE = 3,
  /** PICKUP_OFFICE - The active execution leg's pickup / drop RTG office (customer/execution leg companies). */
  PICKUP_OFFICE = 4,
  DROP_OFFICE = 5,
  UNRECOGNIZED = -1,
}

export function locationTargetFromJSON(object: any): LocationTarget {
  switch (object) {
    case 0:
    case "LOCATION_TARGET_UNSPECIFIED":
      return LocationTarget.LOCATION_TARGET_UNSPECIFIED;
    case 1:
    case "ORIGIN":
      return LocationTarget.ORIGIN;
    case 2:
    case "DESTINATION":
      return LocationTarget.DESTINATION;
    case 3:
    case "CONTROLLING_OFFICE":
      return LocationTarget.CONTROLLING_OFFICE;
    case 4:
    case "PICKUP_OFFICE":
      return LocationTarget.PICKUP_OFFICE;
    case 5:
    case "DROP_OFFICE":
      return LocationTarget.DROP_OFFICE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return LocationTarget.UNRECOGNIZED;
  }
}

export function locationTargetToJSON(object: LocationTarget): string {
  switch (object) {
    case LocationTarget.LOCATION_TARGET_UNSPECIFIED:
      return "LOCATION_TARGET_UNSPECIFIED";
    case LocationTarget.ORIGIN:
      return "ORIGIN";
    case LocationTarget.DESTINATION:
      return "DESTINATION";
    case LocationTarget.CONTROLLING_OFFICE:
      return "CONTROLLING_OFFICE";
    case LocationTarget.PICKUP_OFFICE:
      return "PICKUP_OFFICE";
    case LocationTarget.DROP_OFFICE:
      return "DROP_OFFICE";
    case LocationTarget.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Shipment status changes a Delay can wait for. The editor offers only the ones that are wired up;
 * DELAY_STATUS_CREATED exists in the contract but is not offered.
 */
export enum DelayStatusMilestone {
  DELAY_STATUS_MILESTONE_UNSPECIFIED = 0,
  DELAY_STATUS_CREATED = 1,
  DELAY_STATUS_PICKED_UP = 2,
  DELAY_STATUS_CUSTOMS_HOLD = 3,
  DELAY_STATUS_CUSTOMS_RELEASED = 4,
  DELAY_STATUS_INCOMPLETE = 5,
  DELAY_STATUS_GEOFENCE_DEVIATION = 6,
  DELAY_STATUS_DELIVERED = 7,
  UNRECOGNIZED = -1,
}

export function delayStatusMilestoneFromJSON(object: any): DelayStatusMilestone {
  switch (object) {
    case 0:
    case "DELAY_STATUS_MILESTONE_UNSPECIFIED":
      return DelayStatusMilestone.DELAY_STATUS_MILESTONE_UNSPECIFIED;
    case 1:
    case "DELAY_STATUS_CREATED":
      return DelayStatusMilestone.DELAY_STATUS_CREATED;
    case 2:
    case "DELAY_STATUS_PICKED_UP":
      return DelayStatusMilestone.DELAY_STATUS_PICKED_UP;
    case 3:
    case "DELAY_STATUS_CUSTOMS_HOLD":
      return DelayStatusMilestone.DELAY_STATUS_CUSTOMS_HOLD;
    case 4:
    case "DELAY_STATUS_CUSTOMS_RELEASED":
      return DelayStatusMilestone.DELAY_STATUS_CUSTOMS_RELEASED;
    case 5:
    case "DELAY_STATUS_INCOMPLETE":
      return DelayStatusMilestone.DELAY_STATUS_INCOMPLETE;
    case 6:
    case "DELAY_STATUS_GEOFENCE_DEVIATION":
      return DelayStatusMilestone.DELAY_STATUS_GEOFENCE_DEVIATION;
    case 7:
    case "DELAY_STATUS_DELIVERED":
      return DelayStatusMilestone.DELAY_STATUS_DELIVERED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DelayStatusMilestone.UNRECOGNIZED;
  }
}

export function delayStatusMilestoneToJSON(object: DelayStatusMilestone): string {
  switch (object) {
    case DelayStatusMilestone.DELAY_STATUS_MILESTONE_UNSPECIFIED:
      return "DELAY_STATUS_MILESTONE_UNSPECIFIED";
    case DelayStatusMilestone.DELAY_STATUS_CREATED:
      return "DELAY_STATUS_CREATED";
    case DelayStatusMilestone.DELAY_STATUS_PICKED_UP:
      return "DELAY_STATUS_PICKED_UP";
    case DelayStatusMilestone.DELAY_STATUS_CUSTOMS_HOLD:
      return "DELAY_STATUS_CUSTOMS_HOLD";
    case DelayStatusMilestone.DELAY_STATUS_CUSTOMS_RELEASED:
      return "DELAY_STATUS_CUSTOMS_RELEASED";
    case DelayStatusMilestone.DELAY_STATUS_INCOMPLETE:
      return "DELAY_STATUS_INCOMPLETE";
    case DelayStatusMilestone.DELAY_STATUS_GEOFENCE_DEVIATION:
      return "DELAY_STATUS_GEOFENCE_DEVIATION";
    case DelayStatusMilestone.DELAY_STATUS_DELIVERED:
      return "DELAY_STATUS_DELIVERED";
    case DelayStatusMilestone.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Where a document or a note must be added for a Delay to continue. */
export enum DelayEventWhere {
  /**
   * DELAY_EVENT_WHERE_UNSPECIFIED - Not chosen. A card saved before this setting existed has this, and counts anywhere on the
   * shipment's chain of custody. Publishing requires a choice.
   */
  DELAY_EVENT_WHERE_UNSPECIFIED = 0,
  /**
   * DELAY_EVENT_WHERE_RUN_ALERT - On the alert that started this run, and that alert only: its reply box, and a note an
   * automation appended to it. Needs a workflow that starts from an alert.
   */
  DELAY_EVENT_WHERE_RUN_ALERT = 1,
  /** DELAY_EVENT_WHERE_SHIPMENT - Anywhere on the shipment's chain of custody, alerts included. */
  DELAY_EVENT_WHERE_SHIPMENT = 2,
  UNRECOGNIZED = -1,
}

export function delayEventWhereFromJSON(object: any): DelayEventWhere {
  switch (object) {
    case 0:
    case "DELAY_EVENT_WHERE_UNSPECIFIED":
      return DelayEventWhere.DELAY_EVENT_WHERE_UNSPECIFIED;
    case 1:
    case "DELAY_EVENT_WHERE_RUN_ALERT":
      return DelayEventWhere.DELAY_EVENT_WHERE_RUN_ALERT;
    case 2:
    case "DELAY_EVENT_WHERE_SHIPMENT":
      return DelayEventWhere.DELAY_EVENT_WHERE_SHIPMENT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DelayEventWhere.UNRECOGNIZED;
  }
}

export function delayEventWhereToJSON(object: DelayEventWhere): string {
  switch (object) {
    case DelayEventWhere.DELAY_EVENT_WHERE_UNSPECIFIED:
      return "DELAY_EVENT_WHERE_UNSPECIFIED";
    case DelayEventWhere.DELAY_EVENT_WHERE_RUN_ALERT:
      return "DELAY_EVENT_WHERE_RUN_ALERT";
    case DelayEventWhere.DELAY_EVENT_WHERE_SHIPMENT:
      return "DELAY_EVENT_WHERE_SHIPMENT";
    case DelayEventWhere.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Who wrote a note a Delay waits for. */
export enum DelayNoteAddedBy {
  /** DELAY_NOTE_ADDED_BY_ANYONE - A person or an automation. Zero, so a card saved without this field means anyone. */
  DELAY_NOTE_ADDED_BY_ANYONE = 0,
  /** DELAY_NOTE_ADDED_BY_PERSON - A person typing in the shipment's comment box. */
  DELAY_NOTE_ADDED_BY_PERSON = 1,
  /** DELAY_NOTE_ADDED_BY_AUTOMATION - A workflow, or ZoomLogi itself. */
  DELAY_NOTE_ADDED_BY_AUTOMATION = 2,
  UNRECOGNIZED = -1,
}

export function delayNoteAddedByFromJSON(object: any): DelayNoteAddedBy {
  switch (object) {
    case 0:
    case "DELAY_NOTE_ADDED_BY_ANYONE":
      return DelayNoteAddedBy.DELAY_NOTE_ADDED_BY_ANYONE;
    case 1:
    case "DELAY_NOTE_ADDED_BY_PERSON":
      return DelayNoteAddedBy.DELAY_NOTE_ADDED_BY_PERSON;
    case 2:
    case "DELAY_NOTE_ADDED_BY_AUTOMATION":
      return DelayNoteAddedBy.DELAY_NOTE_ADDED_BY_AUTOMATION;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DelayNoteAddedBy.UNRECOGNIZED;
  }
}

export function delayNoteAddedByToJSON(object: DelayNoteAddedBy): string {
  switch (object) {
    case DelayNoteAddedBy.DELAY_NOTE_ADDED_BY_ANYONE:
      return "DELAY_NOTE_ADDED_BY_ANYONE";
    case DelayNoteAddedBy.DELAY_NOTE_ADDED_BY_PERSON:
      return "DELAY_NOTE_ADDED_BY_PERSON";
    case DelayNoteAddedBy.DELAY_NOTE_ADDED_BY_AUTOMATION:
      return "DELAY_NOTE_ADDED_BY_AUTOMATION";
    case DelayNoteAddedBy.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum DelayNotifyChannel {
  DELAY_NOTIFY_CHANNEL_UNSPECIFIED = 0,
  DELAY_NOTIFY_EMAIL = 1,
  DELAY_NOTIFY_SMS = 2,
  DELAY_NOTIFY_SLACK = 3,
  DELAY_NOTIFY_TEAMS = 4,
  UNRECOGNIZED = -1,
}

export function delayNotifyChannelFromJSON(object: any): DelayNotifyChannel {
  switch (object) {
    case 0:
    case "DELAY_NOTIFY_CHANNEL_UNSPECIFIED":
      return DelayNotifyChannel.DELAY_NOTIFY_CHANNEL_UNSPECIFIED;
    case 1:
    case "DELAY_NOTIFY_EMAIL":
      return DelayNotifyChannel.DELAY_NOTIFY_EMAIL;
    case 2:
    case "DELAY_NOTIFY_SMS":
      return DelayNotifyChannel.DELAY_NOTIFY_SMS;
    case 3:
    case "DELAY_NOTIFY_SLACK":
      return DelayNotifyChannel.DELAY_NOTIFY_SLACK;
    case 4:
    case "DELAY_NOTIFY_TEAMS":
      return DelayNotifyChannel.DELAY_NOTIFY_TEAMS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DelayNotifyChannel.UNRECOGNIZED;
  }
}

export function delayNotifyChannelToJSON(object: DelayNotifyChannel): string {
  switch (object) {
    case DelayNotifyChannel.DELAY_NOTIFY_CHANNEL_UNSPECIFIED:
      return "DELAY_NOTIFY_CHANNEL_UNSPECIFIED";
    case DelayNotifyChannel.DELAY_NOTIFY_EMAIL:
      return "DELAY_NOTIFY_EMAIL";
    case DelayNotifyChannel.DELAY_NOTIFY_SMS:
      return "DELAY_NOTIFY_SMS";
    case DelayNotifyChannel.DELAY_NOTIFY_SLACK:
      return "DELAY_NOTIFY_SLACK";
    case DelayNotifyChannel.DELAY_NOTIFY_TEAMS:
      return "DELAY_NOTIFY_TEAMS";
    case DelayNotifyChannel.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum TimeRangeOp {
  /** WITHIN - now() is within the time range */
  WITHIN = 0,
  /** NOT_WITHIN - now() is NOT within the time range */
  NOT_WITHIN = 1,
  UNRECOGNIZED = -1,
}

export function timeRangeOpFromJSON(object: any): TimeRangeOp {
  switch (object) {
    case 0:
    case "WITHIN":
      return TimeRangeOp.WITHIN;
    case 1:
    case "NOT_WITHIN":
      return TimeRangeOp.NOT_WITHIN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TimeRangeOp.UNRECOGNIZED;
  }
}

export function timeRangeOpToJSON(object: TimeRangeOp): string {
  switch (object) {
    case TimeRangeOp.WITHIN:
      return "WITHIN";
    case TimeRangeOp.NOT_WITHIN:
      return "NOT_WITHIN";
    case TimeRangeOp.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Logical operator for combining multiple condition expressions */
export enum LogicalOp {
  /** AND - All expressions must be true */
  AND = 0,
  /** OR - At least one expression must be true */
  OR = 1,
  UNRECOGNIZED = -1,
}

export function logicalOpFromJSON(object: any): LogicalOp {
  switch (object) {
    case 0:
    case "AND":
      return LogicalOp.AND;
    case 1:
    case "OR":
      return LogicalOp.OR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return LogicalOp.UNRECOGNIZED;
  }
}

export function logicalOpToJSON(object: LogicalOp): string {
  switch (object) {
    case LogicalOp.AND:
      return "AND";
    case LogicalOp.OR:
      return "OR";
    case LogicalOp.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Operator for ComparisonExpr.
 * Numeric values are stable; do not change them — they are stored in serialized workflow protobufs.
 */
export enum ComparisonOp {
  /** COMPARISON_EQUALS - Universal */
  COMPARISON_EQUALS = 0,
  /** COMPARISON_NOT_EQUALS - != */
  COMPARISON_NOT_EQUALS = 1,
  /** COMPARISON_EXISTS - variable exists and is non-empty */
  COMPARISON_EXISTS = 2,
  /** COMPARISON_NOT_EXISTS - variable does not exist or is empty */
  COMPARISON_NOT_EXISTS = 3,
  /** COMPARISON_CONTAINS - Text (STRING) */
  COMPARISON_CONTAINS = 4,
  /** COMPARISON_NOT_CONTAINS - no substring match */
  COMPARISON_NOT_CONTAINS = 5,
  /** COMPARISON_STARTS_WITH - prefix match */
  COMPARISON_STARTS_WITH = 6,
  /** COMPARISON_ENDS_WITH - suffix match */
  COMPARISON_ENDS_WITH = 7,
  /** COMPARISON_IS_EMPTY - "" or null */
  COMPARISON_IS_EMPTY = 14,
  /** COMPARISON_IS_NOT_EMPTY - non-empty string */
  COMPARISON_IS_NOT_EMPTY = 15,
  /** COMPARISON_GREATER_THAN - Numeric (NUMBER) */
  COMPARISON_GREATER_THAN = 8,
  /** COMPARISON_GREATER_THAN_OR_EQUAL - >= */
  COMPARISON_GREATER_THAN_OR_EQUAL = 9,
  /** COMPARISON_LESS_THAN - < */
  COMPARISON_LESS_THAN = 10,
  /** COMPARISON_LESS_THAN_OR_EQUAL - <= */
  COMPARISON_LESS_THAN_OR_EQUAL = 11,
  /** COMPARISON_BETWEEN - rhs <= value <= rhs2 */
  COMPARISON_BETWEEN = 17,
  /** COMPARISON_NOT_BETWEEN - value < rhs or value > rhs2 */
  COMPARISON_NOT_BETWEEN = 18,
  /** COMPARISON_IN_LIST - Enum / list (ALERT_TYPE, STRING with fixed value set) */
  COMPARISON_IN_LIST = 12,
  /** COMPARISON_NOT_IN_LIST - value is not in rhs list */
  COMPARISON_NOT_IN_LIST = 13,
  /** COMPARISON_IS_TRUE - Boolean (BOOL) */
  COMPARISON_IS_TRUE = 19,
  /** COMPARISON_IS_FALSE - value == false (no RHS needed) */
  COMPARISON_IS_FALSE = 20,
  /** COMPARISON_BEFORE - Datetime ordering (DATE_TIME) — single literal RHS */
  COMPARISON_BEFORE = 21,
  /** COMPARISON_ON_OR_BEFORE - value <= rhs */
  COMPARISON_ON_OR_BEFORE = 22,
  /** COMPARISON_AFTER - value > rhs */
  COMPARISON_AFTER = 23,
  /** COMPARISON_ON_OR_AFTER - value >= rhs */
  COMPARISON_ON_OR_AFTER = 24,
  /** COMPARISON_REGEX_MATCHES - Text matching */
  COMPARISON_REGEX_MATCHES = 16,
  UNRECOGNIZED = -1,
}

export function comparisonOpFromJSON(object: any): ComparisonOp {
  switch (object) {
    case 0:
    case "COMPARISON_EQUALS":
      return ComparisonOp.COMPARISON_EQUALS;
    case 1:
    case "COMPARISON_NOT_EQUALS":
      return ComparisonOp.COMPARISON_NOT_EQUALS;
    case 2:
    case "COMPARISON_EXISTS":
      return ComparisonOp.COMPARISON_EXISTS;
    case 3:
    case "COMPARISON_NOT_EXISTS":
      return ComparisonOp.COMPARISON_NOT_EXISTS;
    case 4:
    case "COMPARISON_CONTAINS":
      return ComparisonOp.COMPARISON_CONTAINS;
    case 5:
    case "COMPARISON_NOT_CONTAINS":
      return ComparisonOp.COMPARISON_NOT_CONTAINS;
    case 6:
    case "COMPARISON_STARTS_WITH":
      return ComparisonOp.COMPARISON_STARTS_WITH;
    case 7:
    case "COMPARISON_ENDS_WITH":
      return ComparisonOp.COMPARISON_ENDS_WITH;
    case 14:
    case "COMPARISON_IS_EMPTY":
      return ComparisonOp.COMPARISON_IS_EMPTY;
    case 15:
    case "COMPARISON_IS_NOT_EMPTY":
      return ComparisonOp.COMPARISON_IS_NOT_EMPTY;
    case 8:
    case "COMPARISON_GREATER_THAN":
      return ComparisonOp.COMPARISON_GREATER_THAN;
    case 9:
    case "COMPARISON_GREATER_THAN_OR_EQUAL":
      return ComparisonOp.COMPARISON_GREATER_THAN_OR_EQUAL;
    case 10:
    case "COMPARISON_LESS_THAN":
      return ComparisonOp.COMPARISON_LESS_THAN;
    case 11:
    case "COMPARISON_LESS_THAN_OR_EQUAL":
      return ComparisonOp.COMPARISON_LESS_THAN_OR_EQUAL;
    case 17:
    case "COMPARISON_BETWEEN":
      return ComparisonOp.COMPARISON_BETWEEN;
    case 18:
    case "COMPARISON_NOT_BETWEEN":
      return ComparisonOp.COMPARISON_NOT_BETWEEN;
    case 12:
    case "COMPARISON_IN_LIST":
      return ComparisonOp.COMPARISON_IN_LIST;
    case 13:
    case "COMPARISON_NOT_IN_LIST":
      return ComparisonOp.COMPARISON_NOT_IN_LIST;
    case 19:
    case "COMPARISON_IS_TRUE":
      return ComparisonOp.COMPARISON_IS_TRUE;
    case 20:
    case "COMPARISON_IS_FALSE":
      return ComparisonOp.COMPARISON_IS_FALSE;
    case 21:
    case "COMPARISON_BEFORE":
      return ComparisonOp.COMPARISON_BEFORE;
    case 22:
    case "COMPARISON_ON_OR_BEFORE":
      return ComparisonOp.COMPARISON_ON_OR_BEFORE;
    case 23:
    case "COMPARISON_AFTER":
      return ComparisonOp.COMPARISON_AFTER;
    case 24:
    case "COMPARISON_ON_OR_AFTER":
      return ComparisonOp.COMPARISON_ON_OR_AFTER;
    case 16:
    case "COMPARISON_REGEX_MATCHES":
      return ComparisonOp.COMPARISON_REGEX_MATCHES;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ComparisonOp.UNRECOGNIZED;
  }
}

export function comparisonOpToJSON(object: ComparisonOp): string {
  switch (object) {
    case ComparisonOp.COMPARISON_EQUALS:
      return "COMPARISON_EQUALS";
    case ComparisonOp.COMPARISON_NOT_EQUALS:
      return "COMPARISON_NOT_EQUALS";
    case ComparisonOp.COMPARISON_EXISTS:
      return "COMPARISON_EXISTS";
    case ComparisonOp.COMPARISON_NOT_EXISTS:
      return "COMPARISON_NOT_EXISTS";
    case ComparisonOp.COMPARISON_CONTAINS:
      return "COMPARISON_CONTAINS";
    case ComparisonOp.COMPARISON_NOT_CONTAINS:
      return "COMPARISON_NOT_CONTAINS";
    case ComparisonOp.COMPARISON_STARTS_WITH:
      return "COMPARISON_STARTS_WITH";
    case ComparisonOp.COMPARISON_ENDS_WITH:
      return "COMPARISON_ENDS_WITH";
    case ComparisonOp.COMPARISON_IS_EMPTY:
      return "COMPARISON_IS_EMPTY";
    case ComparisonOp.COMPARISON_IS_NOT_EMPTY:
      return "COMPARISON_IS_NOT_EMPTY";
    case ComparisonOp.COMPARISON_GREATER_THAN:
      return "COMPARISON_GREATER_THAN";
    case ComparisonOp.COMPARISON_GREATER_THAN_OR_EQUAL:
      return "COMPARISON_GREATER_THAN_OR_EQUAL";
    case ComparisonOp.COMPARISON_LESS_THAN:
      return "COMPARISON_LESS_THAN";
    case ComparisonOp.COMPARISON_LESS_THAN_OR_EQUAL:
      return "COMPARISON_LESS_THAN_OR_EQUAL";
    case ComparisonOp.COMPARISON_BETWEEN:
      return "COMPARISON_BETWEEN";
    case ComparisonOp.COMPARISON_NOT_BETWEEN:
      return "COMPARISON_NOT_BETWEEN";
    case ComparisonOp.COMPARISON_IN_LIST:
      return "COMPARISON_IN_LIST";
    case ComparisonOp.COMPARISON_NOT_IN_LIST:
      return "COMPARISON_NOT_IN_LIST";
    case ComparisonOp.COMPARISON_IS_TRUE:
      return "COMPARISON_IS_TRUE";
    case ComparisonOp.COMPARISON_IS_FALSE:
      return "COMPARISON_IS_FALSE";
    case ComparisonOp.COMPARISON_BEFORE:
      return "COMPARISON_BEFORE";
    case ComparisonOp.COMPARISON_ON_OR_BEFORE:
      return "COMPARISON_ON_OR_BEFORE";
    case ComparisonOp.COMPARISON_AFTER:
      return "COMPARISON_AFTER";
    case ComparisonOp.COMPARISON_ON_OR_AFTER:
      return "COMPARISON_ON_OR_AFTER";
    case ComparisonOp.COMPARISON_REGEX_MATCHES:
      return "COMPARISON_REGEX_MATCHES";
    case ComparisonOp.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum TransferToEscalationOption {
  TRANSFER_TO_ESCALATION_OPTION_UNSPECIFIED = 0,
  TRY_SECOND_NUMBER = 1,
  CONNECT_TO_AGENT = 2,
  UNRECOGNIZED = -1,
}

export function transferToEscalationOptionFromJSON(object: any): TransferToEscalationOption {
  switch (object) {
    case 0:
    case "TRANSFER_TO_ESCALATION_OPTION_UNSPECIFIED":
      return TransferToEscalationOption.TRANSFER_TO_ESCALATION_OPTION_UNSPECIFIED;
    case 1:
    case "TRY_SECOND_NUMBER":
      return TransferToEscalationOption.TRY_SECOND_NUMBER;
    case 2:
    case "CONNECT_TO_AGENT":
      return TransferToEscalationOption.CONNECT_TO_AGENT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TransferToEscalationOption.UNRECOGNIZED;
  }
}

export function transferToEscalationOptionToJSON(object: TransferToEscalationOption): string {
  switch (object) {
    case TransferToEscalationOption.TRANSFER_TO_ESCALATION_OPTION_UNSPECIFIED:
      return "TRANSFER_TO_ESCALATION_OPTION_UNSPECIFIED";
    case TransferToEscalationOption.TRY_SECOND_NUMBER:
      return "TRY_SECOND_NUMBER";
    case TransferToEscalationOption.CONNECT_TO_AGENT:
      return "CONNECT_TO_AGENT";
    case TransferToEscalationOption.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * LBWorkflow is the top-level container for workflows.
 * It contains a list of graphs: graphs[0] is the root graph, graphs[1..n] are
 * subgraphs (e.g., loop body graphs referenced by ParallelLoopData.subgraph_index).
 */
export interface LBWorkflow {
  graphs: LBGraph[];
}

/**
 * A single Logiblock graph.
 * (A workflow can contain multiple graphs: one root graph and
 * zero or more subgraphs for loop bodies.)
 */
export interface LBGraph {
  nodes: LBNode[];
  edges: LBEdge[];
}

/**
 * A single node in the Logiblock graph.
 * IDs are UUIDs (e.g., "a3f9d8e1-4b2c-4a1d-8f3e-9c7b6a5d4e3f")
 */
export interface LBNode {
  id: string;
  data: LBNodeData | undefined;
}

/**
 * Configuration and state for a LBNode.
 * The type-specific node data lives in the `data` oneof; `custom_display_name`
 * is a per-node label override that applies to all node types.
 */
export interface LBNodeData {
  /**
   * User-provided display name shown on the canvas in place of the
   * node type's default label. Unset means no custom name.
   */
  custom_display_name?:
    | string
    | undefined;
  /**
   * Per-node-instance variable declarations the workflow author has added.
   * Merged with the node type's static outputs to produce the node's full
   * published variable set.
   */
  user_variables: VariableDesc[];
  alert_trigger?: AlertTriggerData | undefined;
  schedule_trigger?: ScheduleTriggerData | undefined;
  ai_call_action?: AICallActionData | undefined;
  slack_action?: SlackActionData | undefined;
  email_action?: EmailActionData | undefined;
  sms_action?: SmsActionData | undefined;
  resolve_alert_action?: ResolveAlertActionData | undefined;
  generate_transcript_action?: GenerateTranscriptActionData | undefined;
  call_webhook_action?: CallWebhookActionData | undefined;
  paths?: PathsData | undefined;
  delay_action?: DelayActionData | undefined;
  deprecated_filtered_shipments_loop?: Deprecated_FilteredShipmentsLoopData | undefined;
  inbound_event_trigger?: InboundEventTriggerData | undefined;
  add_coc_note_action?: AddCocNoteActionData | undefined;
  alert_status_check?: AlertStatusCheckData | undefined;
  eta_change_trigger?: ETAChangeTriggerData | undefined;
  location_trigger?: LocationTriggerData | undefined;
  status_progress_trigger?: StatusProgressTriggerData | undefined;
  manual_execution_trigger?: ManualExecutionTriggerData | undefined;
  inbound_trigger?: InboundTriggerData | undefined;
  schedule_trigger_v2?: ScheduleTriggerV2Data | undefined;
  filter_control_flow?: FilterControlFlowData | undefined;
  conditional?: ConditionalData | undefined;
  inbound_call_trigger?: InboundCallTriggerData | undefined;
  teams_notification?: TeamsNotificationData | undefined;
  transfer_to_action?: TransferToActionData | undefined;
  alert_action_taken_trigger?: AlertActionTakenTriggerData | undefined;
  snooze_action?: SnoozeActionData | undefined;
  wait_for_reply?: WaitForReplyData | undefined;
  back_to_delay?: BackToDelayData | undefined;
}

/** Trigger data types */
export interface AlertTriggerData {
  /** Selected alert types (empty = all alert types) */
  alert_types: string[];
  /** Selected courier IDs (empty = all couriers) */
  courier_ids: string[];
  /** Selected team IDs (empty = all teams) */
  team_ids: string[];
  /** Selected origin location IDs (empty = all origins) */
  origin_ids: string[];
  /** Selected destination location IDs (empty = all destinations) */
  destination_ids: string[];
  /** Selected product IDs (empty = all products) */
  product_ids: string[];
  /** True when all filter dimensions are selected */
  select_all: boolean;
  /** True when all teams are selected */
  select_all_teams: boolean;
  /** True when all origins are selected */
  select_all_origins: boolean;
  /** True when all products are selected */
  select_all_products: boolean;
  /** True when all transport providers are selected */
  select_all_transport_providers: boolean;
  /** True when all destinations are selected */
  select_all_destinations: boolean;
  /** True when all alert types are selected */
  select_all_alert_types: boolean;
}

export interface AlertActionTakenTriggerData {
  /** Selected alert types (empty = all alert types) */
  alert_types: string[];
  /** Selected courier IDs (empty = all couriers) */
  courier_ids: string[];
  /** Selected team IDs (empty = all teams) */
  team_ids: string[];
  /** Selected origin location IDs (empty = all origins) */
  origin_ids: string[];
  /** Selected destination location IDs (empty = all destinations) */
  destination_ids: string[];
  /** Selected product IDs (empty = all products) */
  product_ids: string[];
  /** True when all filter dimensions are selected */
  select_all: boolean;
  /** True when all teams are selected */
  select_all_teams: boolean;
  /** True when all origins are selected */
  select_all_origins: boolean;
  /** True when all products are selected */
  select_all_products: boolean;
  /** True when all transport providers are selected */
  select_all_transport_providers: boolean;
  /** True when all destinations are selected */
  select_all_destinations: boolean;
  /** True when all alert types are selected */
  select_all_alert_types: boolean;
  action_taken: ActionTaken[];
  /** True when "All actions" is selected */
  select_all_action_taken: boolean;
  /**
   * CompanyAlertTag ids: run only when the action was taken with one of these tags
   * (an assignment's tag, or a manual resolve/dismiss close tag). Empty = any tag or none.
   */
  tag_ids: string[];
}

/**
 * Trigger data for ETA change events.
 * Fires when a shipment's ETA changes by more than the specified threshold.
 */
export interface ETAChangeTriggerData {
  /** ETA change threshold (e.g., "15 minutes", "1 hour") */
  change_by: string;
  /** Selected courier IDs (empty = all couriers) */
  courier_ids: string[];
  /** Selected team IDs (empty = all teams) */
  team_ids: string[];
  /** Selected origin location IDs (empty = all origins) */
  origin_ids: string[];
  /** Selected destination location IDs (empty = all destinations) */
  destination_ids: string[];
  /** Selected product IDs (empty = all products) */
  product_ids: string[];
  /** True when all filter dimensions are selected */
  select_all: boolean;
  /** True when all teams are selected */
  select_all_teams: boolean;
  /** True when all origins are selected */
  select_all_origins: boolean;
  /** True when all products are selected */
  select_all_products: boolean;
  /** True when all transport providers are selected */
  select_all_transport_providers: boolean;
  /** True when all destinations are selected */
  select_all_destinations: boolean;
  /** Optional ETA movement filter: "later", "earlier", or empty for either */
  direction: string;
}

/**
 * Trigger data for location arrival events.
 * Fires when a shipment arrives at the specified location.
 */
export interface LocationTriggerData {
  /** Selected location ID */
  location: string;
  /** Selected courier IDs (empty = all couriers) */
  courier_ids: string[];
  /** Selected team IDs (empty = all teams) */
  team_ids: string[];
  /** Selected origin location IDs (empty = all origins) */
  origin_ids: string[];
  /** Selected destination location IDs (empty = all destinations) */
  destination_ids: string[];
  /** Selected product IDs (empty = all products) */
  product_ids: string[];
  /** True when all filter dimensions are selected */
  select_all: boolean;
  /** True when all teams are selected */
  select_all_teams: boolean;
  /** True when all origins are selected */
  select_all_origins: boolean;
  /** True when all products are selected */
  select_all_products: boolean;
  /** True when all transport providers are selected */
  select_all_transport_providers: boolean;
  /** True when all destinations are selected */
  select_all_destinations: boolean;
}

/**
 * Trigger data for shipment status progress events.
 * Fires when a shipment reaches one of the selected status milestones.
 */
export interface StatusProgressTriggerData {
  /** Fire when a shipment is picked up */
  is_pickup_confirmation: boolean;
  /** Fire when a shipment is delivered */
  is_delivery_confirmation: boolean;
  /** Fire when a delivery exception occurs */
  is_delivery_exception: boolean;
  /** Fire when a shipment is created */
  is_created: boolean;
  /** Fire when a shipment is out for delivery */
  is_out_for_delivery: boolean;
  /** Selected courier IDs (empty = all couriers) */
  courier_ids: string[];
  /** Selected team IDs (empty = all teams) */
  team_ids: string[];
  /** Selected origin location IDs (empty = all origins) */
  origin_ids: string[];
  /** Selected destination location IDs (empty = all destinations) */
  destination_ids: string[];
  /** Selected product IDs (empty = all products) */
  product_ids: string[];
  /** True when all filter dimensions are selected */
  select_all: boolean;
  /** True when all teams are selected */
  select_all_teams: boolean;
  /** True when all origins are selected */
  select_all_origins: boolean;
  /** True when all products are selected */
  select_all_products: boolean;
  /** True when all transport providers are selected */
  select_all_transport_providers: boolean;
  /** True when all destinations are selected */
  select_all_destinations: boolean;
  /** Fire when a shipment is incomplete */
  is_incomplete: boolean;
}

/**
 * Trigger data for inbound call events.
 *
 * Fires when an inbound phone call is received for a shipment that matches
 * the optional courier/team/origin/destination filters.
 * Empty filter list = match all shipments (same semantics as AlertTriggerData).
 */
export interface InboundEventTriggerData {
  /** Selected courier IDs (empty = all couriers) */
  courier_ids: string[];
  /** Selected team IDs (empty = all teams) */
  team_ids: string[];
  /** Selected origin location IDs (empty = all origins) */
  origin_ids: string[];
  /** Selected destination location IDs (empty = all destinations) */
  destination_ids: string[];
}

/**
 * Trigger data for inbound events (updated version of InboundEventTriggerData).
 *
 * Fires when an inbound event of the specified type occurs.
 */
export interface InboundTriggerData {
  /** "call" | "email" | "sms" | "tracking_link" */
  inbound_event_type: string;
  /** E.164 phone number; only used when inbound_event_type = "call" */
  phone_number: string;
  /** "address_update" | "delivery_time_update"; only used when inbound_event_type = "tracking_link" */
  tracking_link_types: string[];
}

/**
 * Trigger data for the "Inbound Call" trigger node.
 * Fires when Retell's pre-call webhook hits /register-call for the given phone number.
 */
export interface InboundCallTriggerData {
  /** E.164 phone number this workflow is bound to */
  phone_number: string;
}

export interface DailySchedule {
  /** 0-23, UTC */
  hour: number;
  /** 0-59 */
  minute: number;
}

export interface DaysOfWeekSchedule {
  days_of_week: DayOfWeek[];
  /** 0-23, UTC */
  hour: number;
  /** 0-59 */
  minute: number;
}

export interface ScheduleTriggerData {
  /** Run every day at a given time */
  daily?:
    | DailySchedule
    | undefined;
  /**
   * Run on 1 or more days of the week at a given time.
   * (A DaysOfWeekSchedule with all 7 days selected is
   * functionally equivalent to a DailySchedule, but we use
   * different UI for each, so we keep them separate.)
   */
  days_of_week?: DaysOfWeekSchedule | undefined;
}

/** A time of day in 24-hour form, local to a schedule's timezone. */
export interface TimeOfDay {
  /** 0-23 */
  hour: number;
  /** 0-59 */
  minute: number;
}

/**
 * Trigger that fires on a configurable repeating schedule.
 * Supports daily, weekly, and monthly recurrence with one or more run times per period.
 */
export interface ScheduleTriggerV2Data {
  /** How many units between each run (e.g., 2 for "every 2 weeks") */
  repeat_interval: number;
  /** Recurrence unit: day, week, or month */
  repeat_every: RepeatUnit;
  /** For weekly recurrence: which days to run on */
  days_of_week: DayOfWeek[];
  /** For monthly recurrence: which days of month to run on */
  days_of_month: number[];
  /** One or more times of day to run, local to `timezone` */
  schedule_times: TimeOfDay[];
  /** IANA timezone the schedule_times are expressed in (e.g., "America/New_York") */
  timezone: string;
}

export interface AICallActionData {
  channel_type: AIChannelType;
  agent_type: AIAgentType;
  agent_id: string;
  contact_id: string;
  /** PCA variable names (snake_case) that this agent collects, for downstream variable access */
  pca_variable_names: string[];
  is_inbound_agent: boolean;
  collect_shipment_id: boolean;
  /**
   * Marks a node auto-materialized beneath a Transfer To node's "connect to
   * an agent" fallback. The agent is delivered mid-call via register-call, so
   * this node self-skips at execution time (see AICallActionNode.execute).
   */
  is_transfer_escalation: boolean;
  /**
   * How long an email waits for a reply before the run continues with
   * "Issue Resolved" false. 0 keeps the default of one hour. Calls ignore it:
   * their result arrives when the call ends.
   */
  reply_wait_seconds: number;
  /**
   * Email with a custom agent only: send the email and continue at once instead
   * of waiting for a reply. A later Wait for reply step can pick the reply up.
   */
  dont_wait: boolean;
}

export interface SlackActionData {
  /** The message as a list of parts. */
  message_chunks: TextTemplateChunk[];
  /**
   * Teams that we want to send the Slack message to.
   * (A team must have its Slack webhook configured to get a message)
   */
  recipient_team_ids: string[];
}

export interface TeamsNotificationData {
  /** The message as a list of parts. */
  message_chunks: TextTemplateChunk[];
  /**
   * Teams (CompanyTeams) that we want to send the Microsoft Teams message to.
   * (A team must have its Teams webhook configured to get a message)
   */
  recipient_team_ids: string[];
  frequency?: string | undefined;
  day?: string | undefined;
  time1?: string | undefined;
  time2?: string | undefined;
}

export interface EmailActionData {
  /** Recipients for the "to", "CC", and "BCC" email fields */
  to: TeamNotifRecipients[];
  cc: TeamNotifRecipients[];
  bcc: TeamNotifRecipients[];
  /** The subject as a list of parts. */
  subject_chunks: TextTemplateChunk[];
  /** The body as a list of parts. */
  body_chunks: TextTemplateChunk[];
  send_mode?: string | undefined;
}

export interface TeamNotifRecipients {
  team_id: string;
  /**
   * If true, send to ALL members of the given team.
   * Otherwise, send to the specified userIds.
   * (If select_all is set, user_ids should be empty.)
   */
  select_all: boolean;
  user_ids: string[];
  /** Additional contact IDs (e.g. origin/destination primary contacts) */
  additional_recipients: string[];
  /** If true, this entry represents additional contacts only (not a team selection) */
  is_additional?: boolean | undefined;
}

export interface SmsActionData {
  /** Kept in schema but hidden in UI */
  phone: string;
  /** The message as a list of parts. */
  message_chunks: TextTemplateChunk[];
  contact_id: string;
  wait_for_response: boolean;
  update_coc: boolean;
}

export interface ResolveAlertActionData {
  /** Alert resolution status: 'resolved' or 'dismissed' */
  alert_status: string;
  /** The comment as a list of parts. */
  comment_chunks: TextTemplateChunk[];
  /** Selected alert types to resolve/dismiss */
  alert_types: string[];
  /** Whether to select all alert types */
  select_all_alert_types: boolean;
  /** Reference to the shipment_id variable from a trigger or loop node. */
  shipment_id: VariableRef | undefined;
}

/** Paths node: parent for ConditionalNodes */
export interface PathsData {
}

export interface GenerateTranscriptActionData {
}

/**
 * A single user-defined header on a Call Webhook request. Injected
 * authentication (from `credential_id`) is never stored as a header here --
 * it's applied at execute time, so it never appears in a saved workflow.
 */
export interface WebhookHeader {
  key: string;
  /** The value as a list of parts. */
  value_chunks: TextTemplateChunk[];
}

/**
 * Exponential backoff between Call Webhook attempts. The frontend's retry
 * dropdown only offers 4 preset options (see callWebhookAction/defaults.ts),
 * but the shape here is a full backoff policy so a later UI can expose
 * tuning without another proto migration.
 */
export interface RetryPolicy {
  /** total attempts including the first; 1 = no retries */
  max_attempts: number;
  /** delay before the 2nd attempt */
  initial_backoff_seconds: number;
  /** growth factor applied per subsequent attempt */
  backoff_multiplier: number;
  /** cap on any single inter-attempt delay */
  max_backoff_seconds: number;
}

export interface CallWebhookActionData {
  /** "GET"|"POST"|"PUT"|"PATCH", validated in code */
  method: string;
  /** user-defined only */
  headers: WebhookHeader[];
  /** defaults to "application/json" when empty */
  content_type: string;
  /**
   * customer_credentials.Credential.id (UUID string). Empty means no
   * authentication. The referenced Credential already knows its own
   * auth_type, so there is no separate auth-type enum on this node.
   */
  credential_id: string;
  retry_policy: RetryPolicy | undefined;
  on_failure: WebhookFailureAction;
  /**
   * Only meaningful when on_failure is WEBHOOK_FAILURE_NOTIFY; ignored
   * otherwise. Defaults to in-app.
   */
  notify_channel: WebhookNotifyChannel;
  /** The URL and body as lists of parts. The URL must use HTTPS. */
  url_chunks: TextTemplateChunk[];
  body_chunks: TextTemplateChunk[];
}

export interface AddCocNoteActionData {
  /** Reference to the shipment_id variable from a trigger or loop node. */
  shipment_id:
    | VariableRef
    | undefined;
  /** The message as a list of parts. */
  message_chunks: TextTemplateChunk[];
  /** Target audience type (e.g. 'public', 'my_team', 'specific_teams') */
  audience?:
    | string
    | undefined;
  /** List of selected team IDs if audience is 'specific_teams' (optional/repeated) */
  team_ids: string[];
  /** User IDs mentioned in message_chunks, chosen at workflow-authoring time. */
  mentioned_user_ids: string[];
  /**
   * When true and the workflow was triggered by an alert, the note nests under
   * that alert in the shipment timeline instead of appearing as its own entry.
   * Ignored when no alert is in the workflow's context.
   */
  append_to_alert: boolean;
}

/**
 * Alert status check - queries current status of an alert from execution context
 * Outputs: alert_status variable ("resolved", "dismissed", or "active")
 */
export interface AlertStatusCheckData {
}

/** Delay action - suspends workflow execution for a specified duration */
export interface DelayActionData {
  duration?: DelayDuration | undefined;
  until_time?: DelayUntilTime | undefined;
  until_day?: DelayUntilDay | undefined;
  until_event?: DelayUntilEvent | undefined;
  until_location_open?: DelayUntilLocationOpen | undefined;
}

/**
 * Wait for reply - continues as soon as an earlier "Don't wait" AI email in the run
 * gets a reply or an earlier AI call was answered, or when the wait runs out.
 */
export interface WaitForReplyData {
  /**
   * How long to wait for a reply, in seconds. The editor shows it in the largest whole
   * unit (seconds, minutes or hours).
   */
  wait_seconds: number;
}

/**
 * Back to delay - ends its branch and sends the run back to an earlier Delay until event, which
 * waits again for the same events. It has no outgoing connection, so the workflow stays acyclic.
 */
export interface BackToDelayData {
  /** The id of the Delay until event node to return to. It must be an ancestor of this node. */
  return_to_node_id: string;
}

/**
 * Wait until the location is open, by its operating hours. Continues at once when it is
 * open, has no hours set, can't be found, or doesn't open within a year.
 */
export interface DelayUntilLocationOpen {
  target: LocationTarget;
}

/**
 * Snooze action - stops the alert that triggered the run from re-firing for a period of time,
 * for as long as configured. Reuses the Delay action's duration and until-time messages.
 */
export interface SnoozeActionData {
  duration?: DelayDuration | undefined;
  until_time?: DelayUntilTime | undefined;
}

export interface DelayDuration {
  /** Total seconds to delay */
  seconds: number;
  /** Unit for frontend display (MINUTES or HOURS) */
  display_unit: IntervalUnit;
}

export interface DelayUntilTime {
  /** Time of day in UTC, as seconds since midnight (0-86399). Unset until the user picks a time. */
  seconds_since_midnight?: number | undefined;
}

export interface DelayUntilDay {
  /**
   * One or more days-of-the-week.
   * The workflow will resume at the given time on the next day from this list.
   */
  days_of_week: DayOfWeek[];
  /** Time of day in UTC, as seconds since midnight (0-86399). Unset until the user picks a time. */
  seconds_since_midnight?: number | undefined;
}

/**
 * "Delay until event": the run pauses until any one of the events below happens, or the deadline
 * passes, then continues. See the Delay node's authoring definition for what is wired up.
 */
export interface DelayUntilEvent {
  /** One entry per event card in the editor. The same kind of event may appear more than once. */
  events: DelayWaitEvent[];
  /**
   * Stop waiting after this long: a whole number of minutes or hours, from 5 minutes to 30 days.
   * Publishing requires it. A node saved without one still runs and waits the 30 day maximum.
   */
  stop_waiting_after?:
    | DelayDuration
    | undefined;
  /** What to do when the deadline passes and none of the events happened. */
  if_nothing_happens: DelayIfNothingHappens | undefined;
}

/** One event the run waits for, with that event's own settings. */
export interface DelayWaitEvent {
  /**
   * Stable id of this card. It survives reordering and deleting other cards, so other nodes can
   * refer to one specific event.
   */
  id: string;
  alert_triggered?: DelayAlertTriggeredEvent | undefined;
  alert_action_taken?: DelayAlertActionTakenEvent | undefined;
  status_progress_update?: DelayStatusProgressEvent | undefined;
  reply_received?: DelayReplyReceivedEvent | undefined;
  document_added?: DelayDocumentAddedEvent | undefined;
  note_added?:
    | DelayNoteAddedEvent
    | undefined;
  /** Later changes add: webhook_received = 9. */
  snooze_ended?: DelaySnoozeEndedEvent | undefined;
}

/** Which alerts count. Alert types are the same strings the Alert trigger stores. */
export interface DelayAlertFilter {
  alert_types: string[];
  /** True when every alert type counts. alert_types is then empty. */
  select_all_alert_types: boolean;
}

/** Continue when a selected alert is triggered on this shipment. */
export interface DelayAlertTriggeredEvent {
  alerts: DelayAlertFilter | undefined;
}

/** Continue when a selected alert is acted on by a person or an AI agent, or assigned. */
export interface DelayAlertActionTakenEvent {
  alerts: DelayAlertFilter | undefined;
  action_taken: ActionTaken[];
  /** True for "Any action". action_taken is then empty. */
  select_all_action_taken: boolean;
}

/** Continue when the shipment reaches one of these statuses. */
export interface DelayStatusProgressEvent {
  statuses: DelayStatusMilestone[];
}

/** Continue when someone replies to a message sent earlier in this run. */
export interface DelayReplyReceivedEvent {
  /**
   * Ids of earlier communication nodes in this run whose messages to listen for. Empty means any
   * reply on the shipment (the first version does not narrow further).
   */
  source_node_ids: string[];
}

/**
 * Continue when a document is added: a file from Upload file, from a shipment comment or from an
 * alert's reply box. A file attached when assigning an alert, or to an outgoing email reply, does
 * not count.
 */
export interface DelayDocumentAddedEvent {
  where: DelayEventWhere;
}

/**
 * Continue when a note is added to this shipment's chain of custody: a note from the shipment's
 * comment box, a note an automation appended to an alert, or a reply in an alert's reply box
 * (which counts as a note written by a person).
 */
export interface DelayNoteAddedEvent {
  added_by: DelayNoteAddedBy;
  where: DelayEventWhere;
}

/**
 * Continue when the alert that started this run is no longer snoozed. A run whose alert is not
 * snoozed when the Delay starts continues at once. The first version has no settings.
 */
export interface DelaySnoozeEndedEvent {
}

export interface DelayIfNothingHappens {
  end_run: boolean;
  notify_automation_owner: boolean;
  /** Unset when "Notify someone else" is not chosen. */
  notify_others: DelayNotifyOthers | undefined;
}

export interface DelayNotifyOthers {
  channels: DelayNotifyChannel[];
  recipients: TeamNotifRecipients[];
}

/** Reference to a variable from a node's output */
export interface VariableRef {
  /** NodeId that produced the variable */
  node_id: string;
  /** Name of the variable */
  variable_name: string;
  /**
   * Field read off the variable named above, as in the "status" of
   * shipment_id.status. Empty when variable_name names the value itself.
   */
  derived_variable_name: string;
  /**
   * Who declared the variable named above. A lookup reads the node type's
   * outputs for SOURCE_NODE_TYPE, the author's for SOURCE_USER, and the runtime
   * for SOURCE_SYSTEM. Copied from the published variable the author picked,
   * never inferred later.
   */
  source: VariableSource;
}

/**
 * A person @-mentioned in a message, by user id. The label is what the author
 * saw when they picked the person, and is what renders.
 */
export interface UserMention {
  user_id: string;
  label: string;
}

/** One part of a text template. A template is a list of these, in order. */
export interface TextTemplateChunk {
  text?: string | undefined;
  variable?: VariableRef | undefined;
  user_mention?: UserMention | undefined;
}

/** Ordered list of values used as the RHS for IN_LIST / NOT_IN_LIST operators. */
export interface RhsValueList {
  items: VariableValue[];
}

/**
 * Shared RHS shape for BoolExprs: a typed literal, a variable reference,
 * or a list of literals for IN_LIST / NOT_IN_LIST.
 */
export interface RhsValue {
  /** Typed literal RHS */
  literal?:
    | VariableValue
    | undefined;
  /** Variable reference RHS */
  variable?:
    | VariableRef
    | undefined;
  /** List of literals for IN_LIST / NOT_IN_LIST */
  list?: RhsValueList | undefined;
}

/**
 * A value comparison: `variable operator rhs`.
 * EXISTS / NOT_EXISTS / IS_TRUE / IS_FALSE / IS_EMPTY / IS_NOT_EMPTY ignore the RHS.
 * BETWEEN / NOT_BETWEEN use both rhs (lower bound) and rhs2 (upper bound).
 * IN_LIST / NOT_IN_LIST use rhs.list.
 */
export interface ComparisonExpr {
  /** LHS variable reference */
  variable: VariableRef | undefined;
  operator: ComparisonOp;
  rhs:
    | RhsValue
    | undefined;
  /** upper bound for BETWEEN / NOT_BETWEEN */
  rhs2: RhsValue | undefined;
}

/**
 * "variable falls inside this recurring weekly window".
 * Time-of-day and day-of-week are interpreted in the LHS variable's own
 * IANA zone, so a window like "Mon-Fri 9-5" matches local business hours
 * regardless of where the variable was produced.
 */
export interface RecurringWindowExpr {
  /** LHS DATE_TIME variable */
  variable:
    | VariableRef
    | undefined;
  /** seconds since midnight, in the LHS's zone; unset = no time-of-day filter */
  start_seconds?:
    | number
    | undefined;
  /** seconds since midnight, in the LHS's zone; unset = no time-of-day filter */
  end_seconds?:
    | number
    | undefined;
  /** empty = every day */
  days_of_week: DayOfWeek[];
  /** WITHIN / NOT_WITHIN */
  operator: TimeRangeOp;
}

/**
 * A time-of-day window for one SpecificDateEntry / DayOfWeekEntry.
 * all_day = true means no time filter for this entry (start/end unset).
 */
export interface TimeOfDayRange {
  all_day: boolean;
  /** seconds since midnight; ignored when all_day */
  start_seconds?:
    | number
    | undefined;
  /** seconds since midnight; ignored when all_day */
  end_seconds?: number | undefined;
}

/**
 * One specific calendar date with its own optional time range. `date` is a
 * civil ("YYYY-MM-DD") date with no zone baked in — DateTimeSetExpr.iana_timezone
 * says how to interpret it.
 */
export interface SpecificDateEntry {
  date: string;
  time_range: TimeOfDayRange | undefined;
}

export interface SpecificDateSet {
  dates: SpecificDateEntry[];
}

/** One day-of-week with its own optional time range. */
export interface DayOfWeekEntry {
  day: DayOfWeek;
  time_range: TimeOfDayRange | undefined;
}

export interface DayOfWeekSet {
  days: DayOfWeekEntry[];
}

/**
 * "variable falls inside this set of dates/days". Replacement for
 * RecurringWindowExpr going forward — RecurringWindowExpr is kept for
 * existing saved workflows and is never written by new code.
 *
 * Exactly one `source` is populated:
 *   specific_dates   — an ad-hoc, inline set of dates, each with its own range
 *   days_of_week     — an ad-hoc, inline set of days, each with its own range
 *   system_preset_id — a built-in preset ("weekends", "weekdays_7to6",
 *                      "us_federal_holidays", "us_bank_holidays"), resolved
 *                      live at evaluation time — never materialized here
 *   saved_list_id    — a LogiblocksSavedDateList row (by id), resolved live
 *                      at evaluation time so edits to the list propagate
 *
 * iana_timezone is the explicit zone dates/times are evaluated in. For the
 * two holiday presets, evaluation ignores this field and always uses the
 * company's default timezone instead (see conditional_node.py).
 */
export interface DateTimeSetExpr {
  variable: VariableRef | undefined;
  iana_timezone: string;
  operator: TimeRangeOp;
  specific_dates?: SpecificDateSet | undefined;
  days_of_week?: DayOfWeekSet | undefined;
  system_preset_id?: string | undefined;
  saved_list_id?:
    | string
    | undefined;
  /**
   * Denormalized display name for system_preset_id / saved_list_id, set by
   * the frontend at save time so the canvas subtitle and the RHS field's own
   * collapsed display never need a network call to render. Never
   * authoritative -- the editor and the evaluator both resolve the current
   * name live; this is display-only and may be stale after a saved list is
   * renamed (refreshed next time the condition is saved).
   */
  display_label: string;
}

/**
 * One node in a boolean expression tree: a leaf comparison/datetime
 * expression, or a nested BoolExprGroup.
 */
export interface BoolExpr {
  comparison_expr?: ComparisonExpr | undefined;
  recurring_window_expr?: RecurringWindowExpr | undefined;
  group?: BoolExprGroup | undefined;
  date_time_set_expr?: DateTimeSetExpr | undefined;
}

/**
 * A group of boolean expressions combined by per-pair logical operators.
 * `operators[i]` is the connective between `expressions[i]` and
 * `expressions[i+1]`, so a well-formed group has
 * `len(operators) == len(expressions) - 1`. AND binds tighter than OR
 * (standard precedence), so `a AND b OR c AND d` evaluates as
 * `(a AND b) OR (c AND d)`.
 */
export interface BoolExprGroup {
  expressions: BoolExpr[];
  operators: LogicalOp[];
}

/**
 * Conditional node data. Wraps a single root group; that root group can
 * contain leaf expressions and/or nested groups to any depth.
 */
export interface ConditionalData {
  root: BoolExprGroup | undefined;
}

/** LBEdge represents a connection between two nodes */
export interface LBEdge {
  /** Unique edge ID */
  id: string;
  /** Source node ID */
  source: string;
  /** Target node ID */
  target: string;
  /** Order for MULTIPLE output type edges (0-indexed, left-to-right) */
  edge_order?:
    | number
    | undefined;
  /** (Currently unused. TODO: remove?) */
  source_handle?:
    | string
    | undefined;
  /** Target connection point (for multiple inputs) */
  target_handle?: string | undefined;
}

/**
 * Deprecated. Use FilterControlFlowData instead. Existing workflows still
 * deserialise via this message (tag 14); new workflows cannot be authored on it.
 */
export interface Deprecated_FilteredShipmentsLoopData {
  /** Index of our loop subgraph in the workflow.graphs list. */
  subgraph_index: number;
  /**
   * Selected shipment status IDs to filter by.
   * If length==0, don't filter by status.
   */
  status_ids: string[];
  /**
   * Selected origin location IDs to filter by.
   * If length==0, don't filter by origin.
   */
  origin_location_ids: string[];
  /**
   * Selected destination location IDs to filter by.
   * If length==0, don't filter by destination.
   */
  destination_location_ids: string[];
}

export interface ManualExecutionTriggerData {
  /** External trigger type (e.g., "manual", "slack", "teams") */
  external_trigger: string;
  /** Keyword used to trigger execution */
  execution_keyword: string;
}

/** A single date range entry used in FilterControlFlowData date maps. */
export interface FilterDateRange {
  /** Named period (e.g., "last_7_days", "custom") */
  period: string;
  /** ISO date string (start of range) */
  start: string;
  /** ISO date string (end of range) */
  end: string;
}

/**
 * "Filter Control Flow" node: filters shipments in the current execution context
 * using the same criteria as the Control Tower filter panel. Downstream nodes
 * receive only the shipments that match all configured filters.
 */
export interface FilterControlFlowData {
  /** Index of the subgraph (loop body) in the workflow.graphs list. */
  subgraph_index: number;
  /** ── Array filter fields ─────────────────────────────────────────────────── */
  team: string[];
  from_location: string[];
  to_location: string[];
  origin_state: string[];
  destination_state: string[];
  location_type: string[];
  alert_types: string[];
  type: string[];
  last_open_alert_aging: string[];
  status: string[];
  delivery_status: string[];
  pod_status: string[];
  product: string[];
  product_type: string[];
  project_id: string[];
  temperature: string[];
  courier: string[];
  link_code: string[];
  /** ── Date range filters (keyed by integer index for multiple ranges) ─────── */
  scheduled_pickup_date: { [key: number]: FilterDateRange };
  scheduled_delivery_date: { [key: number]: FilterDateRange };
  created_at: { [key: number]: FilterDateRange };
  /** Archived filter value ("ARCHIVED" when active, empty string when not set). */
  archived: string;
  /** ── Logical operator overrides ("AND" or "OR", defaulting to "OR" if empty) ──── */
  team_logic: string;
  location_type_logic: string;
  alert_types_logic: string;
  product_logic: string;
  product_type_logic: string;
  project_id_logic: string;
}

export interface FilterControlFlowData_ScheduledPickupDateEntry {
  key: number;
  value: FilterDateRange | undefined;
}

export interface FilterControlFlowData_ScheduledDeliveryDateEntry {
  key: number;
  value: FilterDateRange | undefined;
}

export interface FilterControlFlowData_CreatedAtEntry {
  key: number;
  value: FilterDateRange | undefined;
}

/** The data a workflow test run runs with, other than its tester. */
export interface WorkflowTestRunData {
  /** The workflow the run executes, which can be an unpublished draft. */
  workflow:
    | LBWorkflow
    | undefined;
  /**
   * The Shipment the run tests against. Set if a node in the workflow reads a shipment, and can be
   * empty otherwise.
   */
  shipment_id: string;
  /**
   * The ShipmentAlert on the shipment that the alert trigger replays, which the tester picks. Set
   * only if the workflow's trigger is an alert trigger, and empty for other triggers.
   */
  alert_id: string;
  /** The addresses an email node sends to in place of its own recipients. Empty means the tester. */
  email_recipients: string[];
  /**
   * Whether a delay node moves the run's clock forward and continues at once, in place of
   * suspending until the delay ends.
   */
  skip_delays: boolean;
}

/** Complete execution state that can be serialized/deserialized for suspend/resume */
export interface ExecutionState {
  /**
   * The execution stack. stack[-1] is the current frame.
   * When suspended, stack[-1].node_id is the node that requested suspension.
   */
  stack: ExecutionFrame[];
  /** Whether execution is currently suspended */
  suspended: boolean;
  /**
   * The frames of every node in the enclosing graphs that this subgraph can
   * read, each holding the values as its node published them. Empty for a
   * root graph. For a nested subgraph, holds every enclosing graph's frames.
   * The loop node's frame holds this iteration's loop variables.
   */
  parent_graph_frames: ExecutionFrame[];
  /**
   * What each Delay until event this run has been back to remembers. Kept here and not in the
   * Delay's frame, because returning to a Delay pops that frame.
   */
  delay_loops: DelayLoopState[];
}

/** What a run remembers about one Delay until event it was sent back to. */
export interface DelayLoopState {
  node_id: string;
  /** How many times the run has been sent back to the Delay. */
  returns: number;
  /**
   * Events at or after this time count when the Delay waits again: the moment after the event
   * that ended the previous wait, or, when that wait timed out, the moment it did.
   */
  look_back_since_unix_millis: number;
  /**
   * When the Delay's current wait runs out. Kept so that, if it times out and the run carries on,
   * the next wait knows when to look back from.
   */
  deadline_unix_millis: number;
}

/**
 * A frame in the execution stack. Each frame represents a node being executed
 * and contains the variables that node produced.
 */
export interface ExecutionFrame {
  /** The node ID this frame represents */
  node_id: string;
  /**
   * Index of the next child to execute (children are computed from graph edges in edge_order).
   * Defaults to 0. When >= number of children, this frame is complete.
   */
  next_child_index: number;
  /** Values of the variables this node's type declares (variable_name -> value) */
  node_variables: { [key: string]: VariableValue };
  /**
   * Values of the variables the workflow author declared on this node, in
   * LBNodeData.user_variables. Kept apart from the node type's so a name that
   * appears in both declarations holds two values.
   */
  user_variables: { [key: string]: VariableValue };
}

export interface ExecutionFrame_NodeVariablesEntry {
  key: string;
  value: VariableValue | undefined;
}

export interface ExecutionFrame_UserVariablesEntry {
  key: string;
  value: VariableValue | undefined;
}

/**
 * A timezone-aware datetime value.
 * Stores an absolute instant plus the IANA zone it should be displayed in.
 * The IANA name (not a fixed offset) is used so rendering stays correct
 * across daylight-savings-time transitions.
 */
export interface DateTimeValue {
  /** Instant since Unix epoch, in milliseconds */
  unix_millis: number;
  /** IANA zone name, e.g. "America/Los_Angeles" (required) */
  iana_timezone: string;
}

/** A timezone-aware start/end time window (e.g. "tomorrow 1–4pm"). */
export interface DateTimeRangeValue {
  start: DateTimeValue | undefined;
  end: DateTimeValue | undefined;
}

/**
 * An entity a condition compares by id, such as one of a shipment's teams. `name` is what it
 * displays as.
 */
export interface LabeledIdValue {
  id: string;
  name: string;
}

/** Entities a condition compares by id, such as a shipment's products. */
export interface LabeledIdListValue {
  items: LabeledIdValue[];
}

/** A typed variable value stored in execution scope */
export interface VariableValue {
  string_value?: string | undefined;
  number_value?: number | undefined;
  bool_value?: boolean | undefined;
  datetime_value?: DateTimeValue | undefined;
  date_time_range_value?: DateTimeRangeValue | undefined;
  labeled_id_value?: LabeledIdValue | undefined;
  labeled_id_list_value?: LabeledIdListValue | undefined;
  type: VariableType;
}

export interface TransferToActionData {
  primary_number: string;
  enable_escalation: boolean;
  escalation_option: TransferToEscalationOption;
  second_number: string;
  agent_id: string;
}

function createBaseLBWorkflow(): LBWorkflow {
  return { graphs: [] };
}

export const LBWorkflow: MessageFns<LBWorkflow> = {
  encode(message: LBWorkflow, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.graphs) {
      LBGraph.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LBWorkflow {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseLBWorkflow();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.graphs.push(LBGraph.decode(reader, reader.uint32()));
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): LBWorkflow {
    return {
      graphs: globalThis.Array.isArray(object?.graphs) ? object.graphs.map((e: any) => LBGraph.fromJSON(e)) : [],
    };
  },

  toJSON(message: LBWorkflow): unknown {
    const obj: any = {};
    if (message.graphs?.length) {
      obj.graphs = message.graphs.map((e) => LBGraph.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LBWorkflow>, I>>(base?: I): LBWorkflow {
    return LBWorkflow.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LBWorkflow>, I>>(object: I): LBWorkflow {
    const message = createBaseLBWorkflow();
    message.graphs = object.graphs?.map((e) => LBGraph.fromPartial(e)) || [];
    return message;
  },
};

function createBaseLBGraph(): LBGraph {
  return { nodes: [], edges: [] };
}

export const LBGraph: MessageFns<LBGraph> = {
  encode(message: LBGraph, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.nodes) {
      LBNode.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.edges) {
      LBEdge.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LBGraph {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseLBGraph();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.nodes.push(LBNode.decode(reader, reader.uint32()));
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.edges.push(LBEdge.decode(reader, reader.uint32()));
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): LBGraph {
    return {
      nodes: globalThis.Array.isArray(object?.nodes) ? object.nodes.map((e: any) => LBNode.fromJSON(e)) : [],
      edges: globalThis.Array.isArray(object?.edges) ? object.edges.map((e: any) => LBEdge.fromJSON(e)) : [],
    };
  },

  toJSON(message: LBGraph): unknown {
    const obj: any = {};
    if (message.nodes?.length) {
      obj.nodes = message.nodes.map((e) => LBNode.toJSON(e));
    }
    if (message.edges?.length) {
      obj.edges = message.edges.map((e) => LBEdge.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LBGraph>, I>>(base?: I): LBGraph {
    return LBGraph.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LBGraph>, I>>(object: I): LBGraph {
    const message = createBaseLBGraph();
    message.nodes = object.nodes?.map((e) => LBNode.fromPartial(e)) || [];
    message.edges = object.edges?.map((e) => LBEdge.fromPartial(e)) || [];
    return message;
  },
};

function createBaseLBNode(): LBNode {
  return { id: "", data: undefined };
}

export const LBNode: MessageFns<LBNode> = {
  encode(message: LBNode, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.data !== undefined) {
      LBNodeData.encode(message.data, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LBNode {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseLBNode();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.id = reader.string();
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.data = LBNodeData.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): LBNode {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      data: isSet(object.data) ? LBNodeData.fromJSON(object.data) : undefined,
    };
  },

  toJSON(message: LBNode): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.data !== undefined) {
      obj.data = LBNodeData.toJSON(message.data);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LBNode>, I>>(base?: I): LBNode {
    return LBNode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LBNode>, I>>(object: I): LBNode {
    const message = createBaseLBNode();
    message.id = object.id ?? "";
    message.data = (object.data !== undefined && object.data !== null)
      ? LBNodeData.fromPartial(object.data)
      : undefined;
    return message;
  },
};

function createBaseLBNodeData(): LBNodeData {
  return {
    custom_display_name: undefined,
    user_variables: [],
    alert_trigger: undefined,
    schedule_trigger: undefined,
    ai_call_action: undefined,
    slack_action: undefined,
    email_action: undefined,
    sms_action: undefined,
    resolve_alert_action: undefined,
    generate_transcript_action: undefined,
    call_webhook_action: undefined,
    paths: undefined,
    delay_action: undefined,
    deprecated_filtered_shipments_loop: undefined,
    inbound_event_trigger: undefined,
    add_coc_note_action: undefined,
    alert_status_check: undefined,
    eta_change_trigger: undefined,
    location_trigger: undefined,
    status_progress_trigger: undefined,
    manual_execution_trigger: undefined,
    inbound_trigger: undefined,
    schedule_trigger_v2: undefined,
    filter_control_flow: undefined,
    conditional: undefined,
    inbound_call_trigger: undefined,
    teams_notification: undefined,
    transfer_to_action: undefined,
    alert_action_taken_trigger: undefined,
    snooze_action: undefined,
    wait_for_reply: undefined,
    back_to_delay: undefined,
  };
}

export const LBNodeData: MessageFns<LBNodeData> = {
  encode(message: LBNodeData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.custom_display_name !== undefined) {
      writer.uint32(218).string(message.custom_display_name);
    }
    for (const v of message.user_variables) {
      VariableDesc.encode(v!, writer.uint32(234).fork()).join();
    }
    if (message.alert_trigger !== undefined) {
      AlertTriggerData.encode(message.alert_trigger, writer.uint32(10).fork()).join();
    }
    if (message.schedule_trigger !== undefined) {
      ScheduleTriggerData.encode(message.schedule_trigger, writer.uint32(18).fork()).join();
    }
    if (message.ai_call_action !== undefined) {
      AICallActionData.encode(message.ai_call_action, writer.uint32(26).fork()).join();
    }
    if (message.slack_action !== undefined) {
      SlackActionData.encode(message.slack_action, writer.uint32(34).fork()).join();
    }
    if (message.email_action !== undefined) {
      EmailActionData.encode(message.email_action, writer.uint32(42).fork()).join();
    }
    if (message.sms_action !== undefined) {
      SmsActionData.encode(message.sms_action, writer.uint32(58).fork()).join();
    }
    if (message.resolve_alert_action !== undefined) {
      ResolveAlertActionData.encode(message.resolve_alert_action, writer.uint32(66).fork()).join();
    }
    if (message.generate_transcript_action !== undefined) {
      GenerateTranscriptActionData.encode(message.generate_transcript_action, writer.uint32(74).fork()).join();
    }
    if (message.call_webhook_action !== undefined) {
      CallWebhookActionData.encode(message.call_webhook_action, writer.uint32(82).fork()).join();
    }
    if (message.paths !== undefined) {
      PathsData.encode(message.paths, writer.uint32(98).fork()).join();
    }
    if (message.delay_action !== undefined) {
      DelayActionData.encode(message.delay_action, writer.uint32(106).fork()).join();
    }
    if (message.deprecated_filtered_shipments_loop !== undefined) {
      Deprecated_FilteredShipmentsLoopData.encode(message.deprecated_filtered_shipments_loop, writer.uint32(114).fork())
        .join();
    }
    if (message.inbound_event_trigger !== undefined) {
      InboundEventTriggerData.encode(message.inbound_event_trigger, writer.uint32(122).fork()).join();
    }
    if (message.add_coc_note_action !== undefined) {
      AddCocNoteActionData.encode(message.add_coc_note_action, writer.uint32(130).fork()).join();
    }
    if (message.alert_status_check !== undefined) {
      AlertStatusCheckData.encode(message.alert_status_check, writer.uint32(138).fork()).join();
    }
    if (message.eta_change_trigger !== undefined) {
      ETAChangeTriggerData.encode(message.eta_change_trigger, writer.uint32(146).fork()).join();
    }
    if (message.location_trigger !== undefined) {
      LocationTriggerData.encode(message.location_trigger, writer.uint32(154).fork()).join();
    }
    if (message.status_progress_trigger !== undefined) {
      StatusProgressTriggerData.encode(message.status_progress_trigger, writer.uint32(162).fork()).join();
    }
    if (message.manual_execution_trigger !== undefined) {
      ManualExecutionTriggerData.encode(message.manual_execution_trigger, writer.uint32(170).fork()).join();
    }
    if (message.inbound_trigger !== undefined) {
      InboundTriggerData.encode(message.inbound_trigger, writer.uint32(178).fork()).join();
    }
    if (message.schedule_trigger_v2 !== undefined) {
      ScheduleTriggerV2Data.encode(message.schedule_trigger_v2, writer.uint32(186).fork()).join();
    }
    if (message.filter_control_flow !== undefined) {
      FilterControlFlowData.encode(message.filter_control_flow, writer.uint32(194).fork()).join();
    }
    if (message.conditional !== undefined) {
      ConditionalData.encode(message.conditional, writer.uint32(202).fork()).join();
    }
    if (message.inbound_call_trigger !== undefined) {
      InboundCallTriggerData.encode(message.inbound_call_trigger, writer.uint32(210).fork()).join();
    }
    if (message.teams_notification !== undefined) {
      TeamsNotificationData.encode(message.teams_notification, writer.uint32(226).fork()).join();
    }
    if (message.transfer_to_action !== undefined) {
      TransferToActionData.encode(message.transfer_to_action, writer.uint32(242).fork()).join();
    }
    if (message.alert_action_taken_trigger !== undefined) {
      AlertActionTakenTriggerData.encode(message.alert_action_taken_trigger, writer.uint32(250).fork()).join();
    }
    if (message.snooze_action !== undefined) {
      SnoozeActionData.encode(message.snooze_action, writer.uint32(258).fork()).join();
    }
    if (message.wait_for_reply !== undefined) {
      WaitForReplyData.encode(message.wait_for_reply, writer.uint32(266).fork()).join();
    }
    if (message.back_to_delay !== undefined) {
      BackToDelayData.encode(message.back_to_delay, writer.uint32(274).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LBNodeData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseLBNodeData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 27: {
            if (tag !== 218) {
              break;
            }

            message.custom_display_name = reader.string();
            continue;
          }
          case 29: {
            if (tag !== 234) {
              break;
            }

            message.user_variables.push(VariableDesc.decode(reader, reader.uint32()));
            continue;
          }
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.alert_trigger = AlertTriggerData.decode(reader, reader.uint32());
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.schedule_trigger = ScheduleTriggerData.decode(reader, reader.uint32());
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.ai_call_action = AICallActionData.decode(reader, reader.uint32());
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.slack_action = SlackActionData.decode(reader, reader.uint32());
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.email_action = EmailActionData.decode(reader, reader.uint32());
            continue;
          }
          case 7: {
            if (tag !== 58) {
              break;
            }

            message.sms_action = SmsActionData.decode(reader, reader.uint32());
            continue;
          }
          case 8: {
            if (tag !== 66) {
              break;
            }

            message.resolve_alert_action = ResolveAlertActionData.decode(reader, reader.uint32());
            continue;
          }
          case 9: {
            if (tag !== 74) {
              break;
            }

            message.generate_transcript_action = GenerateTranscriptActionData.decode(reader, reader.uint32());
            continue;
          }
          case 10: {
            if (tag !== 82) {
              break;
            }

            message.call_webhook_action = CallWebhookActionData.decode(reader, reader.uint32());
            continue;
          }
          case 12: {
            if (tag !== 98) {
              break;
            }

            message.paths = PathsData.decode(reader, reader.uint32());
            continue;
          }
          case 13: {
            if (tag !== 106) {
              break;
            }

            message.delay_action = DelayActionData.decode(reader, reader.uint32());
            continue;
          }
          case 14: {
            if (tag !== 114) {
              break;
            }

            message.deprecated_filtered_shipments_loop = Deprecated_FilteredShipmentsLoopData.decode(
              reader,
              reader.uint32(),
            );
            continue;
          }
          case 15: {
            if (tag !== 122) {
              break;
            }

            message.inbound_event_trigger = InboundEventTriggerData.decode(reader, reader.uint32());
            continue;
          }
          case 16: {
            if (tag !== 130) {
              break;
            }

            message.add_coc_note_action = AddCocNoteActionData.decode(reader, reader.uint32());
            continue;
          }
          case 17: {
            if (tag !== 138) {
              break;
            }

            message.alert_status_check = AlertStatusCheckData.decode(reader, reader.uint32());
            continue;
          }
          case 18: {
            if (tag !== 146) {
              break;
            }

            message.eta_change_trigger = ETAChangeTriggerData.decode(reader, reader.uint32());
            continue;
          }
          case 19: {
            if (tag !== 154) {
              break;
            }

            message.location_trigger = LocationTriggerData.decode(reader, reader.uint32());
            continue;
          }
          case 20: {
            if (tag !== 162) {
              break;
            }

            message.status_progress_trigger = StatusProgressTriggerData.decode(reader, reader.uint32());
            continue;
          }
          case 21: {
            if (tag !== 170) {
              break;
            }

            message.manual_execution_trigger = ManualExecutionTriggerData.decode(reader, reader.uint32());
            continue;
          }
          case 22: {
            if (tag !== 178) {
              break;
            }

            message.inbound_trigger = InboundTriggerData.decode(reader, reader.uint32());
            continue;
          }
          case 23: {
            if (tag !== 186) {
              break;
            }

            message.schedule_trigger_v2 = ScheduleTriggerV2Data.decode(reader, reader.uint32());
            continue;
          }
          case 24: {
            if (tag !== 194) {
              break;
            }

            message.filter_control_flow = FilterControlFlowData.decode(reader, reader.uint32());
            continue;
          }
          case 25: {
            if (tag !== 202) {
              break;
            }

            message.conditional = ConditionalData.decode(reader, reader.uint32());
            continue;
          }
          case 26: {
            if (tag !== 210) {
              break;
            }

            message.inbound_call_trigger = InboundCallTriggerData.decode(reader, reader.uint32());
            continue;
          }
          case 28: {
            if (tag !== 226) {
              break;
            }

            message.teams_notification = TeamsNotificationData.decode(reader, reader.uint32());
            continue;
          }
          case 30: {
            if (tag !== 242) {
              break;
            }

            message.transfer_to_action = TransferToActionData.decode(reader, reader.uint32());
            continue;
          }
          case 31: {
            if (tag !== 250) {
              break;
            }

            message.alert_action_taken_trigger = AlertActionTakenTriggerData.decode(reader, reader.uint32());
            continue;
          }
          case 32: {
            if (tag !== 258) {
              break;
            }

            message.snooze_action = SnoozeActionData.decode(reader, reader.uint32());
            continue;
          }
          case 33: {
            if (tag !== 266) {
              break;
            }

            message.wait_for_reply = WaitForReplyData.decode(reader, reader.uint32());
            continue;
          }
          case 34: {
            if (tag !== 274) {
              break;
            }

            message.back_to_delay = BackToDelayData.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): LBNodeData {
    return {
      custom_display_name: isSet(object.customDisplayName)
        ? globalThis.String(object.customDisplayName)
        : isSet(object.custom_display_name)
        ? globalThis.String(object.custom_display_name)
        : undefined,
      user_variables: globalThis.Array.isArray(object?.userVariables)
        ? object.userVariables.map((e: any) => VariableDesc.fromJSON(e))
        : globalThis.Array.isArray(object?.user_variables)
        ? object.user_variables.map((e: any) => VariableDesc.fromJSON(e))
        : [],
      alert_trigger: isSet(object.alertTrigger)
        ? AlertTriggerData.fromJSON(object.alertTrigger)
        : isSet(object.alert_trigger)
        ? AlertTriggerData.fromJSON(object.alert_trigger)
        : undefined,
      schedule_trigger: isSet(object.scheduleTrigger)
        ? ScheduleTriggerData.fromJSON(object.scheduleTrigger)
        : isSet(object.schedule_trigger)
        ? ScheduleTriggerData.fromJSON(object.schedule_trigger)
        : undefined,
      ai_call_action: isSet(object.aiCallAction)
        ? AICallActionData.fromJSON(object.aiCallAction)
        : isSet(object.ai_call_action)
        ? AICallActionData.fromJSON(object.ai_call_action)
        : undefined,
      slack_action: isSet(object.slackAction)
        ? SlackActionData.fromJSON(object.slackAction)
        : isSet(object.slack_action)
        ? SlackActionData.fromJSON(object.slack_action)
        : undefined,
      email_action: isSet(object.emailAction)
        ? EmailActionData.fromJSON(object.emailAction)
        : isSet(object.email_action)
        ? EmailActionData.fromJSON(object.email_action)
        : undefined,
      sms_action: isSet(object.smsAction)
        ? SmsActionData.fromJSON(object.smsAction)
        : isSet(object.sms_action)
        ? SmsActionData.fromJSON(object.sms_action)
        : undefined,
      resolve_alert_action: isSet(object.resolveAlertAction)
        ? ResolveAlertActionData.fromJSON(object.resolveAlertAction)
        : isSet(object.resolve_alert_action)
        ? ResolveAlertActionData.fromJSON(object.resolve_alert_action)
        : undefined,
      generate_transcript_action: isSet(object.generateTranscriptAction)
        ? GenerateTranscriptActionData.fromJSON(object.generateTranscriptAction)
        : isSet(object.generate_transcript_action)
        ? GenerateTranscriptActionData.fromJSON(object.generate_transcript_action)
        : undefined,
      call_webhook_action: isSet(object.callWebhookAction)
        ? CallWebhookActionData.fromJSON(object.callWebhookAction)
        : isSet(object.call_webhook_action)
        ? CallWebhookActionData.fromJSON(object.call_webhook_action)
        : undefined,
      paths: isSet(object.paths) ? PathsData.fromJSON(object.paths) : undefined,
      delay_action: isSet(object.delayAction)
        ? DelayActionData.fromJSON(object.delayAction)
        : isSet(object.delay_action)
        ? DelayActionData.fromJSON(object.delay_action)
        : undefined,
      deprecated_filtered_shipments_loop: isSet(object.deprecatedFilteredShipmentsLoop)
        ? Deprecated_FilteredShipmentsLoopData.fromJSON(object.deprecatedFilteredShipmentsLoop)
        : isSet(object.deprecated_filtered_shipments_loop)
        ? Deprecated_FilteredShipmentsLoopData.fromJSON(object.deprecated_filtered_shipments_loop)
        : undefined,
      inbound_event_trigger: isSet(object.inboundEventTrigger)
        ? InboundEventTriggerData.fromJSON(object.inboundEventTrigger)
        : isSet(object.inbound_event_trigger)
        ? InboundEventTriggerData.fromJSON(object.inbound_event_trigger)
        : undefined,
      add_coc_note_action: isSet(object.addCocNoteAction)
        ? AddCocNoteActionData.fromJSON(object.addCocNoteAction)
        : isSet(object.add_coc_note_action)
        ? AddCocNoteActionData.fromJSON(object.add_coc_note_action)
        : undefined,
      alert_status_check: isSet(object.alertStatusCheck)
        ? AlertStatusCheckData.fromJSON(object.alertStatusCheck)
        : isSet(object.alert_status_check)
        ? AlertStatusCheckData.fromJSON(object.alert_status_check)
        : undefined,
      eta_change_trigger: isSet(object.etaChangeTrigger)
        ? ETAChangeTriggerData.fromJSON(object.etaChangeTrigger)
        : isSet(object.eta_change_trigger)
        ? ETAChangeTriggerData.fromJSON(object.eta_change_trigger)
        : undefined,
      location_trigger: isSet(object.locationTrigger)
        ? LocationTriggerData.fromJSON(object.locationTrigger)
        : isSet(object.location_trigger)
        ? LocationTriggerData.fromJSON(object.location_trigger)
        : undefined,
      status_progress_trigger: isSet(object.statusProgressTrigger)
        ? StatusProgressTriggerData.fromJSON(object.statusProgressTrigger)
        : isSet(object.status_progress_trigger)
        ? StatusProgressTriggerData.fromJSON(object.status_progress_trigger)
        : undefined,
      manual_execution_trigger: isSet(object.manualExecutionTrigger)
        ? ManualExecutionTriggerData.fromJSON(object.manualExecutionTrigger)
        : isSet(object.manual_execution_trigger)
        ? ManualExecutionTriggerData.fromJSON(object.manual_execution_trigger)
        : undefined,
      inbound_trigger: isSet(object.inboundTrigger)
        ? InboundTriggerData.fromJSON(object.inboundTrigger)
        : isSet(object.inbound_trigger)
        ? InboundTriggerData.fromJSON(object.inbound_trigger)
        : undefined,
      schedule_trigger_v2: isSet(object.scheduleTriggerV2)
        ? ScheduleTriggerV2Data.fromJSON(object.scheduleTriggerV2)
        : isSet(object.schedule_trigger_v2)
        ? ScheduleTriggerV2Data.fromJSON(object.schedule_trigger_v2)
        : undefined,
      filter_control_flow: isSet(object.filterControlFlow)
        ? FilterControlFlowData.fromJSON(object.filterControlFlow)
        : isSet(object.filter_control_flow)
        ? FilterControlFlowData.fromJSON(object.filter_control_flow)
        : undefined,
      conditional: isSet(object.conditional) ? ConditionalData.fromJSON(object.conditional) : undefined,
      inbound_call_trigger: isSet(object.inboundCallTrigger)
        ? InboundCallTriggerData.fromJSON(object.inboundCallTrigger)
        : isSet(object.inbound_call_trigger)
        ? InboundCallTriggerData.fromJSON(object.inbound_call_trigger)
        : undefined,
      teams_notification: isSet(object.teamsNotification)
        ? TeamsNotificationData.fromJSON(object.teamsNotification)
        : isSet(object.teams_notification)
        ? TeamsNotificationData.fromJSON(object.teams_notification)
        : undefined,
      transfer_to_action: isSet(object.transferToAction)
        ? TransferToActionData.fromJSON(object.transferToAction)
        : isSet(object.transfer_to_action)
        ? TransferToActionData.fromJSON(object.transfer_to_action)
        : undefined,
      alert_action_taken_trigger: isSet(object.alertActionTakenTrigger)
        ? AlertActionTakenTriggerData.fromJSON(object.alertActionTakenTrigger)
        : isSet(object.alert_action_taken_trigger)
        ? AlertActionTakenTriggerData.fromJSON(object.alert_action_taken_trigger)
        : undefined,
      snooze_action: isSet(object.snoozeAction)
        ? SnoozeActionData.fromJSON(object.snoozeAction)
        : isSet(object.snooze_action)
        ? SnoozeActionData.fromJSON(object.snooze_action)
        : undefined,
      wait_for_reply: isSet(object.waitForReply)
        ? WaitForReplyData.fromJSON(object.waitForReply)
        : isSet(object.wait_for_reply)
        ? WaitForReplyData.fromJSON(object.wait_for_reply)
        : undefined,
      back_to_delay: isSet(object.backToDelay)
        ? BackToDelayData.fromJSON(object.backToDelay)
        : isSet(object.back_to_delay)
        ? BackToDelayData.fromJSON(object.back_to_delay)
        : undefined,
    };
  },

  toJSON(message: LBNodeData): unknown {
    const obj: any = {};
    if (message.custom_display_name !== undefined) {
      obj.customDisplayName = message.custom_display_name;
    }
    if (message.user_variables?.length) {
      obj.userVariables = message.user_variables.map((e) => VariableDesc.toJSON(e));
    }
    if (message.alert_trigger !== undefined) {
      obj.alertTrigger = AlertTriggerData.toJSON(message.alert_trigger);
    }
    if (message.schedule_trigger !== undefined) {
      obj.scheduleTrigger = ScheduleTriggerData.toJSON(message.schedule_trigger);
    }
    if (message.ai_call_action !== undefined) {
      obj.aiCallAction = AICallActionData.toJSON(message.ai_call_action);
    }
    if (message.slack_action !== undefined) {
      obj.slackAction = SlackActionData.toJSON(message.slack_action);
    }
    if (message.email_action !== undefined) {
      obj.emailAction = EmailActionData.toJSON(message.email_action);
    }
    if (message.sms_action !== undefined) {
      obj.smsAction = SmsActionData.toJSON(message.sms_action);
    }
    if (message.resolve_alert_action !== undefined) {
      obj.resolveAlertAction = ResolveAlertActionData.toJSON(message.resolve_alert_action);
    }
    if (message.generate_transcript_action !== undefined) {
      obj.generateTranscriptAction = GenerateTranscriptActionData.toJSON(message.generate_transcript_action);
    }
    if (message.call_webhook_action !== undefined) {
      obj.callWebhookAction = CallWebhookActionData.toJSON(message.call_webhook_action);
    }
    if (message.paths !== undefined) {
      obj.paths = PathsData.toJSON(message.paths);
    }
    if (message.delay_action !== undefined) {
      obj.delayAction = DelayActionData.toJSON(message.delay_action);
    }
    if (message.deprecated_filtered_shipments_loop !== undefined) {
      obj.deprecatedFilteredShipmentsLoop = Deprecated_FilteredShipmentsLoopData.toJSON(
        message.deprecated_filtered_shipments_loop,
      );
    }
    if (message.inbound_event_trigger !== undefined) {
      obj.inboundEventTrigger = InboundEventTriggerData.toJSON(message.inbound_event_trigger);
    }
    if (message.add_coc_note_action !== undefined) {
      obj.addCocNoteAction = AddCocNoteActionData.toJSON(message.add_coc_note_action);
    }
    if (message.alert_status_check !== undefined) {
      obj.alertStatusCheck = AlertStatusCheckData.toJSON(message.alert_status_check);
    }
    if (message.eta_change_trigger !== undefined) {
      obj.etaChangeTrigger = ETAChangeTriggerData.toJSON(message.eta_change_trigger);
    }
    if (message.location_trigger !== undefined) {
      obj.locationTrigger = LocationTriggerData.toJSON(message.location_trigger);
    }
    if (message.status_progress_trigger !== undefined) {
      obj.statusProgressTrigger = StatusProgressTriggerData.toJSON(message.status_progress_trigger);
    }
    if (message.manual_execution_trigger !== undefined) {
      obj.manualExecutionTrigger = ManualExecutionTriggerData.toJSON(message.manual_execution_trigger);
    }
    if (message.inbound_trigger !== undefined) {
      obj.inboundTrigger = InboundTriggerData.toJSON(message.inbound_trigger);
    }
    if (message.schedule_trigger_v2 !== undefined) {
      obj.scheduleTriggerV2 = ScheduleTriggerV2Data.toJSON(message.schedule_trigger_v2);
    }
    if (message.filter_control_flow !== undefined) {
      obj.filterControlFlow = FilterControlFlowData.toJSON(message.filter_control_flow);
    }
    if (message.conditional !== undefined) {
      obj.conditional = ConditionalData.toJSON(message.conditional);
    }
    if (message.inbound_call_trigger !== undefined) {
      obj.inboundCallTrigger = InboundCallTriggerData.toJSON(message.inbound_call_trigger);
    }
    if (message.teams_notification !== undefined) {
      obj.teamsNotification = TeamsNotificationData.toJSON(message.teams_notification);
    }
    if (message.transfer_to_action !== undefined) {
      obj.transferToAction = TransferToActionData.toJSON(message.transfer_to_action);
    }
    if (message.alert_action_taken_trigger !== undefined) {
      obj.alertActionTakenTrigger = AlertActionTakenTriggerData.toJSON(message.alert_action_taken_trigger);
    }
    if (message.snooze_action !== undefined) {
      obj.snoozeAction = SnoozeActionData.toJSON(message.snooze_action);
    }
    if (message.wait_for_reply !== undefined) {
      obj.waitForReply = WaitForReplyData.toJSON(message.wait_for_reply);
    }
    if (message.back_to_delay !== undefined) {
      obj.backToDelay = BackToDelayData.toJSON(message.back_to_delay);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LBNodeData>, I>>(base?: I): LBNodeData {
    return LBNodeData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LBNodeData>, I>>(object: I): LBNodeData {
    const message = createBaseLBNodeData();
    message.custom_display_name = object.custom_display_name ?? undefined;
    message.user_variables = object.user_variables?.map((e) => VariableDesc.fromPartial(e)) || [];
    message.alert_trigger = (object.alert_trigger !== undefined && object.alert_trigger !== null)
      ? AlertTriggerData.fromPartial(object.alert_trigger)
      : undefined;
    message.schedule_trigger = (object.schedule_trigger !== undefined && object.schedule_trigger !== null)
      ? ScheduleTriggerData.fromPartial(object.schedule_trigger)
      : undefined;
    message.ai_call_action = (object.ai_call_action !== undefined && object.ai_call_action !== null)
      ? AICallActionData.fromPartial(object.ai_call_action)
      : undefined;
    message.slack_action = (object.slack_action !== undefined && object.slack_action !== null)
      ? SlackActionData.fromPartial(object.slack_action)
      : undefined;
    message.email_action = (object.email_action !== undefined && object.email_action !== null)
      ? EmailActionData.fromPartial(object.email_action)
      : undefined;
    message.sms_action = (object.sms_action !== undefined && object.sms_action !== null)
      ? SmsActionData.fromPartial(object.sms_action)
      : undefined;
    message.resolve_alert_action = (object.resolve_alert_action !== undefined && object.resolve_alert_action !== null)
      ? ResolveAlertActionData.fromPartial(object.resolve_alert_action)
      : undefined;
    message.generate_transcript_action =
      (object.generate_transcript_action !== undefined && object.generate_transcript_action !== null)
        ? GenerateTranscriptActionData.fromPartial(object.generate_transcript_action)
        : undefined;
    message.call_webhook_action = (object.call_webhook_action !== undefined && object.call_webhook_action !== null)
      ? CallWebhookActionData.fromPartial(object.call_webhook_action)
      : undefined;
    message.paths = (object.paths !== undefined && object.paths !== null)
      ? PathsData.fromPartial(object.paths)
      : undefined;
    message.delay_action = (object.delay_action !== undefined && object.delay_action !== null)
      ? DelayActionData.fromPartial(object.delay_action)
      : undefined;
    message.deprecated_filtered_shipments_loop =
      (object.deprecated_filtered_shipments_loop !== undefined && object.deprecated_filtered_shipments_loop !== null)
        ? Deprecated_FilteredShipmentsLoopData.fromPartial(object.deprecated_filtered_shipments_loop)
        : undefined;
    message.inbound_event_trigger =
      (object.inbound_event_trigger !== undefined && object.inbound_event_trigger !== null)
        ? InboundEventTriggerData.fromPartial(object.inbound_event_trigger)
        : undefined;
    message.add_coc_note_action = (object.add_coc_note_action !== undefined && object.add_coc_note_action !== null)
      ? AddCocNoteActionData.fromPartial(object.add_coc_note_action)
      : undefined;
    message.alert_status_check = (object.alert_status_check !== undefined && object.alert_status_check !== null)
      ? AlertStatusCheckData.fromPartial(object.alert_status_check)
      : undefined;
    message.eta_change_trigger = (object.eta_change_trigger !== undefined && object.eta_change_trigger !== null)
      ? ETAChangeTriggerData.fromPartial(object.eta_change_trigger)
      : undefined;
    message.location_trigger = (object.location_trigger !== undefined && object.location_trigger !== null)
      ? LocationTriggerData.fromPartial(object.location_trigger)
      : undefined;
    message.status_progress_trigger =
      (object.status_progress_trigger !== undefined && object.status_progress_trigger !== null)
        ? StatusProgressTriggerData.fromPartial(object.status_progress_trigger)
        : undefined;
    message.manual_execution_trigger =
      (object.manual_execution_trigger !== undefined && object.manual_execution_trigger !== null)
        ? ManualExecutionTriggerData.fromPartial(object.manual_execution_trigger)
        : undefined;
    message.inbound_trigger = (object.inbound_trigger !== undefined && object.inbound_trigger !== null)
      ? InboundTriggerData.fromPartial(object.inbound_trigger)
      : undefined;
    message.schedule_trigger_v2 = (object.schedule_trigger_v2 !== undefined && object.schedule_trigger_v2 !== null)
      ? ScheduleTriggerV2Data.fromPartial(object.schedule_trigger_v2)
      : undefined;
    message.filter_control_flow = (object.filter_control_flow !== undefined && object.filter_control_flow !== null)
      ? FilterControlFlowData.fromPartial(object.filter_control_flow)
      : undefined;
    message.conditional = (object.conditional !== undefined && object.conditional !== null)
      ? ConditionalData.fromPartial(object.conditional)
      : undefined;
    message.inbound_call_trigger = (object.inbound_call_trigger !== undefined && object.inbound_call_trigger !== null)
      ? InboundCallTriggerData.fromPartial(object.inbound_call_trigger)
      : undefined;
    message.teams_notification = (object.teams_notification !== undefined && object.teams_notification !== null)
      ? TeamsNotificationData.fromPartial(object.teams_notification)
      : undefined;
    message.transfer_to_action = (object.transfer_to_action !== undefined && object.transfer_to_action !== null)
      ? TransferToActionData.fromPartial(object.transfer_to_action)
      : undefined;
    message.alert_action_taken_trigger =
      (object.alert_action_taken_trigger !== undefined && object.alert_action_taken_trigger !== null)
        ? AlertActionTakenTriggerData.fromPartial(object.alert_action_taken_trigger)
        : undefined;
    message.snooze_action = (object.snooze_action !== undefined && object.snooze_action !== null)
      ? SnoozeActionData.fromPartial(object.snooze_action)
      : undefined;
    message.wait_for_reply = (object.wait_for_reply !== undefined && object.wait_for_reply !== null)
      ? WaitForReplyData.fromPartial(object.wait_for_reply)
      : undefined;
    message.back_to_delay = (object.back_to_delay !== undefined && object.back_to_delay !== null)
      ? BackToDelayData.fromPartial(object.back_to_delay)
      : undefined;
    return message;
  },
};

function createBaseAlertTriggerData(): AlertTriggerData {
  return {
    alert_types: [],
    courier_ids: [],
    team_ids: [],
    origin_ids: [],
    destination_ids: [],
    product_ids: [],
    select_all: false,
    select_all_teams: false,
    select_all_origins: false,
    select_all_products: false,
    select_all_transport_providers: false,
    select_all_destinations: false,
    select_all_alert_types: false,
  };
}

export const AlertTriggerData: MessageFns<AlertTriggerData> = {
  encode(message: AlertTriggerData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.alert_types) {
      writer.uint32(10).string(v!);
    }
    for (const v of message.courier_ids) {
      writer.uint32(18).string(v!);
    }
    for (const v of message.team_ids) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.origin_ids) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.destination_ids) {
      writer.uint32(42).string(v!);
    }
    for (const v of message.product_ids) {
      writer.uint32(50).string(v!);
    }
    if (message.select_all !== false) {
      writer.uint32(56).bool(message.select_all);
    }
    if (message.select_all_teams !== false) {
      writer.uint32(64).bool(message.select_all_teams);
    }
    if (message.select_all_origins !== false) {
      writer.uint32(72).bool(message.select_all_origins);
    }
    if (message.select_all_products !== false) {
      writer.uint32(80).bool(message.select_all_products);
    }
    if (message.select_all_transport_providers !== false) {
      writer.uint32(88).bool(message.select_all_transport_providers);
    }
    if (message.select_all_destinations !== false) {
      writer.uint32(96).bool(message.select_all_destinations);
    }
    if (message.select_all_alert_types !== false) {
      writer.uint32(104).bool(message.select_all_alert_types);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AlertTriggerData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseAlertTriggerData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.alert_types.push(reader.string());
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.courier_ids.push(reader.string());
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.team_ids.push(reader.string());
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.origin_ids.push(reader.string());
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.destination_ids.push(reader.string());
            continue;
          }
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.product_ids.push(reader.string());
            continue;
          }
          case 7: {
            if (tag !== 56) {
              break;
            }

            message.select_all = reader.bool();
            continue;
          }
          case 8: {
            if (tag !== 64) {
              break;
            }

            message.select_all_teams = reader.bool();
            continue;
          }
          case 9: {
            if (tag !== 72) {
              break;
            }

            message.select_all_origins = reader.bool();
            continue;
          }
          case 10: {
            if (tag !== 80) {
              break;
            }

            message.select_all_products = reader.bool();
            continue;
          }
          case 11: {
            if (tag !== 88) {
              break;
            }

            message.select_all_transport_providers = reader.bool();
            continue;
          }
          case 12: {
            if (tag !== 96) {
              break;
            }

            message.select_all_destinations = reader.bool();
            continue;
          }
          case 13: {
            if (tag !== 104) {
              break;
            }

            message.select_all_alert_types = reader.bool();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): AlertTriggerData {
    return {
      alert_types: globalThis.Array.isArray(object?.alertTypes)
        ? object.alertTypes.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.alert_types)
        ? object.alert_types.map((e: any) => globalThis.String(e))
        : [],
      courier_ids: globalThis.Array.isArray(object?.courierIds)
        ? object.courierIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.courier_ids)
        ? object.courier_ids.map((e: any) => globalThis.String(e))
        : [],
      team_ids: globalThis.Array.isArray(object?.teamIds)
        ? object.teamIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.team_ids)
        ? object.team_ids.map((e: any) => globalThis.String(e))
        : [],
      origin_ids: globalThis.Array.isArray(object?.originIds)
        ? object.originIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.origin_ids)
        ? object.origin_ids.map((e: any) => globalThis.String(e))
        : [],
      destination_ids: globalThis.Array.isArray(object?.destinationIds)
        ? object.destinationIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.destination_ids)
        ? object.destination_ids.map((e: any) => globalThis.String(e))
        : [],
      product_ids: globalThis.Array.isArray(object?.productIds)
        ? object.productIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.product_ids)
        ? object.product_ids.map((e: any) => globalThis.String(e))
        : [],
      select_all: isSet(object.selectAll)
        ? globalThis.Boolean(object.selectAll)
        : isSet(object.select_all)
        ? globalThis.Boolean(object.select_all)
        : false,
      select_all_teams: isSet(object.selectAllTeams)
        ? globalThis.Boolean(object.selectAllTeams)
        : isSet(object.select_all_teams)
        ? globalThis.Boolean(object.select_all_teams)
        : false,
      select_all_origins: isSet(object.selectAllOrigins)
        ? globalThis.Boolean(object.selectAllOrigins)
        : isSet(object.select_all_origins)
        ? globalThis.Boolean(object.select_all_origins)
        : false,
      select_all_products: isSet(object.selectAllProducts)
        ? globalThis.Boolean(object.selectAllProducts)
        : isSet(object.select_all_products)
        ? globalThis.Boolean(object.select_all_products)
        : false,
      select_all_transport_providers: isSet(object.selectAllTransportProviders)
        ? globalThis.Boolean(object.selectAllTransportProviders)
        : isSet(object.select_all_transport_providers)
        ? globalThis.Boolean(object.select_all_transport_providers)
        : false,
      select_all_destinations: isSet(object.selectAllDestinations)
        ? globalThis.Boolean(object.selectAllDestinations)
        : isSet(object.select_all_destinations)
        ? globalThis.Boolean(object.select_all_destinations)
        : false,
      select_all_alert_types: isSet(object.selectAllAlertTypes)
        ? globalThis.Boolean(object.selectAllAlertTypes)
        : isSet(object.select_all_alert_types)
        ? globalThis.Boolean(object.select_all_alert_types)
        : false,
    };
  },

  toJSON(message: AlertTriggerData): unknown {
    const obj: any = {};
    if (message.alert_types?.length) {
      obj.alertTypes = message.alert_types;
    }
    if (message.courier_ids?.length) {
      obj.courierIds = message.courier_ids;
    }
    if (message.team_ids?.length) {
      obj.teamIds = message.team_ids;
    }
    if (message.origin_ids?.length) {
      obj.originIds = message.origin_ids;
    }
    if (message.destination_ids?.length) {
      obj.destinationIds = message.destination_ids;
    }
    if (message.product_ids?.length) {
      obj.productIds = message.product_ids;
    }
    if (message.select_all !== false) {
      obj.selectAll = message.select_all;
    }
    if (message.select_all_teams !== false) {
      obj.selectAllTeams = message.select_all_teams;
    }
    if (message.select_all_origins !== false) {
      obj.selectAllOrigins = message.select_all_origins;
    }
    if (message.select_all_products !== false) {
      obj.selectAllProducts = message.select_all_products;
    }
    if (message.select_all_transport_providers !== false) {
      obj.selectAllTransportProviders = message.select_all_transport_providers;
    }
    if (message.select_all_destinations !== false) {
      obj.selectAllDestinations = message.select_all_destinations;
    }
    if (message.select_all_alert_types !== false) {
      obj.selectAllAlertTypes = message.select_all_alert_types;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AlertTriggerData>, I>>(base?: I): AlertTriggerData {
    return AlertTriggerData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AlertTriggerData>, I>>(object: I): AlertTriggerData {
    const message = createBaseAlertTriggerData();
    message.alert_types = object.alert_types?.map((e) => e) || [];
    message.courier_ids = object.courier_ids?.map((e) => e) || [];
    message.team_ids = object.team_ids?.map((e) => e) || [];
    message.origin_ids = object.origin_ids?.map((e) => e) || [];
    message.destination_ids = object.destination_ids?.map((e) => e) || [];
    message.product_ids = object.product_ids?.map((e) => e) || [];
    message.select_all = object.select_all ?? false;
    message.select_all_teams = object.select_all_teams ?? false;
    message.select_all_origins = object.select_all_origins ?? false;
    message.select_all_products = object.select_all_products ?? false;
    message.select_all_transport_providers = object.select_all_transport_providers ?? false;
    message.select_all_destinations = object.select_all_destinations ?? false;
    message.select_all_alert_types = object.select_all_alert_types ?? false;
    return message;
  },
};

function createBaseAlertActionTakenTriggerData(): AlertActionTakenTriggerData {
  return {
    alert_types: [],
    courier_ids: [],
    team_ids: [],
    origin_ids: [],
    destination_ids: [],
    product_ids: [],
    select_all: false,
    select_all_teams: false,
    select_all_origins: false,
    select_all_products: false,
    select_all_transport_providers: false,
    select_all_destinations: false,
    select_all_alert_types: false,
    action_taken: [],
    select_all_action_taken: false,
    tag_ids: [],
  };
}

export const AlertActionTakenTriggerData: MessageFns<AlertActionTakenTriggerData> = {
  encode(message: AlertActionTakenTriggerData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.alert_types) {
      writer.uint32(10).string(v!);
    }
    for (const v of message.courier_ids) {
      writer.uint32(18).string(v!);
    }
    for (const v of message.team_ids) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.origin_ids) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.destination_ids) {
      writer.uint32(42).string(v!);
    }
    for (const v of message.product_ids) {
      writer.uint32(50).string(v!);
    }
    if (message.select_all !== false) {
      writer.uint32(56).bool(message.select_all);
    }
    if (message.select_all_teams !== false) {
      writer.uint32(64).bool(message.select_all_teams);
    }
    if (message.select_all_origins !== false) {
      writer.uint32(72).bool(message.select_all_origins);
    }
    if (message.select_all_products !== false) {
      writer.uint32(80).bool(message.select_all_products);
    }
    if (message.select_all_transport_providers !== false) {
      writer.uint32(88).bool(message.select_all_transport_providers);
    }
    if (message.select_all_destinations !== false) {
      writer.uint32(96).bool(message.select_all_destinations);
    }
    if (message.select_all_alert_types !== false) {
      writer.uint32(104).bool(message.select_all_alert_types);
    }
    if (message.action_taken.length !== 0) {
      writer.uint32(114).fork();
      for (const v of message.action_taken) {
        writer.int32(v);
      }
      writer.join();
    }
    if (message.select_all_action_taken !== false) {
      writer.uint32(120).bool(message.select_all_action_taken);
    }
    for (const v of message.tag_ids) {
      writer.uint32(130).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AlertActionTakenTriggerData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseAlertActionTakenTriggerData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.alert_types.push(reader.string());
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.courier_ids.push(reader.string());
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.team_ids.push(reader.string());
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.origin_ids.push(reader.string());
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.destination_ids.push(reader.string());
            continue;
          }
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.product_ids.push(reader.string());
            continue;
          }
          case 7: {
            if (tag !== 56) {
              break;
            }

            message.select_all = reader.bool();
            continue;
          }
          case 8: {
            if (tag !== 64) {
              break;
            }

            message.select_all_teams = reader.bool();
            continue;
          }
          case 9: {
            if (tag !== 72) {
              break;
            }

            message.select_all_origins = reader.bool();
            continue;
          }
          case 10: {
            if (tag !== 80) {
              break;
            }

            message.select_all_products = reader.bool();
            continue;
          }
          case 11: {
            if (tag !== 88) {
              break;
            }

            message.select_all_transport_providers = reader.bool();
            continue;
          }
          case 12: {
            if (tag !== 96) {
              break;
            }

            message.select_all_destinations = reader.bool();
            continue;
          }
          case 13: {
            if (tag !== 104) {
              break;
            }

            message.select_all_alert_types = reader.bool();
            continue;
          }
          case 14: {
            if (tag === 112) {
              message.action_taken.push(reader.int32() as any);

              continue;
            }

            if (tag === 114) {
              const end2 = reader.uint32() + reader.pos;
              while (reader.pos < end2) {
                message.action_taken.push(reader.int32() as any);
              }

              continue;
            }

            break;
          }
          case 15: {
            if (tag !== 120) {
              break;
            }

            message.select_all_action_taken = reader.bool();
            continue;
          }
          case 16: {
            if (tag !== 130) {
              break;
            }

            message.tag_ids.push(reader.string());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): AlertActionTakenTriggerData {
    return {
      alert_types: globalThis.Array.isArray(object?.alertTypes)
        ? object.alertTypes.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.alert_types)
        ? object.alert_types.map((e: any) => globalThis.String(e))
        : [],
      courier_ids: globalThis.Array.isArray(object?.courierIds)
        ? object.courierIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.courier_ids)
        ? object.courier_ids.map((e: any) => globalThis.String(e))
        : [],
      team_ids: globalThis.Array.isArray(object?.teamIds)
        ? object.teamIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.team_ids)
        ? object.team_ids.map((e: any) => globalThis.String(e))
        : [],
      origin_ids: globalThis.Array.isArray(object?.originIds)
        ? object.originIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.origin_ids)
        ? object.origin_ids.map((e: any) => globalThis.String(e))
        : [],
      destination_ids: globalThis.Array.isArray(object?.destinationIds)
        ? object.destinationIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.destination_ids)
        ? object.destination_ids.map((e: any) => globalThis.String(e))
        : [],
      product_ids: globalThis.Array.isArray(object?.productIds)
        ? object.productIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.product_ids)
        ? object.product_ids.map((e: any) => globalThis.String(e))
        : [],
      select_all: isSet(object.selectAll)
        ? globalThis.Boolean(object.selectAll)
        : isSet(object.select_all)
        ? globalThis.Boolean(object.select_all)
        : false,
      select_all_teams: isSet(object.selectAllTeams)
        ? globalThis.Boolean(object.selectAllTeams)
        : isSet(object.select_all_teams)
        ? globalThis.Boolean(object.select_all_teams)
        : false,
      select_all_origins: isSet(object.selectAllOrigins)
        ? globalThis.Boolean(object.selectAllOrigins)
        : isSet(object.select_all_origins)
        ? globalThis.Boolean(object.select_all_origins)
        : false,
      select_all_products: isSet(object.selectAllProducts)
        ? globalThis.Boolean(object.selectAllProducts)
        : isSet(object.select_all_products)
        ? globalThis.Boolean(object.select_all_products)
        : false,
      select_all_transport_providers: isSet(object.selectAllTransportProviders)
        ? globalThis.Boolean(object.selectAllTransportProviders)
        : isSet(object.select_all_transport_providers)
        ? globalThis.Boolean(object.select_all_transport_providers)
        : false,
      select_all_destinations: isSet(object.selectAllDestinations)
        ? globalThis.Boolean(object.selectAllDestinations)
        : isSet(object.select_all_destinations)
        ? globalThis.Boolean(object.select_all_destinations)
        : false,
      select_all_alert_types: isSet(object.selectAllAlertTypes)
        ? globalThis.Boolean(object.selectAllAlertTypes)
        : isSet(object.select_all_alert_types)
        ? globalThis.Boolean(object.select_all_alert_types)
        : false,
      action_taken: globalThis.Array.isArray(object?.actionTaken)
        ? object.actionTaken.map((e: any) => actionTakenFromJSON(e))
        : globalThis.Array.isArray(object?.action_taken)
        ? object.action_taken.map((e: any) => actionTakenFromJSON(e))
        : [],
      select_all_action_taken: isSet(object.selectAllActionTaken)
        ? globalThis.Boolean(object.selectAllActionTaken)
        : isSet(object.select_all_action_taken)
        ? globalThis.Boolean(object.select_all_action_taken)
        : false,
      tag_ids: globalThis.Array.isArray(object?.tagIds)
        ? object.tagIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.tag_ids)
        ? object.tag_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: AlertActionTakenTriggerData): unknown {
    const obj: any = {};
    if (message.alert_types?.length) {
      obj.alertTypes = message.alert_types;
    }
    if (message.courier_ids?.length) {
      obj.courierIds = message.courier_ids;
    }
    if (message.team_ids?.length) {
      obj.teamIds = message.team_ids;
    }
    if (message.origin_ids?.length) {
      obj.originIds = message.origin_ids;
    }
    if (message.destination_ids?.length) {
      obj.destinationIds = message.destination_ids;
    }
    if (message.product_ids?.length) {
      obj.productIds = message.product_ids;
    }
    if (message.select_all !== false) {
      obj.selectAll = message.select_all;
    }
    if (message.select_all_teams !== false) {
      obj.selectAllTeams = message.select_all_teams;
    }
    if (message.select_all_origins !== false) {
      obj.selectAllOrigins = message.select_all_origins;
    }
    if (message.select_all_products !== false) {
      obj.selectAllProducts = message.select_all_products;
    }
    if (message.select_all_transport_providers !== false) {
      obj.selectAllTransportProviders = message.select_all_transport_providers;
    }
    if (message.select_all_destinations !== false) {
      obj.selectAllDestinations = message.select_all_destinations;
    }
    if (message.select_all_alert_types !== false) {
      obj.selectAllAlertTypes = message.select_all_alert_types;
    }
    if (message.action_taken?.length) {
      obj.actionTaken = message.action_taken.map((e) => actionTakenToJSON(e));
    }
    if (message.select_all_action_taken !== false) {
      obj.selectAllActionTaken = message.select_all_action_taken;
    }
    if (message.tag_ids?.length) {
      obj.tagIds = message.tag_ids;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AlertActionTakenTriggerData>, I>>(base?: I): AlertActionTakenTriggerData {
    return AlertActionTakenTriggerData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AlertActionTakenTriggerData>, I>>(object: I): AlertActionTakenTriggerData {
    const message = createBaseAlertActionTakenTriggerData();
    message.alert_types = object.alert_types?.map((e) => e) || [];
    message.courier_ids = object.courier_ids?.map((e) => e) || [];
    message.team_ids = object.team_ids?.map((e) => e) || [];
    message.origin_ids = object.origin_ids?.map((e) => e) || [];
    message.destination_ids = object.destination_ids?.map((e) => e) || [];
    message.product_ids = object.product_ids?.map((e) => e) || [];
    message.select_all = object.select_all ?? false;
    message.select_all_teams = object.select_all_teams ?? false;
    message.select_all_origins = object.select_all_origins ?? false;
    message.select_all_products = object.select_all_products ?? false;
    message.select_all_transport_providers = object.select_all_transport_providers ?? false;
    message.select_all_destinations = object.select_all_destinations ?? false;
    message.select_all_alert_types = object.select_all_alert_types ?? false;
    message.action_taken = object.action_taken?.map((e) => e) || [];
    message.select_all_action_taken = object.select_all_action_taken ?? false;
    message.tag_ids = object.tag_ids?.map((e) => e) || [];
    return message;
  },
};

function createBaseETAChangeTriggerData(): ETAChangeTriggerData {
  return {
    change_by: "",
    courier_ids: [],
    team_ids: [],
    origin_ids: [],
    destination_ids: [],
    product_ids: [],
    select_all: false,
    select_all_teams: false,
    select_all_origins: false,
    select_all_products: false,
    select_all_transport_providers: false,
    select_all_destinations: false,
    direction: "",
  };
}

export const ETAChangeTriggerData: MessageFns<ETAChangeTriggerData> = {
  encode(message: ETAChangeTriggerData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.change_by !== "") {
      writer.uint32(10).string(message.change_by);
    }
    for (const v of message.courier_ids) {
      writer.uint32(18).string(v!);
    }
    for (const v of message.team_ids) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.origin_ids) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.destination_ids) {
      writer.uint32(42).string(v!);
    }
    for (const v of message.product_ids) {
      writer.uint32(50).string(v!);
    }
    if (message.select_all !== false) {
      writer.uint32(56).bool(message.select_all);
    }
    if (message.select_all_teams !== false) {
      writer.uint32(64).bool(message.select_all_teams);
    }
    if (message.select_all_origins !== false) {
      writer.uint32(72).bool(message.select_all_origins);
    }
    if (message.select_all_products !== false) {
      writer.uint32(80).bool(message.select_all_products);
    }
    if (message.select_all_transport_providers !== false) {
      writer.uint32(88).bool(message.select_all_transport_providers);
    }
    if (message.select_all_destinations !== false) {
      writer.uint32(96).bool(message.select_all_destinations);
    }
    if (message.direction !== "") {
      writer.uint32(106).string(message.direction);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ETAChangeTriggerData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseETAChangeTriggerData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.change_by = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.courier_ids.push(reader.string());
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.team_ids.push(reader.string());
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.origin_ids.push(reader.string());
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.destination_ids.push(reader.string());
            continue;
          }
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.product_ids.push(reader.string());
            continue;
          }
          case 7: {
            if (tag !== 56) {
              break;
            }

            message.select_all = reader.bool();
            continue;
          }
          case 8: {
            if (tag !== 64) {
              break;
            }

            message.select_all_teams = reader.bool();
            continue;
          }
          case 9: {
            if (tag !== 72) {
              break;
            }

            message.select_all_origins = reader.bool();
            continue;
          }
          case 10: {
            if (tag !== 80) {
              break;
            }

            message.select_all_products = reader.bool();
            continue;
          }
          case 11: {
            if (tag !== 88) {
              break;
            }

            message.select_all_transport_providers = reader.bool();
            continue;
          }
          case 12: {
            if (tag !== 96) {
              break;
            }

            message.select_all_destinations = reader.bool();
            continue;
          }
          case 13: {
            if (tag !== 106) {
              break;
            }

            message.direction = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): ETAChangeTriggerData {
    return {
      change_by: isSet(object.changeBy)
        ? globalThis.String(object.changeBy)
        : isSet(object.change_by)
        ? globalThis.String(object.change_by)
        : "",
      courier_ids: globalThis.Array.isArray(object?.courierIds)
        ? object.courierIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.courier_ids)
        ? object.courier_ids.map((e: any) => globalThis.String(e))
        : [],
      team_ids: globalThis.Array.isArray(object?.teamIds)
        ? object.teamIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.team_ids)
        ? object.team_ids.map((e: any) => globalThis.String(e))
        : [],
      origin_ids: globalThis.Array.isArray(object?.originIds)
        ? object.originIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.origin_ids)
        ? object.origin_ids.map((e: any) => globalThis.String(e))
        : [],
      destination_ids: globalThis.Array.isArray(object?.destinationIds)
        ? object.destinationIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.destination_ids)
        ? object.destination_ids.map((e: any) => globalThis.String(e))
        : [],
      product_ids: globalThis.Array.isArray(object?.productIds)
        ? object.productIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.product_ids)
        ? object.product_ids.map((e: any) => globalThis.String(e))
        : [],
      select_all: isSet(object.selectAll)
        ? globalThis.Boolean(object.selectAll)
        : isSet(object.select_all)
        ? globalThis.Boolean(object.select_all)
        : false,
      select_all_teams: isSet(object.selectAllTeams)
        ? globalThis.Boolean(object.selectAllTeams)
        : isSet(object.select_all_teams)
        ? globalThis.Boolean(object.select_all_teams)
        : false,
      select_all_origins: isSet(object.selectAllOrigins)
        ? globalThis.Boolean(object.selectAllOrigins)
        : isSet(object.select_all_origins)
        ? globalThis.Boolean(object.select_all_origins)
        : false,
      select_all_products: isSet(object.selectAllProducts)
        ? globalThis.Boolean(object.selectAllProducts)
        : isSet(object.select_all_products)
        ? globalThis.Boolean(object.select_all_products)
        : false,
      select_all_transport_providers: isSet(object.selectAllTransportProviders)
        ? globalThis.Boolean(object.selectAllTransportProviders)
        : isSet(object.select_all_transport_providers)
        ? globalThis.Boolean(object.select_all_transport_providers)
        : false,
      select_all_destinations: isSet(object.selectAllDestinations)
        ? globalThis.Boolean(object.selectAllDestinations)
        : isSet(object.select_all_destinations)
        ? globalThis.Boolean(object.select_all_destinations)
        : false,
      direction: isSet(object.direction) ? globalThis.String(object.direction) : "",
    };
  },

  toJSON(message: ETAChangeTriggerData): unknown {
    const obj: any = {};
    if (message.change_by !== "") {
      obj.changeBy = message.change_by;
    }
    if (message.courier_ids?.length) {
      obj.courierIds = message.courier_ids;
    }
    if (message.team_ids?.length) {
      obj.teamIds = message.team_ids;
    }
    if (message.origin_ids?.length) {
      obj.originIds = message.origin_ids;
    }
    if (message.destination_ids?.length) {
      obj.destinationIds = message.destination_ids;
    }
    if (message.product_ids?.length) {
      obj.productIds = message.product_ids;
    }
    if (message.select_all !== false) {
      obj.selectAll = message.select_all;
    }
    if (message.select_all_teams !== false) {
      obj.selectAllTeams = message.select_all_teams;
    }
    if (message.select_all_origins !== false) {
      obj.selectAllOrigins = message.select_all_origins;
    }
    if (message.select_all_products !== false) {
      obj.selectAllProducts = message.select_all_products;
    }
    if (message.select_all_transport_providers !== false) {
      obj.selectAllTransportProviders = message.select_all_transport_providers;
    }
    if (message.select_all_destinations !== false) {
      obj.selectAllDestinations = message.select_all_destinations;
    }
    if (message.direction !== "") {
      obj.direction = message.direction;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ETAChangeTriggerData>, I>>(base?: I): ETAChangeTriggerData {
    return ETAChangeTriggerData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ETAChangeTriggerData>, I>>(object: I): ETAChangeTriggerData {
    const message = createBaseETAChangeTriggerData();
    message.change_by = object.change_by ?? "";
    message.courier_ids = object.courier_ids?.map((e) => e) || [];
    message.team_ids = object.team_ids?.map((e) => e) || [];
    message.origin_ids = object.origin_ids?.map((e) => e) || [];
    message.destination_ids = object.destination_ids?.map((e) => e) || [];
    message.product_ids = object.product_ids?.map((e) => e) || [];
    message.select_all = object.select_all ?? false;
    message.select_all_teams = object.select_all_teams ?? false;
    message.select_all_origins = object.select_all_origins ?? false;
    message.select_all_products = object.select_all_products ?? false;
    message.select_all_transport_providers = object.select_all_transport_providers ?? false;
    message.select_all_destinations = object.select_all_destinations ?? false;
    message.direction = object.direction ?? "";
    return message;
  },
};

function createBaseLocationTriggerData(): LocationTriggerData {
  return {
    location: "",
    courier_ids: [],
    team_ids: [],
    origin_ids: [],
    destination_ids: [],
    product_ids: [],
    select_all: false,
    select_all_teams: false,
    select_all_origins: false,
    select_all_products: false,
    select_all_transport_providers: false,
    select_all_destinations: false,
  };
}

export const LocationTriggerData: MessageFns<LocationTriggerData> = {
  encode(message: LocationTriggerData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.location !== "") {
      writer.uint32(10).string(message.location);
    }
    for (const v of message.courier_ids) {
      writer.uint32(18).string(v!);
    }
    for (const v of message.team_ids) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.origin_ids) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.destination_ids) {
      writer.uint32(42).string(v!);
    }
    for (const v of message.product_ids) {
      writer.uint32(50).string(v!);
    }
    if (message.select_all !== false) {
      writer.uint32(56).bool(message.select_all);
    }
    if (message.select_all_teams !== false) {
      writer.uint32(64).bool(message.select_all_teams);
    }
    if (message.select_all_origins !== false) {
      writer.uint32(72).bool(message.select_all_origins);
    }
    if (message.select_all_products !== false) {
      writer.uint32(80).bool(message.select_all_products);
    }
    if (message.select_all_transport_providers !== false) {
      writer.uint32(88).bool(message.select_all_transport_providers);
    }
    if (message.select_all_destinations !== false) {
      writer.uint32(96).bool(message.select_all_destinations);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LocationTriggerData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseLocationTriggerData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.location = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.courier_ids.push(reader.string());
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.team_ids.push(reader.string());
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.origin_ids.push(reader.string());
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.destination_ids.push(reader.string());
            continue;
          }
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.product_ids.push(reader.string());
            continue;
          }
          case 7: {
            if (tag !== 56) {
              break;
            }

            message.select_all = reader.bool();
            continue;
          }
          case 8: {
            if (tag !== 64) {
              break;
            }

            message.select_all_teams = reader.bool();
            continue;
          }
          case 9: {
            if (tag !== 72) {
              break;
            }

            message.select_all_origins = reader.bool();
            continue;
          }
          case 10: {
            if (tag !== 80) {
              break;
            }

            message.select_all_products = reader.bool();
            continue;
          }
          case 11: {
            if (tag !== 88) {
              break;
            }

            message.select_all_transport_providers = reader.bool();
            continue;
          }
          case 12: {
            if (tag !== 96) {
              break;
            }

            message.select_all_destinations = reader.bool();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): LocationTriggerData {
    return {
      location: isSet(object.location) ? globalThis.String(object.location) : "",
      courier_ids: globalThis.Array.isArray(object?.courierIds)
        ? object.courierIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.courier_ids)
        ? object.courier_ids.map((e: any) => globalThis.String(e))
        : [],
      team_ids: globalThis.Array.isArray(object?.teamIds)
        ? object.teamIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.team_ids)
        ? object.team_ids.map((e: any) => globalThis.String(e))
        : [],
      origin_ids: globalThis.Array.isArray(object?.originIds)
        ? object.originIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.origin_ids)
        ? object.origin_ids.map((e: any) => globalThis.String(e))
        : [],
      destination_ids: globalThis.Array.isArray(object?.destinationIds)
        ? object.destinationIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.destination_ids)
        ? object.destination_ids.map((e: any) => globalThis.String(e))
        : [],
      product_ids: globalThis.Array.isArray(object?.productIds)
        ? object.productIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.product_ids)
        ? object.product_ids.map((e: any) => globalThis.String(e))
        : [],
      select_all: isSet(object.selectAll)
        ? globalThis.Boolean(object.selectAll)
        : isSet(object.select_all)
        ? globalThis.Boolean(object.select_all)
        : false,
      select_all_teams: isSet(object.selectAllTeams)
        ? globalThis.Boolean(object.selectAllTeams)
        : isSet(object.select_all_teams)
        ? globalThis.Boolean(object.select_all_teams)
        : false,
      select_all_origins: isSet(object.selectAllOrigins)
        ? globalThis.Boolean(object.selectAllOrigins)
        : isSet(object.select_all_origins)
        ? globalThis.Boolean(object.select_all_origins)
        : false,
      select_all_products: isSet(object.selectAllProducts)
        ? globalThis.Boolean(object.selectAllProducts)
        : isSet(object.select_all_products)
        ? globalThis.Boolean(object.select_all_products)
        : false,
      select_all_transport_providers: isSet(object.selectAllTransportProviders)
        ? globalThis.Boolean(object.selectAllTransportProviders)
        : isSet(object.select_all_transport_providers)
        ? globalThis.Boolean(object.select_all_transport_providers)
        : false,
      select_all_destinations: isSet(object.selectAllDestinations)
        ? globalThis.Boolean(object.selectAllDestinations)
        : isSet(object.select_all_destinations)
        ? globalThis.Boolean(object.select_all_destinations)
        : false,
    };
  },

  toJSON(message: LocationTriggerData): unknown {
    const obj: any = {};
    if (message.location !== "") {
      obj.location = message.location;
    }
    if (message.courier_ids?.length) {
      obj.courierIds = message.courier_ids;
    }
    if (message.team_ids?.length) {
      obj.teamIds = message.team_ids;
    }
    if (message.origin_ids?.length) {
      obj.originIds = message.origin_ids;
    }
    if (message.destination_ids?.length) {
      obj.destinationIds = message.destination_ids;
    }
    if (message.product_ids?.length) {
      obj.productIds = message.product_ids;
    }
    if (message.select_all !== false) {
      obj.selectAll = message.select_all;
    }
    if (message.select_all_teams !== false) {
      obj.selectAllTeams = message.select_all_teams;
    }
    if (message.select_all_origins !== false) {
      obj.selectAllOrigins = message.select_all_origins;
    }
    if (message.select_all_products !== false) {
      obj.selectAllProducts = message.select_all_products;
    }
    if (message.select_all_transport_providers !== false) {
      obj.selectAllTransportProviders = message.select_all_transport_providers;
    }
    if (message.select_all_destinations !== false) {
      obj.selectAllDestinations = message.select_all_destinations;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LocationTriggerData>, I>>(base?: I): LocationTriggerData {
    return LocationTriggerData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LocationTriggerData>, I>>(object: I): LocationTriggerData {
    const message = createBaseLocationTriggerData();
    message.location = object.location ?? "";
    message.courier_ids = object.courier_ids?.map((e) => e) || [];
    message.team_ids = object.team_ids?.map((e) => e) || [];
    message.origin_ids = object.origin_ids?.map((e) => e) || [];
    message.destination_ids = object.destination_ids?.map((e) => e) || [];
    message.product_ids = object.product_ids?.map((e) => e) || [];
    message.select_all = object.select_all ?? false;
    message.select_all_teams = object.select_all_teams ?? false;
    message.select_all_origins = object.select_all_origins ?? false;
    message.select_all_products = object.select_all_products ?? false;
    message.select_all_transport_providers = object.select_all_transport_providers ?? false;
    message.select_all_destinations = object.select_all_destinations ?? false;
    return message;
  },
};

function createBaseStatusProgressTriggerData(): StatusProgressTriggerData {
  return {
    is_pickup_confirmation: false,
    is_delivery_confirmation: false,
    is_delivery_exception: false,
    is_created: false,
    is_out_for_delivery: false,
    courier_ids: [],
    team_ids: [],
    origin_ids: [],
    destination_ids: [],
    product_ids: [],
    select_all: false,
    select_all_teams: false,
    select_all_origins: false,
    select_all_products: false,
    select_all_transport_providers: false,
    select_all_destinations: false,
    is_incomplete: false,
  };
}

export const StatusProgressTriggerData: MessageFns<StatusProgressTriggerData> = {
  encode(message: StatusProgressTriggerData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.is_pickup_confirmation !== false) {
      writer.uint32(8).bool(message.is_pickup_confirmation);
    }
    if (message.is_delivery_confirmation !== false) {
      writer.uint32(16).bool(message.is_delivery_confirmation);
    }
    if (message.is_delivery_exception !== false) {
      writer.uint32(24).bool(message.is_delivery_exception);
    }
    if (message.is_created !== false) {
      writer.uint32(32).bool(message.is_created);
    }
    if (message.is_out_for_delivery !== false) {
      writer.uint32(40).bool(message.is_out_for_delivery);
    }
    for (const v of message.courier_ids) {
      writer.uint32(50).string(v!);
    }
    for (const v of message.team_ids) {
      writer.uint32(58).string(v!);
    }
    for (const v of message.origin_ids) {
      writer.uint32(66).string(v!);
    }
    for (const v of message.destination_ids) {
      writer.uint32(74).string(v!);
    }
    for (const v of message.product_ids) {
      writer.uint32(82).string(v!);
    }
    if (message.select_all !== false) {
      writer.uint32(88).bool(message.select_all);
    }
    if (message.select_all_teams !== false) {
      writer.uint32(96).bool(message.select_all_teams);
    }
    if (message.select_all_origins !== false) {
      writer.uint32(104).bool(message.select_all_origins);
    }
    if (message.select_all_products !== false) {
      writer.uint32(112).bool(message.select_all_products);
    }
    if (message.select_all_transport_providers !== false) {
      writer.uint32(120).bool(message.select_all_transport_providers);
    }
    if (message.select_all_destinations !== false) {
      writer.uint32(128).bool(message.select_all_destinations);
    }
    if (message.is_incomplete !== false) {
      writer.uint32(136).bool(message.is_incomplete);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StatusProgressTriggerData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseStatusProgressTriggerData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.is_pickup_confirmation = reader.bool();
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.is_delivery_confirmation = reader.bool();
            continue;
          }
          case 3: {
            if (tag !== 24) {
              break;
            }

            message.is_delivery_exception = reader.bool();
            continue;
          }
          case 4: {
            if (tag !== 32) {
              break;
            }

            message.is_created = reader.bool();
            continue;
          }
          case 5: {
            if (tag !== 40) {
              break;
            }

            message.is_out_for_delivery = reader.bool();
            continue;
          }
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.courier_ids.push(reader.string());
            continue;
          }
          case 7: {
            if (tag !== 58) {
              break;
            }

            message.team_ids.push(reader.string());
            continue;
          }
          case 8: {
            if (tag !== 66) {
              break;
            }

            message.origin_ids.push(reader.string());
            continue;
          }
          case 9: {
            if (tag !== 74) {
              break;
            }

            message.destination_ids.push(reader.string());
            continue;
          }
          case 10: {
            if (tag !== 82) {
              break;
            }

            message.product_ids.push(reader.string());
            continue;
          }
          case 11: {
            if (tag !== 88) {
              break;
            }

            message.select_all = reader.bool();
            continue;
          }
          case 12: {
            if (tag !== 96) {
              break;
            }

            message.select_all_teams = reader.bool();
            continue;
          }
          case 13: {
            if (tag !== 104) {
              break;
            }

            message.select_all_origins = reader.bool();
            continue;
          }
          case 14: {
            if (tag !== 112) {
              break;
            }

            message.select_all_products = reader.bool();
            continue;
          }
          case 15: {
            if (tag !== 120) {
              break;
            }

            message.select_all_transport_providers = reader.bool();
            continue;
          }
          case 16: {
            if (tag !== 128) {
              break;
            }

            message.select_all_destinations = reader.bool();
            continue;
          }
          case 17: {
            if (tag !== 136) {
              break;
            }

            message.is_incomplete = reader.bool();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): StatusProgressTriggerData {
    return {
      is_pickup_confirmation: isSet(object.isPickupConfirmation)
        ? globalThis.Boolean(object.isPickupConfirmation)
        : isSet(object.is_pickup_confirmation)
        ? globalThis.Boolean(object.is_pickup_confirmation)
        : false,
      is_delivery_confirmation: isSet(object.isDeliveryConfirmation)
        ? globalThis.Boolean(object.isDeliveryConfirmation)
        : isSet(object.is_delivery_confirmation)
        ? globalThis.Boolean(object.is_delivery_confirmation)
        : false,
      is_delivery_exception: isSet(object.isDeliveryException)
        ? globalThis.Boolean(object.isDeliveryException)
        : isSet(object.is_delivery_exception)
        ? globalThis.Boolean(object.is_delivery_exception)
        : false,
      is_created: isSet(object.isCreated)
        ? globalThis.Boolean(object.isCreated)
        : isSet(object.is_created)
        ? globalThis.Boolean(object.is_created)
        : false,
      is_out_for_delivery: isSet(object.isOutForDelivery)
        ? globalThis.Boolean(object.isOutForDelivery)
        : isSet(object.is_out_for_delivery)
        ? globalThis.Boolean(object.is_out_for_delivery)
        : false,
      courier_ids: globalThis.Array.isArray(object?.courierIds)
        ? object.courierIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.courier_ids)
        ? object.courier_ids.map((e: any) => globalThis.String(e))
        : [],
      team_ids: globalThis.Array.isArray(object?.teamIds)
        ? object.teamIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.team_ids)
        ? object.team_ids.map((e: any) => globalThis.String(e))
        : [],
      origin_ids: globalThis.Array.isArray(object?.originIds)
        ? object.originIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.origin_ids)
        ? object.origin_ids.map((e: any) => globalThis.String(e))
        : [],
      destination_ids: globalThis.Array.isArray(object?.destinationIds)
        ? object.destinationIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.destination_ids)
        ? object.destination_ids.map((e: any) => globalThis.String(e))
        : [],
      product_ids: globalThis.Array.isArray(object?.productIds)
        ? object.productIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.product_ids)
        ? object.product_ids.map((e: any) => globalThis.String(e))
        : [],
      select_all: isSet(object.selectAll)
        ? globalThis.Boolean(object.selectAll)
        : isSet(object.select_all)
        ? globalThis.Boolean(object.select_all)
        : false,
      select_all_teams: isSet(object.selectAllTeams)
        ? globalThis.Boolean(object.selectAllTeams)
        : isSet(object.select_all_teams)
        ? globalThis.Boolean(object.select_all_teams)
        : false,
      select_all_origins: isSet(object.selectAllOrigins)
        ? globalThis.Boolean(object.selectAllOrigins)
        : isSet(object.select_all_origins)
        ? globalThis.Boolean(object.select_all_origins)
        : false,
      select_all_products: isSet(object.selectAllProducts)
        ? globalThis.Boolean(object.selectAllProducts)
        : isSet(object.select_all_products)
        ? globalThis.Boolean(object.select_all_products)
        : false,
      select_all_transport_providers: isSet(object.selectAllTransportProviders)
        ? globalThis.Boolean(object.selectAllTransportProviders)
        : isSet(object.select_all_transport_providers)
        ? globalThis.Boolean(object.select_all_transport_providers)
        : false,
      select_all_destinations: isSet(object.selectAllDestinations)
        ? globalThis.Boolean(object.selectAllDestinations)
        : isSet(object.select_all_destinations)
        ? globalThis.Boolean(object.select_all_destinations)
        : false,
      is_incomplete: isSet(object.isIncomplete)
        ? globalThis.Boolean(object.isIncomplete)
        : isSet(object.is_incomplete)
        ? globalThis.Boolean(object.is_incomplete)
        : false,
    };
  },

  toJSON(message: StatusProgressTriggerData): unknown {
    const obj: any = {};
    if (message.is_pickup_confirmation !== false) {
      obj.isPickupConfirmation = message.is_pickup_confirmation;
    }
    if (message.is_delivery_confirmation !== false) {
      obj.isDeliveryConfirmation = message.is_delivery_confirmation;
    }
    if (message.is_delivery_exception !== false) {
      obj.isDeliveryException = message.is_delivery_exception;
    }
    if (message.is_created !== false) {
      obj.isCreated = message.is_created;
    }
    if (message.is_out_for_delivery !== false) {
      obj.isOutForDelivery = message.is_out_for_delivery;
    }
    if (message.courier_ids?.length) {
      obj.courierIds = message.courier_ids;
    }
    if (message.team_ids?.length) {
      obj.teamIds = message.team_ids;
    }
    if (message.origin_ids?.length) {
      obj.originIds = message.origin_ids;
    }
    if (message.destination_ids?.length) {
      obj.destinationIds = message.destination_ids;
    }
    if (message.product_ids?.length) {
      obj.productIds = message.product_ids;
    }
    if (message.select_all !== false) {
      obj.selectAll = message.select_all;
    }
    if (message.select_all_teams !== false) {
      obj.selectAllTeams = message.select_all_teams;
    }
    if (message.select_all_origins !== false) {
      obj.selectAllOrigins = message.select_all_origins;
    }
    if (message.select_all_products !== false) {
      obj.selectAllProducts = message.select_all_products;
    }
    if (message.select_all_transport_providers !== false) {
      obj.selectAllTransportProviders = message.select_all_transport_providers;
    }
    if (message.select_all_destinations !== false) {
      obj.selectAllDestinations = message.select_all_destinations;
    }
    if (message.is_incomplete !== false) {
      obj.isIncomplete = message.is_incomplete;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StatusProgressTriggerData>, I>>(base?: I): StatusProgressTriggerData {
    return StatusProgressTriggerData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StatusProgressTriggerData>, I>>(object: I): StatusProgressTriggerData {
    const message = createBaseStatusProgressTriggerData();
    message.is_pickup_confirmation = object.is_pickup_confirmation ?? false;
    message.is_delivery_confirmation = object.is_delivery_confirmation ?? false;
    message.is_delivery_exception = object.is_delivery_exception ?? false;
    message.is_created = object.is_created ?? false;
    message.is_out_for_delivery = object.is_out_for_delivery ?? false;
    message.courier_ids = object.courier_ids?.map((e) => e) || [];
    message.team_ids = object.team_ids?.map((e) => e) || [];
    message.origin_ids = object.origin_ids?.map((e) => e) || [];
    message.destination_ids = object.destination_ids?.map((e) => e) || [];
    message.product_ids = object.product_ids?.map((e) => e) || [];
    message.select_all = object.select_all ?? false;
    message.select_all_teams = object.select_all_teams ?? false;
    message.select_all_origins = object.select_all_origins ?? false;
    message.select_all_products = object.select_all_products ?? false;
    message.select_all_transport_providers = object.select_all_transport_providers ?? false;
    message.select_all_destinations = object.select_all_destinations ?? false;
    message.is_incomplete = object.is_incomplete ?? false;
    return message;
  },
};

function createBaseInboundEventTriggerData(): InboundEventTriggerData {
  return { courier_ids: [], team_ids: [], origin_ids: [], destination_ids: [] };
}

export const InboundEventTriggerData: MessageFns<InboundEventTriggerData> = {
  encode(message: InboundEventTriggerData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.courier_ids) {
      writer.uint32(10).string(v!);
    }
    for (const v of message.team_ids) {
      writer.uint32(18).string(v!);
    }
    for (const v of message.origin_ids) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.destination_ids) {
      writer.uint32(34).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InboundEventTriggerData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseInboundEventTriggerData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.courier_ids.push(reader.string());
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.team_ids.push(reader.string());
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.origin_ids.push(reader.string());
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.destination_ids.push(reader.string());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): InboundEventTriggerData {
    return {
      courier_ids: globalThis.Array.isArray(object?.courierIds)
        ? object.courierIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.courier_ids)
        ? object.courier_ids.map((e: any) => globalThis.String(e))
        : [],
      team_ids: globalThis.Array.isArray(object?.teamIds)
        ? object.teamIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.team_ids)
        ? object.team_ids.map((e: any) => globalThis.String(e))
        : [],
      origin_ids: globalThis.Array.isArray(object?.originIds)
        ? object.originIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.origin_ids)
        ? object.origin_ids.map((e: any) => globalThis.String(e))
        : [],
      destination_ids: globalThis.Array.isArray(object?.destinationIds)
        ? object.destinationIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.destination_ids)
        ? object.destination_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: InboundEventTriggerData): unknown {
    const obj: any = {};
    if (message.courier_ids?.length) {
      obj.courierIds = message.courier_ids;
    }
    if (message.team_ids?.length) {
      obj.teamIds = message.team_ids;
    }
    if (message.origin_ids?.length) {
      obj.originIds = message.origin_ids;
    }
    if (message.destination_ids?.length) {
      obj.destinationIds = message.destination_ids;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InboundEventTriggerData>, I>>(base?: I): InboundEventTriggerData {
    return InboundEventTriggerData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InboundEventTriggerData>, I>>(object: I): InboundEventTriggerData {
    const message = createBaseInboundEventTriggerData();
    message.courier_ids = object.courier_ids?.map((e) => e) || [];
    message.team_ids = object.team_ids?.map((e) => e) || [];
    message.origin_ids = object.origin_ids?.map((e) => e) || [];
    message.destination_ids = object.destination_ids?.map((e) => e) || [];
    return message;
  },
};

function createBaseInboundTriggerData(): InboundTriggerData {
  return { inbound_event_type: "", phone_number: "", tracking_link_types: [] };
}

export const InboundTriggerData: MessageFns<InboundTriggerData> = {
  encode(message: InboundTriggerData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.inbound_event_type !== "") {
      writer.uint32(10).string(message.inbound_event_type);
    }
    if (message.phone_number !== "") {
      writer.uint32(18).string(message.phone_number);
    }
    for (const v of message.tracking_link_types) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InboundTriggerData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseInboundTriggerData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.inbound_event_type = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.phone_number = reader.string();
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.tracking_link_types.push(reader.string());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): InboundTriggerData {
    return {
      inbound_event_type: isSet(object.inboundEventType)
        ? globalThis.String(object.inboundEventType)
        : isSet(object.inbound_event_type)
        ? globalThis.String(object.inbound_event_type)
        : "",
      phone_number: isSet(object.phoneNumber)
        ? globalThis.String(object.phoneNumber)
        : isSet(object.phone_number)
        ? globalThis.String(object.phone_number)
        : "",
      tracking_link_types: globalThis.Array.isArray(object?.trackingLinkTypes)
        ? object.trackingLinkTypes.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.tracking_link_types)
        ? object.tracking_link_types.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: InboundTriggerData): unknown {
    const obj: any = {};
    if (message.inbound_event_type !== "") {
      obj.inboundEventType = message.inbound_event_type;
    }
    if (message.phone_number !== "") {
      obj.phoneNumber = message.phone_number;
    }
    if (message.tracking_link_types?.length) {
      obj.trackingLinkTypes = message.tracking_link_types;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InboundTriggerData>, I>>(base?: I): InboundTriggerData {
    return InboundTriggerData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InboundTriggerData>, I>>(object: I): InboundTriggerData {
    const message = createBaseInboundTriggerData();
    message.inbound_event_type = object.inbound_event_type ?? "";
    message.phone_number = object.phone_number ?? "";
    message.tracking_link_types = object.tracking_link_types?.map((e) => e) || [];
    return message;
  },
};

function createBaseInboundCallTriggerData(): InboundCallTriggerData {
  return { phone_number: "" };
}

export const InboundCallTriggerData: MessageFns<InboundCallTriggerData> = {
  encode(message: InboundCallTriggerData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.phone_number !== "") {
      writer.uint32(10).string(message.phone_number);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InboundCallTriggerData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseInboundCallTriggerData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.phone_number = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): InboundCallTriggerData {
    return {
      phone_number: isSet(object.phoneNumber)
        ? globalThis.String(object.phoneNumber)
        : isSet(object.phone_number)
        ? globalThis.String(object.phone_number)
        : "",
    };
  },

  toJSON(message: InboundCallTriggerData): unknown {
    const obj: any = {};
    if (message.phone_number !== "") {
      obj.phoneNumber = message.phone_number;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InboundCallTriggerData>, I>>(base?: I): InboundCallTriggerData {
    return InboundCallTriggerData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InboundCallTriggerData>, I>>(object: I): InboundCallTriggerData {
    const message = createBaseInboundCallTriggerData();
    message.phone_number = object.phone_number ?? "";
    return message;
  },
};

function createBaseDailySchedule(): DailySchedule {
  return { hour: 0, minute: 0 };
}

export const DailySchedule: MessageFns<DailySchedule> = {
  encode(message: DailySchedule, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.hour !== 0) {
      writer.uint32(8).int32(message.hour);
    }
    if (message.minute !== 0) {
      writer.uint32(16).int32(message.minute);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DailySchedule {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDailySchedule();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.hour = reader.int32();
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.minute = reader.int32();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): DailySchedule {
    return {
      hour: isSet(object.hour) ? globalThis.Number(object.hour) : 0,
      minute: isSet(object.minute) ? globalThis.Number(object.minute) : 0,
    };
  },

  toJSON(message: DailySchedule): unknown {
    const obj: any = {};
    if (message.hour !== 0) {
      obj.hour = Math.round(message.hour);
    }
    if (message.minute !== 0) {
      obj.minute = Math.round(message.minute);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DailySchedule>, I>>(base?: I): DailySchedule {
    return DailySchedule.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DailySchedule>, I>>(object: I): DailySchedule {
    const message = createBaseDailySchedule();
    message.hour = object.hour ?? 0;
    message.minute = object.minute ?? 0;
    return message;
  },
};

function createBaseDaysOfWeekSchedule(): DaysOfWeekSchedule {
  return { days_of_week: [], hour: 0, minute: 0 };
}

export const DaysOfWeekSchedule: MessageFns<DaysOfWeekSchedule> = {
  encode(message: DaysOfWeekSchedule, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.days_of_week.length !== 0) {
      writer.uint32(10).fork();
      for (const v of message.days_of_week) {
        writer.int32(v);
      }
      writer.join();
    }
    if (message.hour !== 0) {
      writer.uint32(16).int32(message.hour);
    }
    if (message.minute !== 0) {
      writer.uint32(24).int32(message.minute);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DaysOfWeekSchedule {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDaysOfWeekSchedule();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag === 8) {
              message.days_of_week.push(reader.int32() as any);

              continue;
            }

            if (tag === 10) {
              const end2 = reader.uint32() + reader.pos;
              while (reader.pos < end2) {
                message.days_of_week.push(reader.int32() as any);
              }

              continue;
            }

            break;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.hour = reader.int32();
            continue;
          }
          case 3: {
            if (tag !== 24) {
              break;
            }

            message.minute = reader.int32();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): DaysOfWeekSchedule {
    return {
      days_of_week: globalThis.Array.isArray(object?.daysOfWeek)
        ? object.daysOfWeek.map((e: any) => dayOfWeekFromJSON(e))
        : globalThis.Array.isArray(object?.days_of_week)
        ? object.days_of_week.map((e: any) => dayOfWeekFromJSON(e))
        : [],
      hour: isSet(object.hour) ? globalThis.Number(object.hour) : 0,
      minute: isSet(object.minute) ? globalThis.Number(object.minute) : 0,
    };
  },

  toJSON(message: DaysOfWeekSchedule): unknown {
    const obj: any = {};
    if (message.days_of_week?.length) {
      obj.daysOfWeek = message.days_of_week.map((e) => dayOfWeekToJSON(e));
    }
    if (message.hour !== 0) {
      obj.hour = Math.round(message.hour);
    }
    if (message.minute !== 0) {
      obj.minute = Math.round(message.minute);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DaysOfWeekSchedule>, I>>(base?: I): DaysOfWeekSchedule {
    return DaysOfWeekSchedule.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DaysOfWeekSchedule>, I>>(object: I): DaysOfWeekSchedule {
    const message = createBaseDaysOfWeekSchedule();
    message.days_of_week = object.days_of_week?.map((e) => e) || [];
    message.hour = object.hour ?? 0;
    message.minute = object.minute ?? 0;
    return message;
  },
};

function createBaseScheduleTriggerData(): ScheduleTriggerData {
  return { daily: undefined, days_of_week: undefined };
}

export const ScheduleTriggerData: MessageFns<ScheduleTriggerData> = {
  encode(message: ScheduleTriggerData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.daily !== undefined) {
      DailySchedule.encode(message.daily, writer.uint32(10).fork()).join();
    }
    if (message.days_of_week !== undefined) {
      DaysOfWeekSchedule.encode(message.days_of_week, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScheduleTriggerData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseScheduleTriggerData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.daily = DailySchedule.decode(reader, reader.uint32());
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.days_of_week = DaysOfWeekSchedule.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): ScheduleTriggerData {
    return {
      daily: isSet(object.daily) ? DailySchedule.fromJSON(object.daily) : undefined,
      days_of_week: isSet(object.daysOfWeek)
        ? DaysOfWeekSchedule.fromJSON(object.daysOfWeek)
        : isSet(object.days_of_week)
        ? DaysOfWeekSchedule.fromJSON(object.days_of_week)
        : undefined,
    };
  },

  toJSON(message: ScheduleTriggerData): unknown {
    const obj: any = {};
    if (message.daily !== undefined) {
      obj.daily = DailySchedule.toJSON(message.daily);
    }
    if (message.days_of_week !== undefined) {
      obj.daysOfWeek = DaysOfWeekSchedule.toJSON(message.days_of_week);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScheduleTriggerData>, I>>(base?: I): ScheduleTriggerData {
    return ScheduleTriggerData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScheduleTriggerData>, I>>(object: I): ScheduleTriggerData {
    const message = createBaseScheduleTriggerData();
    message.daily = (object.daily !== undefined && object.daily !== null)
      ? DailySchedule.fromPartial(object.daily)
      : undefined;
    message.days_of_week = (object.days_of_week !== undefined && object.days_of_week !== null)
      ? DaysOfWeekSchedule.fromPartial(object.days_of_week)
      : undefined;
    return message;
  },
};

function createBaseTimeOfDay(): TimeOfDay {
  return { hour: 0, minute: 0 };
}

export const TimeOfDay: MessageFns<TimeOfDay> = {
  encode(message: TimeOfDay, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.hour !== 0) {
      writer.uint32(8).int32(message.hour);
    }
    if (message.minute !== 0) {
      writer.uint32(16).int32(message.minute);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TimeOfDay {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseTimeOfDay();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.hour = reader.int32();
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.minute = reader.int32();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): TimeOfDay {
    return {
      hour: isSet(object.hour) ? globalThis.Number(object.hour) : 0,
      minute: isSet(object.minute) ? globalThis.Number(object.minute) : 0,
    };
  },

  toJSON(message: TimeOfDay): unknown {
    const obj: any = {};
    if (message.hour !== 0) {
      obj.hour = Math.round(message.hour);
    }
    if (message.minute !== 0) {
      obj.minute = Math.round(message.minute);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TimeOfDay>, I>>(base?: I): TimeOfDay {
    return TimeOfDay.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TimeOfDay>, I>>(object: I): TimeOfDay {
    const message = createBaseTimeOfDay();
    message.hour = object.hour ?? 0;
    message.minute = object.minute ?? 0;
    return message;
  },
};

function createBaseScheduleTriggerV2Data(): ScheduleTriggerV2Data {
  return { repeat_interval: 0, repeat_every: 0, days_of_week: [], days_of_month: [], schedule_times: [], timezone: "" };
}

export const ScheduleTriggerV2Data: MessageFns<ScheduleTriggerV2Data> = {
  encode(message: ScheduleTriggerV2Data, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.repeat_interval !== 0) {
      writer.uint32(8).int32(message.repeat_interval);
    }
    if (message.repeat_every !== 0) {
      writer.uint32(16).int32(message.repeat_every);
    }
    if (message.days_of_week.length !== 0) {
      writer.uint32(26).fork();
      for (const v of message.days_of_week) {
        writer.int32(v);
      }
      writer.join();
    }
    if (message.days_of_month.length !== 0) {
      writer.uint32(34).fork();
      for (const v of message.days_of_month) {
        writer.int32(v);
      }
      writer.join();
    }
    for (const v of message.schedule_times) {
      TimeOfDay.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.timezone !== "") {
      writer.uint32(50).string(message.timezone);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScheduleTriggerV2Data {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseScheduleTriggerV2Data();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.repeat_interval = reader.int32();
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.repeat_every = reader.int32() as any;
            continue;
          }
          case 3: {
            if (tag === 24) {
              message.days_of_week.push(reader.int32() as any);

              continue;
            }

            if (tag === 26) {
              const end2 = reader.uint32() + reader.pos;
              while (reader.pos < end2) {
                message.days_of_week.push(reader.int32() as any);
              }

              continue;
            }

            break;
          }
          case 4: {
            if (tag === 32) {
              message.days_of_month.push(reader.int32());

              continue;
            }

            if (tag === 34) {
              const end2 = reader.uint32() + reader.pos;
              while (reader.pos < end2) {
                message.days_of_month.push(reader.int32());
              }

              continue;
            }

            break;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.schedule_times.push(TimeOfDay.decode(reader, reader.uint32()));
            continue;
          }
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.timezone = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): ScheduleTriggerV2Data {
    return {
      repeat_interval: isSet(object.repeatInterval)
        ? globalThis.Number(object.repeatInterval)
        : isSet(object.repeat_interval)
        ? globalThis.Number(object.repeat_interval)
        : 0,
      repeat_every: isSet(object.repeatEvery)
        ? repeatUnitFromJSON(object.repeatEvery)
        : isSet(object.repeat_every)
        ? repeatUnitFromJSON(object.repeat_every)
        : 0,
      days_of_week: globalThis.Array.isArray(object?.daysOfWeek)
        ? object.daysOfWeek.map((e: any) => dayOfWeekFromJSON(e))
        : globalThis.Array.isArray(object?.days_of_week)
        ? object.days_of_week.map((e: any) => dayOfWeekFromJSON(e))
        : [],
      days_of_month: globalThis.Array.isArray(object?.daysOfMonth)
        ? object.daysOfMonth.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.days_of_month)
        ? object.days_of_month.map((e: any) => globalThis.Number(e))
        : [],
      schedule_times: globalThis.Array.isArray(object?.scheduleTimes)
        ? object.scheduleTimes.map((e: any) => TimeOfDay.fromJSON(e))
        : globalThis.Array.isArray(object?.schedule_times)
        ? object.schedule_times.map((e: any) => TimeOfDay.fromJSON(e))
        : [],
      timezone: isSet(object.timezone) ? globalThis.String(object.timezone) : "",
    };
  },

  toJSON(message: ScheduleTriggerV2Data): unknown {
    const obj: any = {};
    if (message.repeat_interval !== 0) {
      obj.repeatInterval = Math.round(message.repeat_interval);
    }
    if (message.repeat_every !== 0) {
      obj.repeatEvery = repeatUnitToJSON(message.repeat_every);
    }
    if (message.days_of_week?.length) {
      obj.daysOfWeek = message.days_of_week.map((e) => dayOfWeekToJSON(e));
    }
    if (message.days_of_month?.length) {
      obj.daysOfMonth = message.days_of_month.map((e) => Math.round(e));
    }
    if (message.schedule_times?.length) {
      obj.scheduleTimes = message.schedule_times.map((e) => TimeOfDay.toJSON(e));
    }
    if (message.timezone !== "") {
      obj.timezone = message.timezone;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScheduleTriggerV2Data>, I>>(base?: I): ScheduleTriggerV2Data {
    return ScheduleTriggerV2Data.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScheduleTriggerV2Data>, I>>(object: I): ScheduleTriggerV2Data {
    const message = createBaseScheduleTriggerV2Data();
    message.repeat_interval = object.repeat_interval ?? 0;
    message.repeat_every = object.repeat_every ?? 0;
    message.days_of_week = object.days_of_week?.map((e) => e) || [];
    message.days_of_month = object.days_of_month?.map((e) => e) || [];
    message.schedule_times = object.schedule_times?.map((e) => TimeOfDay.fromPartial(e)) || [];
    message.timezone = object.timezone ?? "";
    return message;
  },
};

function createBaseAICallActionData(): AICallActionData {
  return {
    channel_type: 0,
    agent_type: 0,
    agent_id: "",
    contact_id: "",
    pca_variable_names: [],
    is_inbound_agent: false,
    collect_shipment_id: false,
    is_transfer_escalation: false,
    reply_wait_seconds: 0,
    dont_wait: false,
  };
}

export const AICallActionData: MessageFns<AICallActionData> = {
  encode(message: AICallActionData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.channel_type !== 0) {
      writer.uint32(8).int32(message.channel_type);
    }
    if (message.agent_type !== 0) {
      writer.uint32(16).int32(message.agent_type);
    }
    if (message.agent_id !== "") {
      writer.uint32(26).string(message.agent_id);
    }
    if (message.contact_id !== "") {
      writer.uint32(42).string(message.contact_id);
    }
    for (const v of message.pca_variable_names) {
      writer.uint32(50).string(v!);
    }
    if (message.is_inbound_agent !== false) {
      writer.uint32(56).bool(message.is_inbound_agent);
    }
    if (message.collect_shipment_id !== false) {
      writer.uint32(64).bool(message.collect_shipment_id);
    }
    if (message.is_transfer_escalation !== false) {
      writer.uint32(72).bool(message.is_transfer_escalation);
    }
    if (message.reply_wait_seconds !== 0) {
      writer.uint32(80).int32(message.reply_wait_seconds);
    }
    if (message.dont_wait !== false) {
      writer.uint32(88).bool(message.dont_wait);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AICallActionData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseAICallActionData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.channel_type = reader.int32() as any;
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.agent_type = reader.int32() as any;
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.agent_id = reader.string();
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.contact_id = reader.string();
            continue;
          }
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.pca_variable_names.push(reader.string());
            continue;
          }
          case 7: {
            if (tag !== 56) {
              break;
            }

            message.is_inbound_agent = reader.bool();
            continue;
          }
          case 8: {
            if (tag !== 64) {
              break;
            }

            message.collect_shipment_id = reader.bool();
            continue;
          }
          case 9: {
            if (tag !== 72) {
              break;
            }

            message.is_transfer_escalation = reader.bool();
            continue;
          }
          case 10: {
            if (tag !== 80) {
              break;
            }

            message.reply_wait_seconds = reader.int32();
            continue;
          }
          case 11: {
            if (tag !== 88) {
              break;
            }

            message.dont_wait = reader.bool();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): AICallActionData {
    return {
      channel_type: isSet(object.channelType)
        ? aIChannelTypeFromJSON(object.channelType)
        : isSet(object.channel_type)
        ? aIChannelTypeFromJSON(object.channel_type)
        : 0,
      agent_type: isSet(object.agentType)
        ? aIAgentTypeFromJSON(object.agentType)
        : isSet(object.agent_type)
        ? aIAgentTypeFromJSON(object.agent_type)
        : 0,
      agent_id: isSet(object.agentId)
        ? globalThis.String(object.agentId)
        : isSet(object.agent_id)
        ? globalThis.String(object.agent_id)
        : "",
      contact_id: isSet(object.contactId)
        ? globalThis.String(object.contactId)
        : isSet(object.contact_id)
        ? globalThis.String(object.contact_id)
        : "",
      pca_variable_names: globalThis.Array.isArray(object?.pcaVariableNames)
        ? object.pcaVariableNames.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.pca_variable_names)
        ? object.pca_variable_names.map((e: any) => globalThis.String(e))
        : [],
      is_inbound_agent: isSet(object.isInboundAgent)
        ? globalThis.Boolean(object.isInboundAgent)
        : isSet(object.is_inbound_agent)
        ? globalThis.Boolean(object.is_inbound_agent)
        : false,
      collect_shipment_id: isSet(object.collectShipmentId)
        ? globalThis.Boolean(object.collectShipmentId)
        : isSet(object.collect_shipment_id)
        ? globalThis.Boolean(object.collect_shipment_id)
        : false,
      is_transfer_escalation: isSet(object.isTransferEscalation)
        ? globalThis.Boolean(object.isTransferEscalation)
        : isSet(object.is_transfer_escalation)
        ? globalThis.Boolean(object.is_transfer_escalation)
        : false,
      reply_wait_seconds: isSet(object.replyWaitSeconds)
        ? globalThis.Number(object.replyWaitSeconds)
        : isSet(object.reply_wait_seconds)
        ? globalThis.Number(object.reply_wait_seconds)
        : 0,
      dont_wait: isSet(object.dontWait)
        ? globalThis.Boolean(object.dontWait)
        : isSet(object.dont_wait)
        ? globalThis.Boolean(object.dont_wait)
        : false,
    };
  },

  toJSON(message: AICallActionData): unknown {
    const obj: any = {};
    if (message.channel_type !== 0) {
      obj.channelType = aIChannelTypeToJSON(message.channel_type);
    }
    if (message.agent_type !== 0) {
      obj.agentType = aIAgentTypeToJSON(message.agent_type);
    }
    if (message.agent_id !== "") {
      obj.agentId = message.agent_id;
    }
    if (message.contact_id !== "") {
      obj.contactId = message.contact_id;
    }
    if (message.pca_variable_names?.length) {
      obj.pcaVariableNames = message.pca_variable_names;
    }
    if (message.is_inbound_agent !== false) {
      obj.isInboundAgent = message.is_inbound_agent;
    }
    if (message.collect_shipment_id !== false) {
      obj.collectShipmentId = message.collect_shipment_id;
    }
    if (message.is_transfer_escalation !== false) {
      obj.isTransferEscalation = message.is_transfer_escalation;
    }
    if (message.reply_wait_seconds !== 0) {
      obj.replyWaitSeconds = Math.round(message.reply_wait_seconds);
    }
    if (message.dont_wait !== false) {
      obj.dontWait = message.dont_wait;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AICallActionData>, I>>(base?: I): AICallActionData {
    return AICallActionData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AICallActionData>, I>>(object: I): AICallActionData {
    const message = createBaseAICallActionData();
    message.channel_type = object.channel_type ?? 0;
    message.agent_type = object.agent_type ?? 0;
    message.agent_id = object.agent_id ?? "";
    message.contact_id = object.contact_id ?? "";
    message.pca_variable_names = object.pca_variable_names?.map((e) => e) || [];
    message.is_inbound_agent = object.is_inbound_agent ?? false;
    message.collect_shipment_id = object.collect_shipment_id ?? false;
    message.is_transfer_escalation = object.is_transfer_escalation ?? false;
    message.reply_wait_seconds = object.reply_wait_seconds ?? 0;
    message.dont_wait = object.dont_wait ?? false;
    return message;
  },
};

function createBaseSlackActionData(): SlackActionData {
  return { message_chunks: [], recipient_team_ids: [] };
}

export const SlackActionData: MessageFns<SlackActionData> = {
  encode(message: SlackActionData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.message_chunks) {
      TextTemplateChunk.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.recipient_team_ids) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SlackActionData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseSlackActionData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.message_chunks.push(TextTemplateChunk.decode(reader, reader.uint32()));
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.recipient_team_ids.push(reader.string());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): SlackActionData {
    return {
      message_chunks: globalThis.Array.isArray(object?.messageChunks)
        ? object.messageChunks.map((e: any) => TextTemplateChunk.fromJSON(e))
        : globalThis.Array.isArray(object?.message_chunks)
        ? object.message_chunks.map((e: any) => TextTemplateChunk.fromJSON(e))
        : [],
      recipient_team_ids: globalThis.Array.isArray(object?.recipientTeamIds)
        ? object.recipientTeamIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.recipient_team_ids)
        ? object.recipient_team_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: SlackActionData): unknown {
    const obj: any = {};
    if (message.message_chunks?.length) {
      obj.messageChunks = message.message_chunks.map((e) => TextTemplateChunk.toJSON(e));
    }
    if (message.recipient_team_ids?.length) {
      obj.recipientTeamIds = message.recipient_team_ids;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SlackActionData>, I>>(base?: I): SlackActionData {
    return SlackActionData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SlackActionData>, I>>(object: I): SlackActionData {
    const message = createBaseSlackActionData();
    message.message_chunks = object.message_chunks?.map((e) => TextTemplateChunk.fromPartial(e)) || [];
    message.recipient_team_ids = object.recipient_team_ids?.map((e) => e) || [];
    return message;
  },
};

function createBaseTeamsNotificationData(): TeamsNotificationData {
  return {
    message_chunks: [],
    recipient_team_ids: [],
    frequency: undefined,
    day: undefined,
    time1: undefined,
    time2: undefined,
  };
}

export const TeamsNotificationData: MessageFns<TeamsNotificationData> = {
  encode(message: TeamsNotificationData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.message_chunks) {
      TextTemplateChunk.encode(v!, writer.uint32(58).fork()).join();
    }
    for (const v of message.recipient_team_ids) {
      writer.uint32(18).string(v!);
    }
    if (message.frequency !== undefined) {
      writer.uint32(26).string(message.frequency);
    }
    if (message.day !== undefined) {
      writer.uint32(34).string(message.day);
    }
    if (message.time1 !== undefined) {
      writer.uint32(42).string(message.time1);
    }
    if (message.time2 !== undefined) {
      writer.uint32(50).string(message.time2);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TeamsNotificationData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseTeamsNotificationData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 7: {
            if (tag !== 58) {
              break;
            }

            message.message_chunks.push(TextTemplateChunk.decode(reader, reader.uint32()));
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.recipient_team_ids.push(reader.string());
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.frequency = reader.string();
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.day = reader.string();
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.time1 = reader.string();
            continue;
          }
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.time2 = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): TeamsNotificationData {
    return {
      message_chunks: globalThis.Array.isArray(object?.messageChunks)
        ? object.messageChunks.map((e: any) => TextTemplateChunk.fromJSON(e))
        : globalThis.Array.isArray(object?.message_chunks)
        ? object.message_chunks.map((e: any) => TextTemplateChunk.fromJSON(e))
        : [],
      recipient_team_ids: globalThis.Array.isArray(object?.recipientTeamIds)
        ? object.recipientTeamIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.recipient_team_ids)
        ? object.recipient_team_ids.map((e: any) => globalThis.String(e))
        : [],
      frequency: isSet(object.frequency) ? globalThis.String(object.frequency) : undefined,
      day: isSet(object.day) ? globalThis.String(object.day) : undefined,
      time1: isSet(object.time1) ? globalThis.String(object.time1) : undefined,
      time2: isSet(object.time2) ? globalThis.String(object.time2) : undefined,
    };
  },

  toJSON(message: TeamsNotificationData): unknown {
    const obj: any = {};
    if (message.message_chunks?.length) {
      obj.messageChunks = message.message_chunks.map((e) => TextTemplateChunk.toJSON(e));
    }
    if (message.recipient_team_ids?.length) {
      obj.recipientTeamIds = message.recipient_team_ids;
    }
    if (message.frequency !== undefined) {
      obj.frequency = message.frequency;
    }
    if (message.day !== undefined) {
      obj.day = message.day;
    }
    if (message.time1 !== undefined) {
      obj.time1 = message.time1;
    }
    if (message.time2 !== undefined) {
      obj.time2 = message.time2;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TeamsNotificationData>, I>>(base?: I): TeamsNotificationData {
    return TeamsNotificationData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TeamsNotificationData>, I>>(object: I): TeamsNotificationData {
    const message = createBaseTeamsNotificationData();
    message.message_chunks = object.message_chunks?.map((e) => TextTemplateChunk.fromPartial(e)) || [];
    message.recipient_team_ids = object.recipient_team_ids?.map((e) => e) || [];
    message.frequency = object.frequency ?? undefined;
    message.day = object.day ?? undefined;
    message.time1 = object.time1 ?? undefined;
    message.time2 = object.time2 ?? undefined;
    return message;
  },
};

function createBaseEmailActionData(): EmailActionData {
  return { to: [], cc: [], bcc: [], subject_chunks: [], body_chunks: [], send_mode: undefined };
}

export const EmailActionData: MessageFns<EmailActionData> = {
  encode(message: EmailActionData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.to) {
      TeamNotifRecipients.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.cc) {
      TeamNotifRecipients.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.bcc) {
      TeamNotifRecipients.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.subject_chunks) {
      TextTemplateChunk.encode(v!, writer.uint32(58).fork()).join();
    }
    for (const v of message.body_chunks) {
      TextTemplateChunk.encode(v!, writer.uint32(66).fork()).join();
    }
    if (message.send_mode !== undefined) {
      writer.uint32(50).string(message.send_mode);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EmailActionData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseEmailActionData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.to.push(TeamNotifRecipients.decode(reader, reader.uint32()));
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.cc.push(TeamNotifRecipients.decode(reader, reader.uint32()));
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.bcc.push(TeamNotifRecipients.decode(reader, reader.uint32()));
            continue;
          }
          case 7: {
            if (tag !== 58) {
              break;
            }

            message.subject_chunks.push(TextTemplateChunk.decode(reader, reader.uint32()));
            continue;
          }
          case 8: {
            if (tag !== 66) {
              break;
            }

            message.body_chunks.push(TextTemplateChunk.decode(reader, reader.uint32()));
            continue;
          }
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.send_mode = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): EmailActionData {
    return {
      to: globalThis.Array.isArray(object?.to) ? object.to.map((e: any) => TeamNotifRecipients.fromJSON(e)) : [],
      cc: globalThis.Array.isArray(object?.cc) ? object.cc.map((e: any) => TeamNotifRecipients.fromJSON(e)) : [],
      bcc: globalThis.Array.isArray(object?.bcc) ? object.bcc.map((e: any) => TeamNotifRecipients.fromJSON(e)) : [],
      subject_chunks: globalThis.Array.isArray(object?.subjectChunks)
        ? object.subjectChunks.map((e: any) => TextTemplateChunk.fromJSON(e))
        : globalThis.Array.isArray(object?.subject_chunks)
        ? object.subject_chunks.map((e: any) => TextTemplateChunk.fromJSON(e))
        : [],
      body_chunks: globalThis.Array.isArray(object?.bodyChunks)
        ? object.bodyChunks.map((e: any) => TextTemplateChunk.fromJSON(e))
        : globalThis.Array.isArray(object?.body_chunks)
        ? object.body_chunks.map((e: any) => TextTemplateChunk.fromJSON(e))
        : [],
      send_mode: isSet(object.sendMode)
        ? globalThis.String(object.sendMode)
        : isSet(object.send_mode)
        ? globalThis.String(object.send_mode)
        : undefined,
    };
  },

  toJSON(message: EmailActionData): unknown {
    const obj: any = {};
    if (message.to?.length) {
      obj.to = message.to.map((e) => TeamNotifRecipients.toJSON(e));
    }
    if (message.cc?.length) {
      obj.cc = message.cc.map((e) => TeamNotifRecipients.toJSON(e));
    }
    if (message.bcc?.length) {
      obj.bcc = message.bcc.map((e) => TeamNotifRecipients.toJSON(e));
    }
    if (message.subject_chunks?.length) {
      obj.subjectChunks = message.subject_chunks.map((e) => TextTemplateChunk.toJSON(e));
    }
    if (message.body_chunks?.length) {
      obj.bodyChunks = message.body_chunks.map((e) => TextTemplateChunk.toJSON(e));
    }
    if (message.send_mode !== undefined) {
      obj.sendMode = message.send_mode;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EmailActionData>, I>>(base?: I): EmailActionData {
    return EmailActionData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EmailActionData>, I>>(object: I): EmailActionData {
    const message = createBaseEmailActionData();
    message.to = object.to?.map((e) => TeamNotifRecipients.fromPartial(e)) || [];
    message.cc = object.cc?.map((e) => TeamNotifRecipients.fromPartial(e)) || [];
    message.bcc = object.bcc?.map((e) => TeamNotifRecipients.fromPartial(e)) || [];
    message.subject_chunks = object.subject_chunks?.map((e) => TextTemplateChunk.fromPartial(e)) || [];
    message.body_chunks = object.body_chunks?.map((e) => TextTemplateChunk.fromPartial(e)) || [];
    message.send_mode = object.send_mode ?? undefined;
    return message;
  },
};

function createBaseTeamNotifRecipients(): TeamNotifRecipients {
  return { team_id: "", select_all: false, user_ids: [], additional_recipients: [], is_additional: undefined };
}

export const TeamNotifRecipients: MessageFns<TeamNotifRecipients> = {
  encode(message: TeamNotifRecipients, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.team_id !== "") {
      writer.uint32(10).string(message.team_id);
    }
    if (message.select_all !== false) {
      writer.uint32(16).bool(message.select_all);
    }
    for (const v of message.user_ids) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.additional_recipients) {
      writer.uint32(34).string(v!);
    }
    if (message.is_additional !== undefined) {
      writer.uint32(40).bool(message.is_additional);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TeamNotifRecipients {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseTeamNotifRecipients();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.team_id = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.select_all = reader.bool();
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.user_ids.push(reader.string());
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.additional_recipients.push(reader.string());
            continue;
          }
          case 5: {
            if (tag !== 40) {
              break;
            }

            message.is_additional = reader.bool();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): TeamNotifRecipients {
    return {
      team_id: isSet(object.teamId)
        ? globalThis.String(object.teamId)
        : isSet(object.team_id)
        ? globalThis.String(object.team_id)
        : "",
      select_all: isSet(object.selectAll)
        ? globalThis.Boolean(object.selectAll)
        : isSet(object.select_all)
        ? globalThis.Boolean(object.select_all)
        : false,
      user_ids: globalThis.Array.isArray(object?.userIds)
        ? object.userIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.user_ids)
        ? object.user_ids.map((e: any) => globalThis.String(e))
        : [],
      additional_recipients: globalThis.Array.isArray(object?.additionalRecipients)
        ? object.additionalRecipients.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.additional_recipients)
        ? object.additional_recipients.map((e: any) => globalThis.String(e))
        : [],
      is_additional: isSet(object.isAdditional)
        ? globalThis.Boolean(object.isAdditional)
        : isSet(object.is_additional)
        ? globalThis.Boolean(object.is_additional)
        : undefined,
    };
  },

  toJSON(message: TeamNotifRecipients): unknown {
    const obj: any = {};
    if (message.team_id !== "") {
      obj.teamId = message.team_id;
    }
    if (message.select_all !== false) {
      obj.selectAll = message.select_all;
    }
    if (message.user_ids?.length) {
      obj.userIds = message.user_ids;
    }
    if (message.additional_recipients?.length) {
      obj.additionalRecipients = message.additional_recipients;
    }
    if (message.is_additional !== undefined) {
      obj.isAdditional = message.is_additional;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TeamNotifRecipients>, I>>(base?: I): TeamNotifRecipients {
    return TeamNotifRecipients.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TeamNotifRecipients>, I>>(object: I): TeamNotifRecipients {
    const message = createBaseTeamNotifRecipients();
    message.team_id = object.team_id ?? "";
    message.select_all = object.select_all ?? false;
    message.user_ids = object.user_ids?.map((e) => e) || [];
    message.additional_recipients = object.additional_recipients?.map((e) => e) || [];
    message.is_additional = object.is_additional ?? undefined;
    return message;
  },
};

function createBaseSmsActionData(): SmsActionData {
  return { phone: "", message_chunks: [], contact_id: "", wait_for_response: false, update_coc: false };
}

export const SmsActionData: MessageFns<SmsActionData> = {
  encode(message: SmsActionData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.phone !== "") {
      writer.uint32(10).string(message.phone);
    }
    for (const v of message.message_chunks) {
      TextTemplateChunk.encode(v!, writer.uint32(58).fork()).join();
    }
    if (message.contact_id !== "") {
      writer.uint32(26).string(message.contact_id);
    }
    if (message.wait_for_response !== false) {
      writer.uint32(32).bool(message.wait_for_response);
    }
    if (message.update_coc !== false) {
      writer.uint32(48).bool(message.update_coc);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SmsActionData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseSmsActionData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.phone = reader.string();
            continue;
          }
          case 7: {
            if (tag !== 58) {
              break;
            }

            message.message_chunks.push(TextTemplateChunk.decode(reader, reader.uint32()));
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.contact_id = reader.string();
            continue;
          }
          case 4: {
            if (tag !== 32) {
              break;
            }

            message.wait_for_response = reader.bool();
            continue;
          }
          case 6: {
            if (tag !== 48) {
              break;
            }

            message.update_coc = reader.bool();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): SmsActionData {
    return {
      phone: isSet(object.phone) ? globalThis.String(object.phone) : "",
      message_chunks: globalThis.Array.isArray(object?.messageChunks)
        ? object.messageChunks.map((e: any) => TextTemplateChunk.fromJSON(e))
        : globalThis.Array.isArray(object?.message_chunks)
        ? object.message_chunks.map((e: any) => TextTemplateChunk.fromJSON(e))
        : [],
      contact_id: isSet(object.contactId)
        ? globalThis.String(object.contactId)
        : isSet(object.contact_id)
        ? globalThis.String(object.contact_id)
        : "",
      wait_for_response: isSet(object.waitForResponse)
        ? globalThis.Boolean(object.waitForResponse)
        : isSet(object.wait_for_response)
        ? globalThis.Boolean(object.wait_for_response)
        : false,
      update_coc: isSet(object.updateCoc)
        ? globalThis.Boolean(object.updateCoc)
        : isSet(object.update_coc)
        ? globalThis.Boolean(object.update_coc)
        : false,
    };
  },

  toJSON(message: SmsActionData): unknown {
    const obj: any = {};
    if (message.phone !== "") {
      obj.phone = message.phone;
    }
    if (message.message_chunks?.length) {
      obj.messageChunks = message.message_chunks.map((e) => TextTemplateChunk.toJSON(e));
    }
    if (message.contact_id !== "") {
      obj.contactId = message.contact_id;
    }
    if (message.wait_for_response !== false) {
      obj.waitForResponse = message.wait_for_response;
    }
    if (message.update_coc !== false) {
      obj.updateCoc = message.update_coc;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SmsActionData>, I>>(base?: I): SmsActionData {
    return SmsActionData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SmsActionData>, I>>(object: I): SmsActionData {
    const message = createBaseSmsActionData();
    message.phone = object.phone ?? "";
    message.message_chunks = object.message_chunks?.map((e) => TextTemplateChunk.fromPartial(e)) || [];
    message.contact_id = object.contact_id ?? "";
    message.wait_for_response = object.wait_for_response ?? false;
    message.update_coc = object.update_coc ?? false;
    return message;
  },
};

function createBaseResolveAlertActionData(): ResolveAlertActionData {
  return {
    alert_status: "",
    comment_chunks: [],
    alert_types: [],
    select_all_alert_types: false,
    shipment_id: undefined,
  };
}

export const ResolveAlertActionData: MessageFns<ResolveAlertActionData> = {
  encode(message: ResolveAlertActionData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.alert_status !== "") {
      writer.uint32(10).string(message.alert_status);
    }
    for (const v of message.comment_chunks) {
      TextTemplateChunk.encode(v!, writer.uint32(66).fork()).join();
    }
    for (const v of message.alert_types) {
      writer.uint32(42).string(v!);
    }
    if (message.select_all_alert_types !== false) {
      writer.uint32(48).bool(message.select_all_alert_types);
    }
    if (message.shipment_id !== undefined) {
      VariableRef.encode(message.shipment_id, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResolveAlertActionData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseResolveAlertActionData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.alert_status = reader.string();
            continue;
          }
          case 8: {
            if (tag !== 66) {
              break;
            }

            message.comment_chunks.push(TextTemplateChunk.decode(reader, reader.uint32()));
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.alert_types.push(reader.string());
            continue;
          }
          case 6: {
            if (tag !== 48) {
              break;
            }

            message.select_all_alert_types = reader.bool();
            continue;
          }
          case 7: {
            if (tag !== 58) {
              break;
            }

            message.shipment_id = VariableRef.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): ResolveAlertActionData {
    return {
      alert_status: isSet(object.alertStatus)
        ? globalThis.String(object.alertStatus)
        : isSet(object.alert_status)
        ? globalThis.String(object.alert_status)
        : "",
      comment_chunks: globalThis.Array.isArray(object?.commentChunks)
        ? object.commentChunks.map((e: any) => TextTemplateChunk.fromJSON(e))
        : globalThis.Array.isArray(object?.comment_chunks)
        ? object.comment_chunks.map((e: any) => TextTemplateChunk.fromJSON(e))
        : [],
      alert_types: globalThis.Array.isArray(object?.alertTypes)
        ? object.alertTypes.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.alert_types)
        ? object.alert_types.map((e: any) => globalThis.String(e))
        : [],
      select_all_alert_types: isSet(object.selectAllAlertTypes)
        ? globalThis.Boolean(object.selectAllAlertTypes)
        : isSet(object.select_all_alert_types)
        ? globalThis.Boolean(object.select_all_alert_types)
        : false,
      shipment_id: isSet(object.shipmentId)
        ? VariableRef.fromJSON(object.shipmentId)
        : isSet(object.shipment_id)
        ? VariableRef.fromJSON(object.shipment_id)
        : undefined,
    };
  },

  toJSON(message: ResolveAlertActionData): unknown {
    const obj: any = {};
    if (message.alert_status !== "") {
      obj.alertStatus = message.alert_status;
    }
    if (message.comment_chunks?.length) {
      obj.commentChunks = message.comment_chunks.map((e) => TextTemplateChunk.toJSON(e));
    }
    if (message.alert_types?.length) {
      obj.alertTypes = message.alert_types;
    }
    if (message.select_all_alert_types !== false) {
      obj.selectAllAlertTypes = message.select_all_alert_types;
    }
    if (message.shipment_id !== undefined) {
      obj.shipmentId = VariableRef.toJSON(message.shipment_id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ResolveAlertActionData>, I>>(base?: I): ResolveAlertActionData {
    return ResolveAlertActionData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ResolveAlertActionData>, I>>(object: I): ResolveAlertActionData {
    const message = createBaseResolveAlertActionData();
    message.alert_status = object.alert_status ?? "";
    message.comment_chunks = object.comment_chunks?.map((e) => TextTemplateChunk.fromPartial(e)) || [];
    message.alert_types = object.alert_types?.map((e) => e) || [];
    message.select_all_alert_types = object.select_all_alert_types ?? false;
    message.shipment_id = (object.shipment_id !== undefined && object.shipment_id !== null)
      ? VariableRef.fromPartial(object.shipment_id)
      : undefined;
    return message;
  },
};

function createBasePathsData(): PathsData {
  return {};
}

export const PathsData: MessageFns<PathsData> = {
  encode(_: PathsData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PathsData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBasePathsData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(_: any): PathsData {
    return {};
  },

  toJSON(_: PathsData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<PathsData>, I>>(base?: I): PathsData {
    return PathsData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PathsData>, I>>(_: I): PathsData {
    const message = createBasePathsData();
    return message;
  },
};

function createBaseGenerateTranscriptActionData(): GenerateTranscriptActionData {
  return {};
}

export const GenerateTranscriptActionData: MessageFns<GenerateTranscriptActionData> = {
  encode(_: GenerateTranscriptActionData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateTranscriptActionData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseGenerateTranscriptActionData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(_: any): GenerateTranscriptActionData {
    return {};
  },

  toJSON(_: GenerateTranscriptActionData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GenerateTranscriptActionData>, I>>(base?: I): GenerateTranscriptActionData {
    return GenerateTranscriptActionData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GenerateTranscriptActionData>, I>>(_: I): GenerateTranscriptActionData {
    const message = createBaseGenerateTranscriptActionData();
    return message;
  },
};

function createBaseWebhookHeader(): WebhookHeader {
  return { key: "", value_chunks: [] };
}

export const WebhookHeader: MessageFns<WebhookHeader> = {
  encode(message: WebhookHeader, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    for (const v of message.value_chunks) {
      TextTemplateChunk.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WebhookHeader {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseWebhookHeader();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.key = reader.string();
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.value_chunks.push(TextTemplateChunk.decode(reader, reader.uint32()));
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): WebhookHeader {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value_chunks: globalThis.Array.isArray(object?.valueChunks)
        ? object.valueChunks.map((e: any) => TextTemplateChunk.fromJSON(e))
        : globalThis.Array.isArray(object?.value_chunks)
        ? object.value_chunks.map((e: any) => TextTemplateChunk.fromJSON(e))
        : [],
    };
  },

  toJSON(message: WebhookHeader): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value_chunks?.length) {
      obj.valueChunks = message.value_chunks.map((e) => TextTemplateChunk.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WebhookHeader>, I>>(base?: I): WebhookHeader {
    return WebhookHeader.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WebhookHeader>, I>>(object: I): WebhookHeader {
    const message = createBaseWebhookHeader();
    message.key = object.key ?? "";
    message.value_chunks = object.value_chunks?.map((e) => TextTemplateChunk.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRetryPolicy(): RetryPolicy {
  return { max_attempts: 0, initial_backoff_seconds: 0, backoff_multiplier: 0, max_backoff_seconds: 0 };
}

export const RetryPolicy: MessageFns<RetryPolicy> = {
  encode(message: RetryPolicy, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.max_attempts !== 0) {
      writer.uint32(8).int32(message.max_attempts);
    }
    if (message.initial_backoff_seconds !== 0) {
      writer.uint32(17).double(message.initial_backoff_seconds);
    }
    if (message.backoff_multiplier !== 0) {
      writer.uint32(25).double(message.backoff_multiplier);
    }
    if (message.max_backoff_seconds !== 0) {
      writer.uint32(33).double(message.max_backoff_seconds);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RetryPolicy {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseRetryPolicy();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.max_attempts = reader.int32();
            continue;
          }
          case 2: {
            if (tag !== 17) {
              break;
            }

            message.initial_backoff_seconds = reader.double();
            continue;
          }
          case 3: {
            if (tag !== 25) {
              break;
            }

            message.backoff_multiplier = reader.double();
            continue;
          }
          case 4: {
            if (tag !== 33) {
              break;
            }

            message.max_backoff_seconds = reader.double();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): RetryPolicy {
    return {
      max_attempts: isSet(object.maxAttempts)
        ? globalThis.Number(object.maxAttempts)
        : isSet(object.max_attempts)
        ? globalThis.Number(object.max_attempts)
        : 0,
      initial_backoff_seconds: isSet(object.initialBackoffSeconds)
        ? globalThis.Number(object.initialBackoffSeconds)
        : isSet(object.initial_backoff_seconds)
        ? globalThis.Number(object.initial_backoff_seconds)
        : 0,
      backoff_multiplier: isSet(object.backoffMultiplier)
        ? globalThis.Number(object.backoffMultiplier)
        : isSet(object.backoff_multiplier)
        ? globalThis.Number(object.backoff_multiplier)
        : 0,
      max_backoff_seconds: isSet(object.maxBackoffSeconds)
        ? globalThis.Number(object.maxBackoffSeconds)
        : isSet(object.max_backoff_seconds)
        ? globalThis.Number(object.max_backoff_seconds)
        : 0,
    };
  },

  toJSON(message: RetryPolicy): unknown {
    const obj: any = {};
    if (message.max_attempts !== 0) {
      obj.maxAttempts = Math.round(message.max_attempts);
    }
    if (message.initial_backoff_seconds !== 0) {
      obj.initialBackoffSeconds = floatToJson(message.initial_backoff_seconds);
    }
    if (message.backoff_multiplier !== 0) {
      obj.backoffMultiplier = floatToJson(message.backoff_multiplier);
    }
    if (message.max_backoff_seconds !== 0) {
      obj.maxBackoffSeconds = floatToJson(message.max_backoff_seconds);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RetryPolicy>, I>>(base?: I): RetryPolicy {
    return RetryPolicy.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RetryPolicy>, I>>(object: I): RetryPolicy {
    const message = createBaseRetryPolicy();
    message.max_attempts = object.max_attempts ?? 0;
    message.initial_backoff_seconds = object.initial_backoff_seconds ?? 0;
    message.backoff_multiplier = object.backoff_multiplier ?? 0;
    message.max_backoff_seconds = object.max_backoff_seconds ?? 0;
    return message;
  },
};

function createBaseCallWebhookActionData(): CallWebhookActionData {
  return {
    method: "",
    headers: [],
    content_type: "",
    credential_id: "",
    retry_policy: undefined,
    on_failure: 0,
    notify_channel: 0,
    url_chunks: [],
    body_chunks: [],
  };
}

export const CallWebhookActionData: MessageFns<CallWebhookActionData> = {
  encode(message: CallWebhookActionData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.method !== "") {
      writer.uint32(10).string(message.method);
    }
    for (const v of message.headers) {
      WebhookHeader.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.content_type !== "") {
      writer.uint32(42).string(message.content_type);
    }
    if (message.credential_id !== "") {
      writer.uint32(50).string(message.credential_id);
    }
    if (message.retry_policy !== undefined) {
      RetryPolicy.encode(message.retry_policy, writer.uint32(58).fork()).join();
    }
    if (message.on_failure !== 0) {
      writer.uint32(64).int32(message.on_failure);
    }
    if (message.notify_channel !== 0) {
      writer.uint32(72).int32(message.notify_channel);
    }
    for (const v of message.url_chunks) {
      TextTemplateChunk.encode(v!, writer.uint32(82).fork()).join();
    }
    for (const v of message.body_chunks) {
      TextTemplateChunk.encode(v!, writer.uint32(90).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CallWebhookActionData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseCallWebhookActionData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.method = reader.string();
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.headers.push(WebhookHeader.decode(reader, reader.uint32()));
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.content_type = reader.string();
            continue;
          }
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.credential_id = reader.string();
            continue;
          }
          case 7: {
            if (tag !== 58) {
              break;
            }

            message.retry_policy = RetryPolicy.decode(reader, reader.uint32());
            continue;
          }
          case 8: {
            if (tag !== 64) {
              break;
            }

            message.on_failure = reader.int32() as any;
            continue;
          }
          case 9: {
            if (tag !== 72) {
              break;
            }

            message.notify_channel = reader.int32() as any;
            continue;
          }
          case 10: {
            if (tag !== 82) {
              break;
            }

            message.url_chunks.push(TextTemplateChunk.decode(reader, reader.uint32()));
            continue;
          }
          case 11: {
            if (tag !== 90) {
              break;
            }

            message.body_chunks.push(TextTemplateChunk.decode(reader, reader.uint32()));
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): CallWebhookActionData {
    return {
      method: isSet(object.method) ? globalThis.String(object.method) : "",
      headers: globalThis.Array.isArray(object?.headers)
        ? object.headers.map((e: any) => WebhookHeader.fromJSON(e))
        : [],
      content_type: isSet(object.contentType)
        ? globalThis.String(object.contentType)
        : isSet(object.content_type)
        ? globalThis.String(object.content_type)
        : "",
      credential_id: isSet(object.credentialId)
        ? globalThis.String(object.credentialId)
        : isSet(object.credential_id)
        ? globalThis.String(object.credential_id)
        : "",
      retry_policy: isSet(object.retryPolicy)
        ? RetryPolicy.fromJSON(object.retryPolicy)
        : isSet(object.retry_policy)
        ? RetryPolicy.fromJSON(object.retry_policy)
        : undefined,
      on_failure: isSet(object.onFailure)
        ? webhookFailureActionFromJSON(object.onFailure)
        : isSet(object.on_failure)
        ? webhookFailureActionFromJSON(object.on_failure)
        : 0,
      notify_channel: isSet(object.notifyChannel)
        ? webhookNotifyChannelFromJSON(object.notifyChannel)
        : isSet(object.notify_channel)
        ? webhookNotifyChannelFromJSON(object.notify_channel)
        : 0,
      url_chunks: globalThis.Array.isArray(object?.urlChunks)
        ? object.urlChunks.map((e: any) => TextTemplateChunk.fromJSON(e))
        : globalThis.Array.isArray(object?.url_chunks)
        ? object.url_chunks.map((e: any) => TextTemplateChunk.fromJSON(e))
        : [],
      body_chunks: globalThis.Array.isArray(object?.bodyChunks)
        ? object.bodyChunks.map((e: any) => TextTemplateChunk.fromJSON(e))
        : globalThis.Array.isArray(object?.body_chunks)
        ? object.body_chunks.map((e: any) => TextTemplateChunk.fromJSON(e))
        : [],
    };
  },

  toJSON(message: CallWebhookActionData): unknown {
    const obj: any = {};
    if (message.method !== "") {
      obj.method = message.method;
    }
    if (message.headers?.length) {
      obj.headers = message.headers.map((e) => WebhookHeader.toJSON(e));
    }
    if (message.content_type !== "") {
      obj.contentType = message.content_type;
    }
    if (message.credential_id !== "") {
      obj.credentialId = message.credential_id;
    }
    if (message.retry_policy !== undefined) {
      obj.retryPolicy = RetryPolicy.toJSON(message.retry_policy);
    }
    if (message.on_failure !== 0) {
      obj.onFailure = webhookFailureActionToJSON(message.on_failure);
    }
    if (message.notify_channel !== 0) {
      obj.notifyChannel = webhookNotifyChannelToJSON(message.notify_channel);
    }
    if (message.url_chunks?.length) {
      obj.urlChunks = message.url_chunks.map((e) => TextTemplateChunk.toJSON(e));
    }
    if (message.body_chunks?.length) {
      obj.bodyChunks = message.body_chunks.map((e) => TextTemplateChunk.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CallWebhookActionData>, I>>(base?: I): CallWebhookActionData {
    return CallWebhookActionData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CallWebhookActionData>, I>>(object: I): CallWebhookActionData {
    const message = createBaseCallWebhookActionData();
    message.method = object.method ?? "";
    message.headers = object.headers?.map((e) => WebhookHeader.fromPartial(e)) || [];
    message.content_type = object.content_type ?? "";
    message.credential_id = object.credential_id ?? "";
    message.retry_policy = (object.retry_policy !== undefined && object.retry_policy !== null)
      ? RetryPolicy.fromPartial(object.retry_policy)
      : undefined;
    message.on_failure = object.on_failure ?? 0;
    message.notify_channel = object.notify_channel ?? 0;
    message.url_chunks = object.url_chunks?.map((e) => TextTemplateChunk.fromPartial(e)) || [];
    message.body_chunks = object.body_chunks?.map((e) => TextTemplateChunk.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAddCocNoteActionData(): AddCocNoteActionData {
  return {
    shipment_id: undefined,
    message_chunks: [],
    audience: undefined,
    team_ids: [],
    mentioned_user_ids: [],
    append_to_alert: false,
  };
}

export const AddCocNoteActionData: MessageFns<AddCocNoteActionData> = {
  encode(message: AddCocNoteActionData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.shipment_id !== undefined) {
      VariableRef.encode(message.shipment_id, writer.uint32(10).fork()).join();
    }
    for (const v of message.message_chunks) {
      TextTemplateChunk.encode(v!, writer.uint32(58).fork()).join();
    }
    if (message.audience !== undefined) {
      writer.uint32(34).string(message.audience);
    }
    for (const v of message.team_ids) {
      writer.uint32(42).string(v!);
    }
    for (const v of message.mentioned_user_ids) {
      writer.uint32(50).string(v!);
    }
    if (message.append_to_alert !== false) {
      writer.uint32(64).bool(message.append_to_alert);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddCocNoteActionData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseAddCocNoteActionData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.shipment_id = VariableRef.decode(reader, reader.uint32());
            continue;
          }
          case 7: {
            if (tag !== 58) {
              break;
            }

            message.message_chunks.push(TextTemplateChunk.decode(reader, reader.uint32()));
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.audience = reader.string();
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.team_ids.push(reader.string());
            continue;
          }
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.mentioned_user_ids.push(reader.string());
            continue;
          }
          case 8: {
            if (tag !== 64) {
              break;
            }

            message.append_to_alert = reader.bool();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): AddCocNoteActionData {
    return {
      shipment_id: isSet(object.shipmentId)
        ? VariableRef.fromJSON(object.shipmentId)
        : isSet(object.shipment_id)
        ? VariableRef.fromJSON(object.shipment_id)
        : undefined,
      message_chunks: globalThis.Array.isArray(object?.messageChunks)
        ? object.messageChunks.map((e: any) => TextTemplateChunk.fromJSON(e))
        : globalThis.Array.isArray(object?.message_chunks)
        ? object.message_chunks.map((e: any) => TextTemplateChunk.fromJSON(e))
        : [],
      audience: isSet(object.audience) ? globalThis.String(object.audience) : undefined,
      team_ids: globalThis.Array.isArray(object?.teamIds)
        ? object.teamIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.team_ids)
        ? object.team_ids.map((e: any) => globalThis.String(e))
        : [],
      mentioned_user_ids: globalThis.Array.isArray(object?.mentionedUserIds)
        ? object.mentionedUserIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.mentioned_user_ids)
        ? object.mentioned_user_ids.map((e: any) => globalThis.String(e))
        : [],
      append_to_alert: isSet(object.appendToAlert)
        ? globalThis.Boolean(object.appendToAlert)
        : isSet(object.append_to_alert)
        ? globalThis.Boolean(object.append_to_alert)
        : false,
    };
  },

  toJSON(message: AddCocNoteActionData): unknown {
    const obj: any = {};
    if (message.shipment_id !== undefined) {
      obj.shipmentId = VariableRef.toJSON(message.shipment_id);
    }
    if (message.message_chunks?.length) {
      obj.messageChunks = message.message_chunks.map((e) => TextTemplateChunk.toJSON(e));
    }
    if (message.audience !== undefined) {
      obj.audience = message.audience;
    }
    if (message.team_ids?.length) {
      obj.teamIds = message.team_ids;
    }
    if (message.mentioned_user_ids?.length) {
      obj.mentionedUserIds = message.mentioned_user_ids;
    }
    if (message.append_to_alert !== false) {
      obj.appendToAlert = message.append_to_alert;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddCocNoteActionData>, I>>(base?: I): AddCocNoteActionData {
    return AddCocNoteActionData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddCocNoteActionData>, I>>(object: I): AddCocNoteActionData {
    const message = createBaseAddCocNoteActionData();
    message.shipment_id = (object.shipment_id !== undefined && object.shipment_id !== null)
      ? VariableRef.fromPartial(object.shipment_id)
      : undefined;
    message.message_chunks = object.message_chunks?.map((e) => TextTemplateChunk.fromPartial(e)) || [];
    message.audience = object.audience ?? undefined;
    message.team_ids = object.team_ids?.map((e) => e) || [];
    message.mentioned_user_ids = object.mentioned_user_ids?.map((e) => e) || [];
    message.append_to_alert = object.append_to_alert ?? false;
    return message;
  },
};

function createBaseAlertStatusCheckData(): AlertStatusCheckData {
  return {};
}

export const AlertStatusCheckData: MessageFns<AlertStatusCheckData> = {
  encode(_: AlertStatusCheckData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AlertStatusCheckData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseAlertStatusCheckData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(_: any): AlertStatusCheckData {
    return {};
  },

  toJSON(_: AlertStatusCheckData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<AlertStatusCheckData>, I>>(base?: I): AlertStatusCheckData {
    return AlertStatusCheckData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AlertStatusCheckData>, I>>(_: I): AlertStatusCheckData {
    const message = createBaseAlertStatusCheckData();
    return message;
  },
};

function createBaseDelayActionData(): DelayActionData {
  return {
    duration: undefined,
    until_time: undefined,
    until_day: undefined,
    until_event: undefined,
    until_location_open: undefined,
  };
}

export const DelayActionData: MessageFns<DelayActionData> = {
  encode(message: DelayActionData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.duration !== undefined) {
      DelayDuration.encode(message.duration, writer.uint32(10).fork()).join();
    }
    if (message.until_time !== undefined) {
      DelayUntilTime.encode(message.until_time, writer.uint32(18).fork()).join();
    }
    if (message.until_day !== undefined) {
      DelayUntilDay.encode(message.until_day, writer.uint32(26).fork()).join();
    }
    if (message.until_event !== undefined) {
      DelayUntilEvent.encode(message.until_event, writer.uint32(34).fork()).join();
    }
    if (message.until_location_open !== undefined) {
      DelayUntilLocationOpen.encode(message.until_location_open, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DelayActionData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDelayActionData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.duration = DelayDuration.decode(reader, reader.uint32());
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.until_time = DelayUntilTime.decode(reader, reader.uint32());
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.until_day = DelayUntilDay.decode(reader, reader.uint32());
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.until_event = DelayUntilEvent.decode(reader, reader.uint32());
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.until_location_open = DelayUntilLocationOpen.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): DelayActionData {
    return {
      duration: isSet(object.duration) ? DelayDuration.fromJSON(object.duration) : undefined,
      until_time: isSet(object.untilTime)
        ? DelayUntilTime.fromJSON(object.untilTime)
        : isSet(object.until_time)
        ? DelayUntilTime.fromJSON(object.until_time)
        : undefined,
      until_day: isSet(object.untilDay)
        ? DelayUntilDay.fromJSON(object.untilDay)
        : isSet(object.until_day)
        ? DelayUntilDay.fromJSON(object.until_day)
        : undefined,
      until_event: isSet(object.untilEvent)
        ? DelayUntilEvent.fromJSON(object.untilEvent)
        : isSet(object.until_event)
        ? DelayUntilEvent.fromJSON(object.until_event)
        : undefined,
      until_location_open: isSet(object.untilLocationOpen)
        ? DelayUntilLocationOpen.fromJSON(object.untilLocationOpen)
        : isSet(object.until_location_open)
        ? DelayUntilLocationOpen.fromJSON(object.until_location_open)
        : undefined,
    };
  },

  toJSON(message: DelayActionData): unknown {
    const obj: any = {};
    if (message.duration !== undefined) {
      obj.duration = DelayDuration.toJSON(message.duration);
    }
    if (message.until_time !== undefined) {
      obj.untilTime = DelayUntilTime.toJSON(message.until_time);
    }
    if (message.until_day !== undefined) {
      obj.untilDay = DelayUntilDay.toJSON(message.until_day);
    }
    if (message.until_event !== undefined) {
      obj.untilEvent = DelayUntilEvent.toJSON(message.until_event);
    }
    if (message.until_location_open !== undefined) {
      obj.untilLocationOpen = DelayUntilLocationOpen.toJSON(message.until_location_open);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DelayActionData>, I>>(base?: I): DelayActionData {
    return DelayActionData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DelayActionData>, I>>(object: I): DelayActionData {
    const message = createBaseDelayActionData();
    message.duration = (object.duration !== undefined && object.duration !== null)
      ? DelayDuration.fromPartial(object.duration)
      : undefined;
    message.until_time = (object.until_time !== undefined && object.until_time !== null)
      ? DelayUntilTime.fromPartial(object.until_time)
      : undefined;
    message.until_day = (object.until_day !== undefined && object.until_day !== null)
      ? DelayUntilDay.fromPartial(object.until_day)
      : undefined;
    message.until_event = (object.until_event !== undefined && object.until_event !== null)
      ? DelayUntilEvent.fromPartial(object.until_event)
      : undefined;
    message.until_location_open = (object.until_location_open !== undefined && object.until_location_open !== null)
      ? DelayUntilLocationOpen.fromPartial(object.until_location_open)
      : undefined;
    return message;
  },
};

function createBaseWaitForReplyData(): WaitForReplyData {
  return { wait_seconds: 0 };
}

export const WaitForReplyData: MessageFns<WaitForReplyData> = {
  encode(message: WaitForReplyData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.wait_seconds !== 0) {
      writer.uint32(8).int32(message.wait_seconds);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WaitForReplyData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseWaitForReplyData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.wait_seconds = reader.int32();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): WaitForReplyData {
    return {
      wait_seconds: isSet(object.waitSeconds)
        ? globalThis.Number(object.waitSeconds)
        : isSet(object.wait_seconds)
        ? globalThis.Number(object.wait_seconds)
        : 0,
    };
  },

  toJSON(message: WaitForReplyData): unknown {
    const obj: any = {};
    if (message.wait_seconds !== 0) {
      obj.waitSeconds = Math.round(message.wait_seconds);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WaitForReplyData>, I>>(base?: I): WaitForReplyData {
    return WaitForReplyData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WaitForReplyData>, I>>(object: I): WaitForReplyData {
    const message = createBaseWaitForReplyData();
    message.wait_seconds = object.wait_seconds ?? 0;
    return message;
  },
};

function createBaseBackToDelayData(): BackToDelayData {
  return { return_to_node_id: "" };
}

export const BackToDelayData: MessageFns<BackToDelayData> = {
  encode(message: BackToDelayData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.return_to_node_id !== "") {
      writer.uint32(10).string(message.return_to_node_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BackToDelayData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseBackToDelayData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.return_to_node_id = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): BackToDelayData {
    return {
      return_to_node_id: isSet(object.returnToNodeId)
        ? globalThis.String(object.returnToNodeId)
        : isSet(object.return_to_node_id)
        ? globalThis.String(object.return_to_node_id)
        : "",
    };
  },

  toJSON(message: BackToDelayData): unknown {
    const obj: any = {};
    if (message.return_to_node_id !== "") {
      obj.returnToNodeId = message.return_to_node_id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BackToDelayData>, I>>(base?: I): BackToDelayData {
    return BackToDelayData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BackToDelayData>, I>>(object: I): BackToDelayData {
    const message = createBaseBackToDelayData();
    message.return_to_node_id = object.return_to_node_id ?? "";
    return message;
  },
};

function createBaseDelayUntilLocationOpen(): DelayUntilLocationOpen {
  return { target: 0 };
}

export const DelayUntilLocationOpen: MessageFns<DelayUntilLocationOpen> = {
  encode(message: DelayUntilLocationOpen, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.target !== 0) {
      writer.uint32(8).int32(message.target);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DelayUntilLocationOpen {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDelayUntilLocationOpen();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.target = reader.int32() as any;
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): DelayUntilLocationOpen {
    return { target: isSet(object.target) ? locationTargetFromJSON(object.target) : 0 };
  },

  toJSON(message: DelayUntilLocationOpen): unknown {
    const obj: any = {};
    if (message.target !== 0) {
      obj.target = locationTargetToJSON(message.target);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DelayUntilLocationOpen>, I>>(base?: I): DelayUntilLocationOpen {
    return DelayUntilLocationOpen.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DelayUntilLocationOpen>, I>>(object: I): DelayUntilLocationOpen {
    const message = createBaseDelayUntilLocationOpen();
    message.target = object.target ?? 0;
    return message;
  },
};

function createBaseSnoozeActionData(): SnoozeActionData {
  return { duration: undefined, until_time: undefined };
}

export const SnoozeActionData: MessageFns<SnoozeActionData> = {
  encode(message: SnoozeActionData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.duration !== undefined) {
      DelayDuration.encode(message.duration, writer.uint32(10).fork()).join();
    }
    if (message.until_time !== undefined) {
      DelayUntilTime.encode(message.until_time, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SnoozeActionData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseSnoozeActionData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.duration = DelayDuration.decode(reader, reader.uint32());
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.until_time = DelayUntilTime.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): SnoozeActionData {
    return {
      duration: isSet(object.duration) ? DelayDuration.fromJSON(object.duration) : undefined,
      until_time: isSet(object.untilTime)
        ? DelayUntilTime.fromJSON(object.untilTime)
        : isSet(object.until_time)
        ? DelayUntilTime.fromJSON(object.until_time)
        : undefined,
    };
  },

  toJSON(message: SnoozeActionData): unknown {
    const obj: any = {};
    if (message.duration !== undefined) {
      obj.duration = DelayDuration.toJSON(message.duration);
    }
    if (message.until_time !== undefined) {
      obj.untilTime = DelayUntilTime.toJSON(message.until_time);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SnoozeActionData>, I>>(base?: I): SnoozeActionData {
    return SnoozeActionData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SnoozeActionData>, I>>(object: I): SnoozeActionData {
    const message = createBaseSnoozeActionData();
    message.duration = (object.duration !== undefined && object.duration !== null)
      ? DelayDuration.fromPartial(object.duration)
      : undefined;
    message.until_time = (object.until_time !== undefined && object.until_time !== null)
      ? DelayUntilTime.fromPartial(object.until_time)
      : undefined;
    return message;
  },
};

function createBaseDelayDuration(): DelayDuration {
  return { seconds: 0, display_unit: 0 };
}

export const DelayDuration: MessageFns<DelayDuration> = {
  encode(message: DelayDuration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.seconds !== 0) {
      writer.uint32(8).int32(message.seconds);
    }
    if (message.display_unit !== 0) {
      writer.uint32(16).int32(message.display_unit);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DelayDuration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDelayDuration();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.seconds = reader.int32();
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.display_unit = reader.int32() as any;
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): DelayDuration {
    return {
      seconds: isSet(object.seconds) ? globalThis.Number(object.seconds) : 0,
      display_unit: isSet(object.displayUnit)
        ? intervalUnitFromJSON(object.displayUnit)
        : isSet(object.display_unit)
        ? intervalUnitFromJSON(object.display_unit)
        : 0,
    };
  },

  toJSON(message: DelayDuration): unknown {
    const obj: any = {};
    if (message.seconds !== 0) {
      obj.seconds = Math.round(message.seconds);
    }
    if (message.display_unit !== 0) {
      obj.displayUnit = intervalUnitToJSON(message.display_unit);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DelayDuration>, I>>(base?: I): DelayDuration {
    return DelayDuration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DelayDuration>, I>>(object: I): DelayDuration {
    const message = createBaseDelayDuration();
    message.seconds = object.seconds ?? 0;
    message.display_unit = object.display_unit ?? 0;
    return message;
  },
};

function createBaseDelayUntilTime(): DelayUntilTime {
  return { seconds_since_midnight: undefined };
}

export const DelayUntilTime: MessageFns<DelayUntilTime> = {
  encode(message: DelayUntilTime, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.seconds_since_midnight !== undefined) {
      writer.uint32(8).int32(message.seconds_since_midnight);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DelayUntilTime {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDelayUntilTime();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.seconds_since_midnight = reader.int32();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): DelayUntilTime {
    return {
      seconds_since_midnight: isSet(object.secondsSinceMidnight)
        ? globalThis.Number(object.secondsSinceMidnight)
        : isSet(object.seconds_since_midnight)
        ? globalThis.Number(object.seconds_since_midnight)
        : undefined,
    };
  },

  toJSON(message: DelayUntilTime): unknown {
    const obj: any = {};
    if (message.seconds_since_midnight !== undefined) {
      obj.secondsSinceMidnight = Math.round(message.seconds_since_midnight);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DelayUntilTime>, I>>(base?: I): DelayUntilTime {
    return DelayUntilTime.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DelayUntilTime>, I>>(object: I): DelayUntilTime {
    const message = createBaseDelayUntilTime();
    message.seconds_since_midnight = object.seconds_since_midnight ?? undefined;
    return message;
  },
};

function createBaseDelayUntilDay(): DelayUntilDay {
  return { days_of_week: [], seconds_since_midnight: undefined };
}

export const DelayUntilDay: MessageFns<DelayUntilDay> = {
  encode(message: DelayUntilDay, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.days_of_week.length !== 0) {
      writer.uint32(10).fork();
      for (const v of message.days_of_week) {
        writer.int32(v);
      }
      writer.join();
    }
    if (message.seconds_since_midnight !== undefined) {
      writer.uint32(16).int32(message.seconds_since_midnight);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DelayUntilDay {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDelayUntilDay();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag === 8) {
              message.days_of_week.push(reader.int32() as any);

              continue;
            }

            if (tag === 10) {
              const end2 = reader.uint32() + reader.pos;
              while (reader.pos < end2) {
                message.days_of_week.push(reader.int32() as any);
              }

              continue;
            }

            break;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.seconds_since_midnight = reader.int32();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): DelayUntilDay {
    return {
      days_of_week: globalThis.Array.isArray(object?.daysOfWeek)
        ? object.daysOfWeek.map((e: any) => dayOfWeekFromJSON(e))
        : globalThis.Array.isArray(object?.days_of_week)
        ? object.days_of_week.map((e: any) => dayOfWeekFromJSON(e))
        : [],
      seconds_since_midnight: isSet(object.secondsSinceMidnight)
        ? globalThis.Number(object.secondsSinceMidnight)
        : isSet(object.seconds_since_midnight)
        ? globalThis.Number(object.seconds_since_midnight)
        : undefined,
    };
  },

  toJSON(message: DelayUntilDay): unknown {
    const obj: any = {};
    if (message.days_of_week?.length) {
      obj.daysOfWeek = message.days_of_week.map((e) => dayOfWeekToJSON(e));
    }
    if (message.seconds_since_midnight !== undefined) {
      obj.secondsSinceMidnight = Math.round(message.seconds_since_midnight);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DelayUntilDay>, I>>(base?: I): DelayUntilDay {
    return DelayUntilDay.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DelayUntilDay>, I>>(object: I): DelayUntilDay {
    const message = createBaseDelayUntilDay();
    message.days_of_week = object.days_of_week?.map((e) => e) || [];
    message.seconds_since_midnight = object.seconds_since_midnight ?? undefined;
    return message;
  },
};

function createBaseDelayUntilEvent(): DelayUntilEvent {
  return { events: [], stop_waiting_after: undefined, if_nothing_happens: undefined };
}

export const DelayUntilEvent: MessageFns<DelayUntilEvent> = {
  encode(message: DelayUntilEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.events) {
      DelayWaitEvent.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.stop_waiting_after !== undefined) {
      DelayDuration.encode(message.stop_waiting_after, writer.uint32(18).fork()).join();
    }
    if (message.if_nothing_happens !== undefined) {
      DelayIfNothingHappens.encode(message.if_nothing_happens, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DelayUntilEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDelayUntilEvent();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.events.push(DelayWaitEvent.decode(reader, reader.uint32()));
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.stop_waiting_after = DelayDuration.decode(reader, reader.uint32());
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.if_nothing_happens = DelayIfNothingHappens.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): DelayUntilEvent {
    return {
      events: globalThis.Array.isArray(object?.events) ? object.events.map((e: any) => DelayWaitEvent.fromJSON(e)) : [],
      stop_waiting_after: isSet(object.stopWaitingAfter)
        ? DelayDuration.fromJSON(object.stopWaitingAfter)
        : isSet(object.stop_waiting_after)
        ? DelayDuration.fromJSON(object.stop_waiting_after)
        : undefined,
      if_nothing_happens: isSet(object.ifNothingHappens)
        ? DelayIfNothingHappens.fromJSON(object.ifNothingHappens)
        : isSet(object.if_nothing_happens)
        ? DelayIfNothingHappens.fromJSON(object.if_nothing_happens)
        : undefined,
    };
  },

  toJSON(message: DelayUntilEvent): unknown {
    const obj: any = {};
    if (message.events?.length) {
      obj.events = message.events.map((e) => DelayWaitEvent.toJSON(e));
    }
    if (message.stop_waiting_after !== undefined) {
      obj.stopWaitingAfter = DelayDuration.toJSON(message.stop_waiting_after);
    }
    if (message.if_nothing_happens !== undefined) {
      obj.ifNothingHappens = DelayIfNothingHappens.toJSON(message.if_nothing_happens);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DelayUntilEvent>, I>>(base?: I): DelayUntilEvent {
    return DelayUntilEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DelayUntilEvent>, I>>(object: I): DelayUntilEvent {
    const message = createBaseDelayUntilEvent();
    message.events = object.events?.map((e) => DelayWaitEvent.fromPartial(e)) || [];
    message.stop_waiting_after = (object.stop_waiting_after !== undefined && object.stop_waiting_after !== null)
      ? DelayDuration.fromPartial(object.stop_waiting_after)
      : undefined;
    message.if_nothing_happens = (object.if_nothing_happens !== undefined && object.if_nothing_happens !== null)
      ? DelayIfNothingHappens.fromPartial(object.if_nothing_happens)
      : undefined;
    return message;
  },
};

function createBaseDelayWaitEvent(): DelayWaitEvent {
  return {
    id: "",
    alert_triggered: undefined,
    alert_action_taken: undefined,
    status_progress_update: undefined,
    reply_received: undefined,
    document_added: undefined,
    note_added: undefined,
    snooze_ended: undefined,
  };
}

export const DelayWaitEvent: MessageFns<DelayWaitEvent> = {
  encode(message: DelayWaitEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.alert_triggered !== undefined) {
      DelayAlertTriggeredEvent.encode(message.alert_triggered, writer.uint32(18).fork()).join();
    }
    if (message.alert_action_taken !== undefined) {
      DelayAlertActionTakenEvent.encode(message.alert_action_taken, writer.uint32(26).fork()).join();
    }
    if (message.status_progress_update !== undefined) {
      DelayStatusProgressEvent.encode(message.status_progress_update, writer.uint32(34).fork()).join();
    }
    if (message.reply_received !== undefined) {
      DelayReplyReceivedEvent.encode(message.reply_received, writer.uint32(42).fork()).join();
    }
    if (message.document_added !== undefined) {
      DelayDocumentAddedEvent.encode(message.document_added, writer.uint32(58).fork()).join();
    }
    if (message.note_added !== undefined) {
      DelayNoteAddedEvent.encode(message.note_added, writer.uint32(66).fork()).join();
    }
    if (message.snooze_ended !== undefined) {
      DelaySnoozeEndedEvent.encode(message.snooze_ended, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DelayWaitEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDelayWaitEvent();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.id = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.alert_triggered = DelayAlertTriggeredEvent.decode(reader, reader.uint32());
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.alert_action_taken = DelayAlertActionTakenEvent.decode(reader, reader.uint32());
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.status_progress_update = DelayStatusProgressEvent.decode(reader, reader.uint32());
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.reply_received = DelayReplyReceivedEvent.decode(reader, reader.uint32());
            continue;
          }
          case 7: {
            if (tag !== 58) {
              break;
            }

            message.document_added = DelayDocumentAddedEvent.decode(reader, reader.uint32());
            continue;
          }
          case 8: {
            if (tag !== 66) {
              break;
            }

            message.note_added = DelayNoteAddedEvent.decode(reader, reader.uint32());
            continue;
          }
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.snooze_ended = DelaySnoozeEndedEvent.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): DelayWaitEvent {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      alert_triggered: isSet(object.alertTriggered)
        ? DelayAlertTriggeredEvent.fromJSON(object.alertTriggered)
        : isSet(object.alert_triggered)
        ? DelayAlertTriggeredEvent.fromJSON(object.alert_triggered)
        : undefined,
      alert_action_taken: isSet(object.alertActionTaken)
        ? DelayAlertActionTakenEvent.fromJSON(object.alertActionTaken)
        : isSet(object.alert_action_taken)
        ? DelayAlertActionTakenEvent.fromJSON(object.alert_action_taken)
        : undefined,
      status_progress_update: isSet(object.statusProgressUpdate)
        ? DelayStatusProgressEvent.fromJSON(object.statusProgressUpdate)
        : isSet(object.status_progress_update)
        ? DelayStatusProgressEvent.fromJSON(object.status_progress_update)
        : undefined,
      reply_received: isSet(object.replyReceived)
        ? DelayReplyReceivedEvent.fromJSON(object.replyReceived)
        : isSet(object.reply_received)
        ? DelayReplyReceivedEvent.fromJSON(object.reply_received)
        : undefined,
      document_added: isSet(object.documentAdded)
        ? DelayDocumentAddedEvent.fromJSON(object.documentAdded)
        : isSet(object.document_added)
        ? DelayDocumentAddedEvent.fromJSON(object.document_added)
        : undefined,
      note_added: isSet(object.noteAdded)
        ? DelayNoteAddedEvent.fromJSON(object.noteAdded)
        : isSet(object.note_added)
        ? DelayNoteAddedEvent.fromJSON(object.note_added)
        : undefined,
      snooze_ended: isSet(object.snoozeEnded)
        ? DelaySnoozeEndedEvent.fromJSON(object.snoozeEnded)
        : isSet(object.snooze_ended)
        ? DelaySnoozeEndedEvent.fromJSON(object.snooze_ended)
        : undefined,
    };
  },

  toJSON(message: DelayWaitEvent): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.alert_triggered !== undefined) {
      obj.alertTriggered = DelayAlertTriggeredEvent.toJSON(message.alert_triggered);
    }
    if (message.alert_action_taken !== undefined) {
      obj.alertActionTaken = DelayAlertActionTakenEvent.toJSON(message.alert_action_taken);
    }
    if (message.status_progress_update !== undefined) {
      obj.statusProgressUpdate = DelayStatusProgressEvent.toJSON(message.status_progress_update);
    }
    if (message.reply_received !== undefined) {
      obj.replyReceived = DelayReplyReceivedEvent.toJSON(message.reply_received);
    }
    if (message.document_added !== undefined) {
      obj.documentAdded = DelayDocumentAddedEvent.toJSON(message.document_added);
    }
    if (message.note_added !== undefined) {
      obj.noteAdded = DelayNoteAddedEvent.toJSON(message.note_added);
    }
    if (message.snooze_ended !== undefined) {
      obj.snoozeEnded = DelaySnoozeEndedEvent.toJSON(message.snooze_ended);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DelayWaitEvent>, I>>(base?: I): DelayWaitEvent {
    return DelayWaitEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DelayWaitEvent>, I>>(object: I): DelayWaitEvent {
    const message = createBaseDelayWaitEvent();
    message.id = object.id ?? "";
    message.alert_triggered = (object.alert_triggered !== undefined && object.alert_triggered !== null)
      ? DelayAlertTriggeredEvent.fromPartial(object.alert_triggered)
      : undefined;
    message.alert_action_taken = (object.alert_action_taken !== undefined && object.alert_action_taken !== null)
      ? DelayAlertActionTakenEvent.fromPartial(object.alert_action_taken)
      : undefined;
    message.status_progress_update =
      (object.status_progress_update !== undefined && object.status_progress_update !== null)
        ? DelayStatusProgressEvent.fromPartial(object.status_progress_update)
        : undefined;
    message.reply_received = (object.reply_received !== undefined && object.reply_received !== null)
      ? DelayReplyReceivedEvent.fromPartial(object.reply_received)
      : undefined;
    message.document_added = (object.document_added !== undefined && object.document_added !== null)
      ? DelayDocumentAddedEvent.fromPartial(object.document_added)
      : undefined;
    message.note_added = (object.note_added !== undefined && object.note_added !== null)
      ? DelayNoteAddedEvent.fromPartial(object.note_added)
      : undefined;
    message.snooze_ended = (object.snooze_ended !== undefined && object.snooze_ended !== null)
      ? DelaySnoozeEndedEvent.fromPartial(object.snooze_ended)
      : undefined;
    return message;
  },
};

function createBaseDelayAlertFilter(): DelayAlertFilter {
  return { alert_types: [], select_all_alert_types: false };
}

export const DelayAlertFilter: MessageFns<DelayAlertFilter> = {
  encode(message: DelayAlertFilter, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.alert_types) {
      writer.uint32(10).string(v!);
    }
    if (message.select_all_alert_types !== false) {
      writer.uint32(16).bool(message.select_all_alert_types);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DelayAlertFilter {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDelayAlertFilter();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.alert_types.push(reader.string());
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.select_all_alert_types = reader.bool();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): DelayAlertFilter {
    return {
      alert_types: globalThis.Array.isArray(object?.alertTypes)
        ? object.alertTypes.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.alert_types)
        ? object.alert_types.map((e: any) => globalThis.String(e))
        : [],
      select_all_alert_types: isSet(object.selectAllAlertTypes)
        ? globalThis.Boolean(object.selectAllAlertTypes)
        : isSet(object.select_all_alert_types)
        ? globalThis.Boolean(object.select_all_alert_types)
        : false,
    };
  },

  toJSON(message: DelayAlertFilter): unknown {
    const obj: any = {};
    if (message.alert_types?.length) {
      obj.alertTypes = message.alert_types;
    }
    if (message.select_all_alert_types !== false) {
      obj.selectAllAlertTypes = message.select_all_alert_types;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DelayAlertFilter>, I>>(base?: I): DelayAlertFilter {
    return DelayAlertFilter.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DelayAlertFilter>, I>>(object: I): DelayAlertFilter {
    const message = createBaseDelayAlertFilter();
    message.alert_types = object.alert_types?.map((e) => e) || [];
    message.select_all_alert_types = object.select_all_alert_types ?? false;
    return message;
  },
};

function createBaseDelayAlertTriggeredEvent(): DelayAlertTriggeredEvent {
  return { alerts: undefined };
}

export const DelayAlertTriggeredEvent: MessageFns<DelayAlertTriggeredEvent> = {
  encode(message: DelayAlertTriggeredEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.alerts !== undefined) {
      DelayAlertFilter.encode(message.alerts, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DelayAlertTriggeredEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDelayAlertTriggeredEvent();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.alerts = DelayAlertFilter.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): DelayAlertTriggeredEvent {
    return { alerts: isSet(object.alerts) ? DelayAlertFilter.fromJSON(object.alerts) : undefined };
  },

  toJSON(message: DelayAlertTriggeredEvent): unknown {
    const obj: any = {};
    if (message.alerts !== undefined) {
      obj.alerts = DelayAlertFilter.toJSON(message.alerts);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DelayAlertTriggeredEvent>, I>>(base?: I): DelayAlertTriggeredEvent {
    return DelayAlertTriggeredEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DelayAlertTriggeredEvent>, I>>(object: I): DelayAlertTriggeredEvent {
    const message = createBaseDelayAlertTriggeredEvent();
    message.alerts = (object.alerts !== undefined && object.alerts !== null)
      ? DelayAlertFilter.fromPartial(object.alerts)
      : undefined;
    return message;
  },
};

function createBaseDelayAlertActionTakenEvent(): DelayAlertActionTakenEvent {
  return { alerts: undefined, action_taken: [], select_all_action_taken: false };
}

export const DelayAlertActionTakenEvent: MessageFns<DelayAlertActionTakenEvent> = {
  encode(message: DelayAlertActionTakenEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.alerts !== undefined) {
      DelayAlertFilter.encode(message.alerts, writer.uint32(10).fork()).join();
    }
    if (message.action_taken.length !== 0) {
      writer.uint32(18).fork();
      for (const v of message.action_taken) {
        writer.int32(v);
      }
      writer.join();
    }
    if (message.select_all_action_taken !== false) {
      writer.uint32(24).bool(message.select_all_action_taken);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DelayAlertActionTakenEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDelayAlertActionTakenEvent();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.alerts = DelayAlertFilter.decode(reader, reader.uint32());
            continue;
          }
          case 2: {
            if (tag === 16) {
              message.action_taken.push(reader.int32() as any);

              continue;
            }

            if (tag === 18) {
              const end2 = reader.uint32() + reader.pos;
              while (reader.pos < end2) {
                message.action_taken.push(reader.int32() as any);
              }

              continue;
            }

            break;
          }
          case 3: {
            if (tag !== 24) {
              break;
            }

            message.select_all_action_taken = reader.bool();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): DelayAlertActionTakenEvent {
    return {
      alerts: isSet(object.alerts) ? DelayAlertFilter.fromJSON(object.alerts) : undefined,
      action_taken: globalThis.Array.isArray(object?.actionTaken)
        ? object.actionTaken.map((e: any) => actionTakenFromJSON(e))
        : globalThis.Array.isArray(object?.action_taken)
        ? object.action_taken.map((e: any) => actionTakenFromJSON(e))
        : [],
      select_all_action_taken: isSet(object.selectAllActionTaken)
        ? globalThis.Boolean(object.selectAllActionTaken)
        : isSet(object.select_all_action_taken)
        ? globalThis.Boolean(object.select_all_action_taken)
        : false,
    };
  },

  toJSON(message: DelayAlertActionTakenEvent): unknown {
    const obj: any = {};
    if (message.alerts !== undefined) {
      obj.alerts = DelayAlertFilter.toJSON(message.alerts);
    }
    if (message.action_taken?.length) {
      obj.actionTaken = message.action_taken.map((e) => actionTakenToJSON(e));
    }
    if (message.select_all_action_taken !== false) {
      obj.selectAllActionTaken = message.select_all_action_taken;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DelayAlertActionTakenEvent>, I>>(base?: I): DelayAlertActionTakenEvent {
    return DelayAlertActionTakenEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DelayAlertActionTakenEvent>, I>>(object: I): DelayAlertActionTakenEvent {
    const message = createBaseDelayAlertActionTakenEvent();
    message.alerts = (object.alerts !== undefined && object.alerts !== null)
      ? DelayAlertFilter.fromPartial(object.alerts)
      : undefined;
    message.action_taken = object.action_taken?.map((e) => e) || [];
    message.select_all_action_taken = object.select_all_action_taken ?? false;
    return message;
  },
};

function createBaseDelayStatusProgressEvent(): DelayStatusProgressEvent {
  return { statuses: [] };
}

export const DelayStatusProgressEvent: MessageFns<DelayStatusProgressEvent> = {
  encode(message: DelayStatusProgressEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.statuses.length !== 0) {
      writer.uint32(10).fork();
      for (const v of message.statuses) {
        writer.int32(v);
      }
      writer.join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DelayStatusProgressEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDelayStatusProgressEvent();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag === 8) {
              message.statuses.push(reader.int32() as any);

              continue;
            }

            if (tag === 10) {
              const end2 = reader.uint32() + reader.pos;
              while (reader.pos < end2) {
                message.statuses.push(reader.int32() as any);
              }

              continue;
            }

            break;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): DelayStatusProgressEvent {
    return {
      statuses: globalThis.Array.isArray(object?.statuses)
        ? object.statuses.map((e: any) => delayStatusMilestoneFromJSON(e))
        : [],
    };
  },

  toJSON(message: DelayStatusProgressEvent): unknown {
    const obj: any = {};
    if (message.statuses?.length) {
      obj.statuses = message.statuses.map((e) => delayStatusMilestoneToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DelayStatusProgressEvent>, I>>(base?: I): DelayStatusProgressEvent {
    return DelayStatusProgressEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DelayStatusProgressEvent>, I>>(object: I): DelayStatusProgressEvent {
    const message = createBaseDelayStatusProgressEvent();
    message.statuses = object.statuses?.map((e) => e) || [];
    return message;
  },
};

function createBaseDelayReplyReceivedEvent(): DelayReplyReceivedEvent {
  return { source_node_ids: [] };
}

export const DelayReplyReceivedEvent: MessageFns<DelayReplyReceivedEvent> = {
  encode(message: DelayReplyReceivedEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.source_node_ids) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DelayReplyReceivedEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDelayReplyReceivedEvent();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.source_node_ids.push(reader.string());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): DelayReplyReceivedEvent {
    return {
      source_node_ids: globalThis.Array.isArray(object?.sourceNodeIds)
        ? object.sourceNodeIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.source_node_ids)
        ? object.source_node_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: DelayReplyReceivedEvent): unknown {
    const obj: any = {};
    if (message.source_node_ids?.length) {
      obj.sourceNodeIds = message.source_node_ids;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DelayReplyReceivedEvent>, I>>(base?: I): DelayReplyReceivedEvent {
    return DelayReplyReceivedEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DelayReplyReceivedEvent>, I>>(object: I): DelayReplyReceivedEvent {
    const message = createBaseDelayReplyReceivedEvent();
    message.source_node_ids = object.source_node_ids?.map((e) => e) || [];
    return message;
  },
};

function createBaseDelayDocumentAddedEvent(): DelayDocumentAddedEvent {
  return { where: 0 };
}

export const DelayDocumentAddedEvent: MessageFns<DelayDocumentAddedEvent> = {
  encode(message: DelayDocumentAddedEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.where !== 0) {
      writer.uint32(8).int32(message.where);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DelayDocumentAddedEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDelayDocumentAddedEvent();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.where = reader.int32() as any;
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): DelayDocumentAddedEvent {
    return { where: isSet(object.where) ? delayEventWhereFromJSON(object.where) : 0 };
  },

  toJSON(message: DelayDocumentAddedEvent): unknown {
    const obj: any = {};
    if (message.where !== 0) {
      obj.where = delayEventWhereToJSON(message.where);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DelayDocumentAddedEvent>, I>>(base?: I): DelayDocumentAddedEvent {
    return DelayDocumentAddedEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DelayDocumentAddedEvent>, I>>(object: I): DelayDocumentAddedEvent {
    const message = createBaseDelayDocumentAddedEvent();
    message.where = object.where ?? 0;
    return message;
  },
};

function createBaseDelayNoteAddedEvent(): DelayNoteAddedEvent {
  return { added_by: 0, where: 0 };
}

export const DelayNoteAddedEvent: MessageFns<DelayNoteAddedEvent> = {
  encode(message: DelayNoteAddedEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.added_by !== 0) {
      writer.uint32(8).int32(message.added_by);
    }
    if (message.where !== 0) {
      writer.uint32(16).int32(message.where);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DelayNoteAddedEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDelayNoteAddedEvent();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.added_by = reader.int32() as any;
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.where = reader.int32() as any;
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): DelayNoteAddedEvent {
    return {
      added_by: isSet(object.addedBy)
        ? delayNoteAddedByFromJSON(object.addedBy)
        : isSet(object.added_by)
        ? delayNoteAddedByFromJSON(object.added_by)
        : 0,
      where: isSet(object.where) ? delayEventWhereFromJSON(object.where) : 0,
    };
  },

  toJSON(message: DelayNoteAddedEvent): unknown {
    const obj: any = {};
    if (message.added_by !== 0) {
      obj.addedBy = delayNoteAddedByToJSON(message.added_by);
    }
    if (message.where !== 0) {
      obj.where = delayEventWhereToJSON(message.where);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DelayNoteAddedEvent>, I>>(base?: I): DelayNoteAddedEvent {
    return DelayNoteAddedEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DelayNoteAddedEvent>, I>>(object: I): DelayNoteAddedEvent {
    const message = createBaseDelayNoteAddedEvent();
    message.added_by = object.added_by ?? 0;
    message.where = object.where ?? 0;
    return message;
  },
};

function createBaseDelaySnoozeEndedEvent(): DelaySnoozeEndedEvent {
  return {};
}

export const DelaySnoozeEndedEvent: MessageFns<DelaySnoozeEndedEvent> = {
  encode(_: DelaySnoozeEndedEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DelaySnoozeEndedEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDelaySnoozeEndedEvent();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(_: any): DelaySnoozeEndedEvent {
    return {};
  },

  toJSON(_: DelaySnoozeEndedEvent): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<DelaySnoozeEndedEvent>, I>>(base?: I): DelaySnoozeEndedEvent {
    return DelaySnoozeEndedEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DelaySnoozeEndedEvent>, I>>(_: I): DelaySnoozeEndedEvent {
    const message = createBaseDelaySnoozeEndedEvent();
    return message;
  },
};

function createBaseDelayIfNothingHappens(): DelayIfNothingHappens {
  return { end_run: false, notify_automation_owner: false, notify_others: undefined };
}

export const DelayIfNothingHappens: MessageFns<DelayIfNothingHappens> = {
  encode(message: DelayIfNothingHappens, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.end_run !== false) {
      writer.uint32(8).bool(message.end_run);
    }
    if (message.notify_automation_owner !== false) {
      writer.uint32(16).bool(message.notify_automation_owner);
    }
    if (message.notify_others !== undefined) {
      DelayNotifyOthers.encode(message.notify_others, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DelayIfNothingHappens {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDelayIfNothingHappens();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.end_run = reader.bool();
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.notify_automation_owner = reader.bool();
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.notify_others = DelayNotifyOthers.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): DelayIfNothingHappens {
    return {
      end_run: isSet(object.endRun)
        ? globalThis.Boolean(object.endRun)
        : isSet(object.end_run)
        ? globalThis.Boolean(object.end_run)
        : false,
      notify_automation_owner: isSet(object.notifyAutomationOwner)
        ? globalThis.Boolean(object.notifyAutomationOwner)
        : isSet(object.notify_automation_owner)
        ? globalThis.Boolean(object.notify_automation_owner)
        : false,
      notify_others: isSet(object.notifyOthers)
        ? DelayNotifyOthers.fromJSON(object.notifyOthers)
        : isSet(object.notify_others)
        ? DelayNotifyOthers.fromJSON(object.notify_others)
        : undefined,
    };
  },

  toJSON(message: DelayIfNothingHappens): unknown {
    const obj: any = {};
    if (message.end_run !== false) {
      obj.endRun = message.end_run;
    }
    if (message.notify_automation_owner !== false) {
      obj.notifyAutomationOwner = message.notify_automation_owner;
    }
    if (message.notify_others !== undefined) {
      obj.notifyOthers = DelayNotifyOthers.toJSON(message.notify_others);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DelayIfNothingHappens>, I>>(base?: I): DelayIfNothingHappens {
    return DelayIfNothingHappens.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DelayIfNothingHappens>, I>>(object: I): DelayIfNothingHappens {
    const message = createBaseDelayIfNothingHappens();
    message.end_run = object.end_run ?? false;
    message.notify_automation_owner = object.notify_automation_owner ?? false;
    message.notify_others = (object.notify_others !== undefined && object.notify_others !== null)
      ? DelayNotifyOthers.fromPartial(object.notify_others)
      : undefined;
    return message;
  },
};

function createBaseDelayNotifyOthers(): DelayNotifyOthers {
  return { channels: [], recipients: [] };
}

export const DelayNotifyOthers: MessageFns<DelayNotifyOthers> = {
  encode(message: DelayNotifyOthers, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.channels.length !== 0) {
      writer.uint32(10).fork();
      for (const v of message.channels) {
        writer.int32(v);
      }
      writer.join();
    }
    for (const v of message.recipients) {
      TeamNotifRecipients.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DelayNotifyOthers {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDelayNotifyOthers();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag === 8) {
              message.channels.push(reader.int32() as any);

              continue;
            }

            if (tag === 10) {
              const end2 = reader.uint32() + reader.pos;
              while (reader.pos < end2) {
                message.channels.push(reader.int32() as any);
              }

              continue;
            }

            break;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.recipients.push(TeamNotifRecipients.decode(reader, reader.uint32()));
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): DelayNotifyOthers {
    return {
      channels: globalThis.Array.isArray(object?.channels)
        ? object.channels.map((e: any) => delayNotifyChannelFromJSON(e))
        : [],
      recipients: globalThis.Array.isArray(object?.recipients)
        ? object.recipients.map((e: any) => TeamNotifRecipients.fromJSON(e))
        : [],
    };
  },

  toJSON(message: DelayNotifyOthers): unknown {
    const obj: any = {};
    if (message.channels?.length) {
      obj.channels = message.channels.map((e) => delayNotifyChannelToJSON(e));
    }
    if (message.recipients?.length) {
      obj.recipients = message.recipients.map((e) => TeamNotifRecipients.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DelayNotifyOthers>, I>>(base?: I): DelayNotifyOthers {
    return DelayNotifyOthers.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DelayNotifyOthers>, I>>(object: I): DelayNotifyOthers {
    const message = createBaseDelayNotifyOthers();
    message.channels = object.channels?.map((e) => e) || [];
    message.recipients = object.recipients?.map((e) => TeamNotifRecipients.fromPartial(e)) || [];
    return message;
  },
};

function createBaseVariableRef(): VariableRef {
  return { node_id: "", variable_name: "", derived_variable_name: "", source: 0 };
}

export const VariableRef: MessageFns<VariableRef> = {
  encode(message: VariableRef, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.node_id !== "") {
      writer.uint32(10).string(message.node_id);
    }
    if (message.variable_name !== "") {
      writer.uint32(18).string(message.variable_name);
    }
    if (message.derived_variable_name !== "") {
      writer.uint32(26).string(message.derived_variable_name);
    }
    if (message.source !== 0) {
      writer.uint32(32).int32(message.source);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariableRef {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseVariableRef();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.node_id = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.variable_name = reader.string();
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.derived_variable_name = reader.string();
            continue;
          }
          case 4: {
            if (tag !== 32) {
              break;
            }

            message.source = reader.int32() as any;
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): VariableRef {
    return {
      node_id: isSet(object.nodeId)
        ? globalThis.String(object.nodeId)
        : isSet(object.node_id)
        ? globalThis.String(object.node_id)
        : "",
      variable_name: isSet(object.variableName)
        ? globalThis.String(object.variableName)
        : isSet(object.variable_name)
        ? globalThis.String(object.variable_name)
        : "",
      derived_variable_name: isSet(object.derivedVariableName)
        ? globalThis.String(object.derivedVariableName)
        : isSet(object.derived_variable_name)
        ? globalThis.String(object.derived_variable_name)
        : "",
      source: isSet(object.source) ? variableSourceFromJSON(object.source) : 0,
    };
  },

  toJSON(message: VariableRef): unknown {
    const obj: any = {};
    if (message.node_id !== "") {
      obj.nodeId = message.node_id;
    }
    if (message.variable_name !== "") {
      obj.variableName = message.variable_name;
    }
    if (message.derived_variable_name !== "") {
      obj.derivedVariableName = message.derived_variable_name;
    }
    if (message.source !== 0) {
      obj.source = variableSourceToJSON(message.source);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VariableRef>, I>>(base?: I): VariableRef {
    return VariableRef.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VariableRef>, I>>(object: I): VariableRef {
    const message = createBaseVariableRef();
    message.node_id = object.node_id ?? "";
    message.variable_name = object.variable_name ?? "";
    message.derived_variable_name = object.derived_variable_name ?? "";
    message.source = object.source ?? 0;
    return message;
  },
};

function createBaseUserMention(): UserMention {
  return { user_id: "", label: "" };
}

export const UserMention: MessageFns<UserMention> = {
  encode(message: UserMention, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.user_id !== "") {
      writer.uint32(10).string(message.user_id);
    }
    if (message.label !== "") {
      writer.uint32(18).string(message.label);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserMention {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseUserMention();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.user_id = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.label = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): UserMention {
    return {
      user_id: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
        ? globalThis.String(object.user_id)
        : "",
      label: isSet(object.label) ? globalThis.String(object.label) : "",
    };
  },

  toJSON(message: UserMention): unknown {
    const obj: any = {};
    if (message.user_id !== "") {
      obj.userId = message.user_id;
    }
    if (message.label !== "") {
      obj.label = message.label;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserMention>, I>>(base?: I): UserMention {
    return UserMention.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserMention>, I>>(object: I): UserMention {
    const message = createBaseUserMention();
    message.user_id = object.user_id ?? "";
    message.label = object.label ?? "";
    return message;
  },
};

function createBaseTextTemplateChunk(): TextTemplateChunk {
  return { text: undefined, variable: undefined, user_mention: undefined };
}

export const TextTemplateChunk: MessageFns<TextTemplateChunk> = {
  encode(message: TextTemplateChunk, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.text !== undefined) {
      writer.uint32(10).string(message.text);
    }
    if (message.variable !== undefined) {
      VariableRef.encode(message.variable, writer.uint32(18).fork()).join();
    }
    if (message.user_mention !== undefined) {
      UserMention.encode(message.user_mention, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TextTemplateChunk {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseTextTemplateChunk();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.text = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.variable = VariableRef.decode(reader, reader.uint32());
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.user_mention = UserMention.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): TextTemplateChunk {
    return {
      text: isSet(object.text) ? globalThis.String(object.text) : undefined,
      variable: isSet(object.variable) ? VariableRef.fromJSON(object.variable) : undefined,
      user_mention: isSet(object.userMention)
        ? UserMention.fromJSON(object.userMention)
        : isSet(object.user_mention)
        ? UserMention.fromJSON(object.user_mention)
        : undefined,
    };
  },

  toJSON(message: TextTemplateChunk): unknown {
    const obj: any = {};
    if (message.text !== undefined) {
      obj.text = message.text;
    }
    if (message.variable !== undefined) {
      obj.variable = VariableRef.toJSON(message.variable);
    }
    if (message.user_mention !== undefined) {
      obj.userMention = UserMention.toJSON(message.user_mention);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TextTemplateChunk>, I>>(base?: I): TextTemplateChunk {
    return TextTemplateChunk.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TextTemplateChunk>, I>>(object: I): TextTemplateChunk {
    const message = createBaseTextTemplateChunk();
    message.text = object.text ?? undefined;
    message.variable = (object.variable !== undefined && object.variable !== null)
      ? VariableRef.fromPartial(object.variable)
      : undefined;
    message.user_mention = (object.user_mention !== undefined && object.user_mention !== null)
      ? UserMention.fromPartial(object.user_mention)
      : undefined;
    return message;
  },
};

function createBaseRhsValueList(): RhsValueList {
  return { items: [] };
}

export const RhsValueList: MessageFns<RhsValueList> = {
  encode(message: RhsValueList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      VariableValue.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RhsValueList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseRhsValueList();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.items.push(VariableValue.decode(reader, reader.uint32()));
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): RhsValueList {
    return {
      items: globalThis.Array.isArray(object?.items) ? object.items.map((e: any) => VariableValue.fromJSON(e)) : [],
    };
  },

  toJSON(message: RhsValueList): unknown {
    const obj: any = {};
    if (message.items?.length) {
      obj.items = message.items.map((e) => VariableValue.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RhsValueList>, I>>(base?: I): RhsValueList {
    return RhsValueList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RhsValueList>, I>>(object: I): RhsValueList {
    const message = createBaseRhsValueList();
    message.items = object.items?.map((e) => VariableValue.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRhsValue(): RhsValue {
  return { literal: undefined, variable: undefined, list: undefined };
}

export const RhsValue: MessageFns<RhsValue> = {
  encode(message: RhsValue, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.literal !== undefined) {
      VariableValue.encode(message.literal, writer.uint32(10).fork()).join();
    }
    if (message.variable !== undefined) {
      VariableRef.encode(message.variable, writer.uint32(18).fork()).join();
    }
    if (message.list !== undefined) {
      RhsValueList.encode(message.list, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RhsValue {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseRhsValue();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.literal = VariableValue.decode(reader, reader.uint32());
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.variable = VariableRef.decode(reader, reader.uint32());
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.list = RhsValueList.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): RhsValue {
    return {
      literal: isSet(object.literal) ? VariableValue.fromJSON(object.literal) : undefined,
      variable: isSet(object.variable) ? VariableRef.fromJSON(object.variable) : undefined,
      list: isSet(object.list) ? RhsValueList.fromJSON(object.list) : undefined,
    };
  },

  toJSON(message: RhsValue): unknown {
    const obj: any = {};
    if (message.literal !== undefined) {
      obj.literal = VariableValue.toJSON(message.literal);
    }
    if (message.variable !== undefined) {
      obj.variable = VariableRef.toJSON(message.variable);
    }
    if (message.list !== undefined) {
      obj.list = RhsValueList.toJSON(message.list);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RhsValue>, I>>(base?: I): RhsValue {
    return RhsValue.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RhsValue>, I>>(object: I): RhsValue {
    const message = createBaseRhsValue();
    message.literal = (object.literal !== undefined && object.literal !== null)
      ? VariableValue.fromPartial(object.literal)
      : undefined;
    message.variable = (object.variable !== undefined && object.variable !== null)
      ? VariableRef.fromPartial(object.variable)
      : undefined;
    message.list = (object.list !== undefined && object.list !== null)
      ? RhsValueList.fromPartial(object.list)
      : undefined;
    return message;
  },
};

function createBaseComparisonExpr(): ComparisonExpr {
  return { variable: undefined, operator: 0, rhs: undefined, rhs2: undefined };
}

export const ComparisonExpr: MessageFns<ComparisonExpr> = {
  encode(message: ComparisonExpr, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.variable !== undefined) {
      VariableRef.encode(message.variable, writer.uint32(10).fork()).join();
    }
    if (message.operator !== 0) {
      writer.uint32(16).int32(message.operator);
    }
    if (message.rhs !== undefined) {
      RhsValue.encode(message.rhs, writer.uint32(26).fork()).join();
    }
    if (message.rhs2 !== undefined) {
      RhsValue.encode(message.rhs2, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ComparisonExpr {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseComparisonExpr();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.variable = VariableRef.decode(reader, reader.uint32());
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.operator = reader.int32() as any;
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.rhs = RhsValue.decode(reader, reader.uint32());
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.rhs2 = RhsValue.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): ComparisonExpr {
    return {
      variable: isSet(object.variable) ? VariableRef.fromJSON(object.variable) : undefined,
      operator: isSet(object.operator) ? comparisonOpFromJSON(object.operator) : 0,
      rhs: isSet(object.rhs) ? RhsValue.fromJSON(object.rhs) : undefined,
      rhs2: isSet(object.rhs2) ? RhsValue.fromJSON(object.rhs2) : undefined,
    };
  },

  toJSON(message: ComparisonExpr): unknown {
    const obj: any = {};
    if (message.variable !== undefined) {
      obj.variable = VariableRef.toJSON(message.variable);
    }
    if (message.operator !== 0) {
      obj.operator = comparisonOpToJSON(message.operator);
    }
    if (message.rhs !== undefined) {
      obj.rhs = RhsValue.toJSON(message.rhs);
    }
    if (message.rhs2 !== undefined) {
      obj.rhs2 = RhsValue.toJSON(message.rhs2);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ComparisonExpr>, I>>(base?: I): ComparisonExpr {
    return ComparisonExpr.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ComparisonExpr>, I>>(object: I): ComparisonExpr {
    const message = createBaseComparisonExpr();
    message.variable = (object.variable !== undefined && object.variable !== null)
      ? VariableRef.fromPartial(object.variable)
      : undefined;
    message.operator = object.operator ?? 0;
    message.rhs = (object.rhs !== undefined && object.rhs !== null) ? RhsValue.fromPartial(object.rhs) : undefined;
    message.rhs2 = (object.rhs2 !== undefined && object.rhs2 !== null) ? RhsValue.fromPartial(object.rhs2) : undefined;
    return message;
  },
};

function createBaseRecurringWindowExpr(): RecurringWindowExpr {
  return { variable: undefined, start_seconds: undefined, end_seconds: undefined, days_of_week: [], operator: 0 };
}

export const RecurringWindowExpr: MessageFns<RecurringWindowExpr> = {
  encode(message: RecurringWindowExpr, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.variable !== undefined) {
      VariableRef.encode(message.variable, writer.uint32(10).fork()).join();
    }
    if (message.start_seconds !== undefined) {
      writer.uint32(16).int32(message.start_seconds);
    }
    if (message.end_seconds !== undefined) {
      writer.uint32(24).int32(message.end_seconds);
    }
    if (message.days_of_week.length !== 0) {
      writer.uint32(34).fork();
      for (const v of message.days_of_week) {
        writer.int32(v);
      }
      writer.join();
    }
    if (message.operator !== 0) {
      writer.uint32(40).int32(message.operator);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RecurringWindowExpr {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseRecurringWindowExpr();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.variable = VariableRef.decode(reader, reader.uint32());
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.start_seconds = reader.int32();
            continue;
          }
          case 3: {
            if (tag !== 24) {
              break;
            }

            message.end_seconds = reader.int32();
            continue;
          }
          case 4: {
            if (tag === 32) {
              message.days_of_week.push(reader.int32() as any);

              continue;
            }

            if (tag === 34) {
              const end2 = reader.uint32() + reader.pos;
              while (reader.pos < end2) {
                message.days_of_week.push(reader.int32() as any);
              }

              continue;
            }

            break;
          }
          case 5: {
            if (tag !== 40) {
              break;
            }

            message.operator = reader.int32() as any;
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): RecurringWindowExpr {
    return {
      variable: isSet(object.variable) ? VariableRef.fromJSON(object.variable) : undefined,
      start_seconds: isSet(object.startSeconds)
        ? globalThis.Number(object.startSeconds)
        : isSet(object.start_seconds)
        ? globalThis.Number(object.start_seconds)
        : undefined,
      end_seconds: isSet(object.endSeconds)
        ? globalThis.Number(object.endSeconds)
        : isSet(object.end_seconds)
        ? globalThis.Number(object.end_seconds)
        : undefined,
      days_of_week: globalThis.Array.isArray(object?.daysOfWeek)
        ? object.daysOfWeek.map((e: any) => dayOfWeekFromJSON(e))
        : globalThis.Array.isArray(object?.days_of_week)
        ? object.days_of_week.map((e: any) => dayOfWeekFromJSON(e))
        : [],
      operator: isSet(object.operator) ? timeRangeOpFromJSON(object.operator) : 0,
    };
  },

  toJSON(message: RecurringWindowExpr): unknown {
    const obj: any = {};
    if (message.variable !== undefined) {
      obj.variable = VariableRef.toJSON(message.variable);
    }
    if (message.start_seconds !== undefined) {
      obj.startSeconds = Math.round(message.start_seconds);
    }
    if (message.end_seconds !== undefined) {
      obj.endSeconds = Math.round(message.end_seconds);
    }
    if (message.days_of_week?.length) {
      obj.daysOfWeek = message.days_of_week.map((e) => dayOfWeekToJSON(e));
    }
    if (message.operator !== 0) {
      obj.operator = timeRangeOpToJSON(message.operator);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RecurringWindowExpr>, I>>(base?: I): RecurringWindowExpr {
    return RecurringWindowExpr.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RecurringWindowExpr>, I>>(object: I): RecurringWindowExpr {
    const message = createBaseRecurringWindowExpr();
    message.variable = (object.variable !== undefined && object.variable !== null)
      ? VariableRef.fromPartial(object.variable)
      : undefined;
    message.start_seconds = object.start_seconds ?? undefined;
    message.end_seconds = object.end_seconds ?? undefined;
    message.days_of_week = object.days_of_week?.map((e) => e) || [];
    message.operator = object.operator ?? 0;
    return message;
  },
};

function createBaseTimeOfDayRange(): TimeOfDayRange {
  return { all_day: false, start_seconds: undefined, end_seconds: undefined };
}

export const TimeOfDayRange: MessageFns<TimeOfDayRange> = {
  encode(message: TimeOfDayRange, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.all_day !== false) {
      writer.uint32(8).bool(message.all_day);
    }
    if (message.start_seconds !== undefined) {
      writer.uint32(16).int32(message.start_seconds);
    }
    if (message.end_seconds !== undefined) {
      writer.uint32(24).int32(message.end_seconds);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TimeOfDayRange {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseTimeOfDayRange();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.all_day = reader.bool();
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.start_seconds = reader.int32();
            continue;
          }
          case 3: {
            if (tag !== 24) {
              break;
            }

            message.end_seconds = reader.int32();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): TimeOfDayRange {
    return {
      all_day: isSet(object.allDay)
        ? globalThis.Boolean(object.allDay)
        : isSet(object.all_day)
        ? globalThis.Boolean(object.all_day)
        : false,
      start_seconds: isSet(object.startSeconds)
        ? globalThis.Number(object.startSeconds)
        : isSet(object.start_seconds)
        ? globalThis.Number(object.start_seconds)
        : undefined,
      end_seconds: isSet(object.endSeconds)
        ? globalThis.Number(object.endSeconds)
        : isSet(object.end_seconds)
        ? globalThis.Number(object.end_seconds)
        : undefined,
    };
  },

  toJSON(message: TimeOfDayRange): unknown {
    const obj: any = {};
    if (message.all_day !== false) {
      obj.allDay = message.all_day;
    }
    if (message.start_seconds !== undefined) {
      obj.startSeconds = Math.round(message.start_seconds);
    }
    if (message.end_seconds !== undefined) {
      obj.endSeconds = Math.round(message.end_seconds);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TimeOfDayRange>, I>>(base?: I): TimeOfDayRange {
    return TimeOfDayRange.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TimeOfDayRange>, I>>(object: I): TimeOfDayRange {
    const message = createBaseTimeOfDayRange();
    message.all_day = object.all_day ?? false;
    message.start_seconds = object.start_seconds ?? undefined;
    message.end_seconds = object.end_seconds ?? undefined;
    return message;
  },
};

function createBaseSpecificDateEntry(): SpecificDateEntry {
  return { date: "", time_range: undefined };
}

export const SpecificDateEntry: MessageFns<SpecificDateEntry> = {
  encode(message: SpecificDateEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.date !== "") {
      writer.uint32(10).string(message.date);
    }
    if (message.time_range !== undefined) {
      TimeOfDayRange.encode(message.time_range, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpecificDateEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseSpecificDateEntry();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.date = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.time_range = TimeOfDayRange.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): SpecificDateEntry {
    return {
      date: isSet(object.date) ? globalThis.String(object.date) : "",
      time_range: isSet(object.timeRange)
        ? TimeOfDayRange.fromJSON(object.timeRange)
        : isSet(object.time_range)
        ? TimeOfDayRange.fromJSON(object.time_range)
        : undefined,
    };
  },

  toJSON(message: SpecificDateEntry): unknown {
    const obj: any = {};
    if (message.date !== "") {
      obj.date = message.date;
    }
    if (message.time_range !== undefined) {
      obj.timeRange = TimeOfDayRange.toJSON(message.time_range);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpecificDateEntry>, I>>(base?: I): SpecificDateEntry {
    return SpecificDateEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpecificDateEntry>, I>>(object: I): SpecificDateEntry {
    const message = createBaseSpecificDateEntry();
    message.date = object.date ?? "";
    message.time_range = (object.time_range !== undefined && object.time_range !== null)
      ? TimeOfDayRange.fromPartial(object.time_range)
      : undefined;
    return message;
  },
};

function createBaseSpecificDateSet(): SpecificDateSet {
  return { dates: [] };
}

export const SpecificDateSet: MessageFns<SpecificDateSet> = {
  encode(message: SpecificDateSet, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.dates) {
      SpecificDateEntry.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpecificDateSet {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseSpecificDateSet();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.dates.push(SpecificDateEntry.decode(reader, reader.uint32()));
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): SpecificDateSet {
    return {
      dates: globalThis.Array.isArray(object?.dates) ? object.dates.map((e: any) => SpecificDateEntry.fromJSON(e)) : [],
    };
  },

  toJSON(message: SpecificDateSet): unknown {
    const obj: any = {};
    if (message.dates?.length) {
      obj.dates = message.dates.map((e) => SpecificDateEntry.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpecificDateSet>, I>>(base?: I): SpecificDateSet {
    return SpecificDateSet.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpecificDateSet>, I>>(object: I): SpecificDateSet {
    const message = createBaseSpecificDateSet();
    message.dates = object.dates?.map((e) => SpecificDateEntry.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDayOfWeekEntry(): DayOfWeekEntry {
  return { day: 0, time_range: undefined };
}

export const DayOfWeekEntry: MessageFns<DayOfWeekEntry> = {
  encode(message: DayOfWeekEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.day !== 0) {
      writer.uint32(8).int32(message.day);
    }
    if (message.time_range !== undefined) {
      TimeOfDayRange.encode(message.time_range, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DayOfWeekEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDayOfWeekEntry();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.day = reader.int32() as any;
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.time_range = TimeOfDayRange.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): DayOfWeekEntry {
    return {
      day: isSet(object.day) ? dayOfWeekFromJSON(object.day) : 0,
      time_range: isSet(object.timeRange)
        ? TimeOfDayRange.fromJSON(object.timeRange)
        : isSet(object.time_range)
        ? TimeOfDayRange.fromJSON(object.time_range)
        : undefined,
    };
  },

  toJSON(message: DayOfWeekEntry): unknown {
    const obj: any = {};
    if (message.day !== 0) {
      obj.day = dayOfWeekToJSON(message.day);
    }
    if (message.time_range !== undefined) {
      obj.timeRange = TimeOfDayRange.toJSON(message.time_range);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DayOfWeekEntry>, I>>(base?: I): DayOfWeekEntry {
    return DayOfWeekEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DayOfWeekEntry>, I>>(object: I): DayOfWeekEntry {
    const message = createBaseDayOfWeekEntry();
    message.day = object.day ?? 0;
    message.time_range = (object.time_range !== undefined && object.time_range !== null)
      ? TimeOfDayRange.fromPartial(object.time_range)
      : undefined;
    return message;
  },
};

function createBaseDayOfWeekSet(): DayOfWeekSet {
  return { days: [] };
}

export const DayOfWeekSet: MessageFns<DayOfWeekSet> = {
  encode(message: DayOfWeekSet, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.days) {
      DayOfWeekEntry.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DayOfWeekSet {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDayOfWeekSet();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.days.push(DayOfWeekEntry.decode(reader, reader.uint32()));
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): DayOfWeekSet {
    return {
      days: globalThis.Array.isArray(object?.days) ? object.days.map((e: any) => DayOfWeekEntry.fromJSON(e)) : [],
    };
  },

  toJSON(message: DayOfWeekSet): unknown {
    const obj: any = {};
    if (message.days?.length) {
      obj.days = message.days.map((e) => DayOfWeekEntry.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DayOfWeekSet>, I>>(base?: I): DayOfWeekSet {
    return DayOfWeekSet.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DayOfWeekSet>, I>>(object: I): DayOfWeekSet {
    const message = createBaseDayOfWeekSet();
    message.days = object.days?.map((e) => DayOfWeekEntry.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDateTimeSetExpr(): DateTimeSetExpr {
  return {
    variable: undefined,
    iana_timezone: "",
    operator: 0,
    specific_dates: undefined,
    days_of_week: undefined,
    system_preset_id: undefined,
    saved_list_id: undefined,
    display_label: "",
  };
}

export const DateTimeSetExpr: MessageFns<DateTimeSetExpr> = {
  encode(message: DateTimeSetExpr, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.variable !== undefined) {
      VariableRef.encode(message.variable, writer.uint32(10).fork()).join();
    }
    if (message.iana_timezone !== "") {
      writer.uint32(18).string(message.iana_timezone);
    }
    if (message.operator !== 0) {
      writer.uint32(24).int32(message.operator);
    }
    if (message.specific_dates !== undefined) {
      SpecificDateSet.encode(message.specific_dates, writer.uint32(34).fork()).join();
    }
    if (message.days_of_week !== undefined) {
      DayOfWeekSet.encode(message.days_of_week, writer.uint32(42).fork()).join();
    }
    if (message.system_preset_id !== undefined) {
      writer.uint32(50).string(message.system_preset_id);
    }
    if (message.saved_list_id !== undefined) {
      writer.uint32(58).string(message.saved_list_id);
    }
    if (message.display_label !== "") {
      writer.uint32(66).string(message.display_label);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DateTimeSetExpr {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDateTimeSetExpr();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.variable = VariableRef.decode(reader, reader.uint32());
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.iana_timezone = reader.string();
            continue;
          }
          case 3: {
            if (tag !== 24) {
              break;
            }

            message.operator = reader.int32() as any;
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.specific_dates = SpecificDateSet.decode(reader, reader.uint32());
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.days_of_week = DayOfWeekSet.decode(reader, reader.uint32());
            continue;
          }
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.system_preset_id = reader.string();
            continue;
          }
          case 7: {
            if (tag !== 58) {
              break;
            }

            message.saved_list_id = reader.string();
            continue;
          }
          case 8: {
            if (tag !== 66) {
              break;
            }

            message.display_label = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): DateTimeSetExpr {
    return {
      variable: isSet(object.variable) ? VariableRef.fromJSON(object.variable) : undefined,
      iana_timezone: isSet(object.ianaTimezone)
        ? globalThis.String(object.ianaTimezone)
        : isSet(object.iana_timezone)
        ? globalThis.String(object.iana_timezone)
        : "",
      operator: isSet(object.operator) ? timeRangeOpFromJSON(object.operator) : 0,
      specific_dates: isSet(object.specificDates)
        ? SpecificDateSet.fromJSON(object.specificDates)
        : isSet(object.specific_dates)
        ? SpecificDateSet.fromJSON(object.specific_dates)
        : undefined,
      days_of_week: isSet(object.daysOfWeek)
        ? DayOfWeekSet.fromJSON(object.daysOfWeek)
        : isSet(object.days_of_week)
        ? DayOfWeekSet.fromJSON(object.days_of_week)
        : undefined,
      system_preset_id: isSet(object.systemPresetId)
        ? globalThis.String(object.systemPresetId)
        : isSet(object.system_preset_id)
        ? globalThis.String(object.system_preset_id)
        : undefined,
      saved_list_id: isSet(object.savedListId)
        ? globalThis.String(object.savedListId)
        : isSet(object.saved_list_id)
        ? globalThis.String(object.saved_list_id)
        : undefined,
      display_label: isSet(object.displayLabel)
        ? globalThis.String(object.displayLabel)
        : isSet(object.display_label)
        ? globalThis.String(object.display_label)
        : "",
    };
  },

  toJSON(message: DateTimeSetExpr): unknown {
    const obj: any = {};
    if (message.variable !== undefined) {
      obj.variable = VariableRef.toJSON(message.variable);
    }
    if (message.iana_timezone !== "") {
      obj.ianaTimezone = message.iana_timezone;
    }
    if (message.operator !== 0) {
      obj.operator = timeRangeOpToJSON(message.operator);
    }
    if (message.specific_dates !== undefined) {
      obj.specificDates = SpecificDateSet.toJSON(message.specific_dates);
    }
    if (message.days_of_week !== undefined) {
      obj.daysOfWeek = DayOfWeekSet.toJSON(message.days_of_week);
    }
    if (message.system_preset_id !== undefined) {
      obj.systemPresetId = message.system_preset_id;
    }
    if (message.saved_list_id !== undefined) {
      obj.savedListId = message.saved_list_id;
    }
    if (message.display_label !== "") {
      obj.displayLabel = message.display_label;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DateTimeSetExpr>, I>>(base?: I): DateTimeSetExpr {
    return DateTimeSetExpr.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DateTimeSetExpr>, I>>(object: I): DateTimeSetExpr {
    const message = createBaseDateTimeSetExpr();
    message.variable = (object.variable !== undefined && object.variable !== null)
      ? VariableRef.fromPartial(object.variable)
      : undefined;
    message.iana_timezone = object.iana_timezone ?? "";
    message.operator = object.operator ?? 0;
    message.specific_dates = (object.specific_dates !== undefined && object.specific_dates !== null)
      ? SpecificDateSet.fromPartial(object.specific_dates)
      : undefined;
    message.days_of_week = (object.days_of_week !== undefined && object.days_of_week !== null)
      ? DayOfWeekSet.fromPartial(object.days_of_week)
      : undefined;
    message.system_preset_id = object.system_preset_id ?? undefined;
    message.saved_list_id = object.saved_list_id ?? undefined;
    message.display_label = object.display_label ?? "";
    return message;
  },
};

function createBaseBoolExpr(): BoolExpr {
  return {
    comparison_expr: undefined,
    recurring_window_expr: undefined,
    group: undefined,
    date_time_set_expr: undefined,
  };
}

export const BoolExpr: MessageFns<BoolExpr> = {
  encode(message: BoolExpr, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.comparison_expr !== undefined) {
      ComparisonExpr.encode(message.comparison_expr, writer.uint32(10).fork()).join();
    }
    if (message.recurring_window_expr !== undefined) {
      RecurringWindowExpr.encode(message.recurring_window_expr, writer.uint32(18).fork()).join();
    }
    if (message.group !== undefined) {
      BoolExprGroup.encode(message.group, writer.uint32(26).fork()).join();
    }
    if (message.date_time_set_expr !== undefined) {
      DateTimeSetExpr.encode(message.date_time_set_expr, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BoolExpr {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseBoolExpr();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.comparison_expr = ComparisonExpr.decode(reader, reader.uint32());
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.recurring_window_expr = RecurringWindowExpr.decode(reader, reader.uint32());
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.group = BoolExprGroup.decode(reader, reader.uint32());
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.date_time_set_expr = DateTimeSetExpr.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): BoolExpr {
    return {
      comparison_expr: isSet(object.comparisonExpr)
        ? ComparisonExpr.fromJSON(object.comparisonExpr)
        : isSet(object.comparison_expr)
        ? ComparisonExpr.fromJSON(object.comparison_expr)
        : undefined,
      recurring_window_expr: isSet(object.recurringWindowExpr)
        ? RecurringWindowExpr.fromJSON(object.recurringWindowExpr)
        : isSet(object.recurring_window_expr)
        ? RecurringWindowExpr.fromJSON(object.recurring_window_expr)
        : undefined,
      group: isSet(object.group) ? BoolExprGroup.fromJSON(object.group) : undefined,
      date_time_set_expr: isSet(object.dateTimeSetExpr)
        ? DateTimeSetExpr.fromJSON(object.dateTimeSetExpr)
        : isSet(object.date_time_set_expr)
        ? DateTimeSetExpr.fromJSON(object.date_time_set_expr)
        : undefined,
    };
  },

  toJSON(message: BoolExpr): unknown {
    const obj: any = {};
    if (message.comparison_expr !== undefined) {
      obj.comparisonExpr = ComparisonExpr.toJSON(message.comparison_expr);
    }
    if (message.recurring_window_expr !== undefined) {
      obj.recurringWindowExpr = RecurringWindowExpr.toJSON(message.recurring_window_expr);
    }
    if (message.group !== undefined) {
      obj.group = BoolExprGroup.toJSON(message.group);
    }
    if (message.date_time_set_expr !== undefined) {
      obj.dateTimeSetExpr = DateTimeSetExpr.toJSON(message.date_time_set_expr);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BoolExpr>, I>>(base?: I): BoolExpr {
    return BoolExpr.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BoolExpr>, I>>(object: I): BoolExpr {
    const message = createBaseBoolExpr();
    message.comparison_expr = (object.comparison_expr !== undefined && object.comparison_expr !== null)
      ? ComparisonExpr.fromPartial(object.comparison_expr)
      : undefined;
    message.recurring_window_expr =
      (object.recurring_window_expr !== undefined && object.recurring_window_expr !== null)
        ? RecurringWindowExpr.fromPartial(object.recurring_window_expr)
        : undefined;
    message.group = (object.group !== undefined && object.group !== null)
      ? BoolExprGroup.fromPartial(object.group)
      : undefined;
    message.date_time_set_expr = (object.date_time_set_expr !== undefined && object.date_time_set_expr !== null)
      ? DateTimeSetExpr.fromPartial(object.date_time_set_expr)
      : undefined;
    return message;
  },
};

function createBaseBoolExprGroup(): BoolExprGroup {
  return { expressions: [], operators: [] };
}

export const BoolExprGroup: MessageFns<BoolExprGroup> = {
  encode(message: BoolExprGroup, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.expressions) {
      BoolExpr.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.operators.length !== 0) {
      writer.uint32(18).fork();
      for (const v of message.operators) {
        writer.int32(v);
      }
      writer.join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BoolExprGroup {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseBoolExprGroup();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.expressions.push(BoolExpr.decode(reader, reader.uint32()));
            continue;
          }
          case 2: {
            if (tag === 16) {
              message.operators.push(reader.int32() as any);

              continue;
            }

            if (tag === 18) {
              const end2 = reader.uint32() + reader.pos;
              while (reader.pos < end2) {
                message.operators.push(reader.int32() as any);
              }

              continue;
            }

            break;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): BoolExprGroup {
    return {
      expressions: globalThis.Array.isArray(object?.expressions)
        ? object.expressions.map((e: any) => BoolExpr.fromJSON(e))
        : [],
      operators: globalThis.Array.isArray(object?.operators)
        ? object.operators.map((e: any) => logicalOpFromJSON(e))
        : [],
    };
  },

  toJSON(message: BoolExprGroup): unknown {
    const obj: any = {};
    if (message.expressions?.length) {
      obj.expressions = message.expressions.map((e) => BoolExpr.toJSON(e));
    }
    if (message.operators?.length) {
      obj.operators = message.operators.map((e) => logicalOpToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BoolExprGroup>, I>>(base?: I): BoolExprGroup {
    return BoolExprGroup.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BoolExprGroup>, I>>(object: I): BoolExprGroup {
    const message = createBaseBoolExprGroup();
    message.expressions = object.expressions?.map((e) => BoolExpr.fromPartial(e)) || [];
    message.operators = object.operators?.map((e) => e) || [];
    return message;
  },
};

function createBaseConditionalData(): ConditionalData {
  return { root: undefined };
}

export const ConditionalData: MessageFns<ConditionalData> = {
  encode(message: ConditionalData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.root !== undefined) {
      BoolExprGroup.encode(message.root, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConditionalData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseConditionalData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.root = BoolExprGroup.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): ConditionalData {
    return { root: isSet(object.root) ? BoolExprGroup.fromJSON(object.root) : undefined };
  },

  toJSON(message: ConditionalData): unknown {
    const obj: any = {};
    if (message.root !== undefined) {
      obj.root = BoolExprGroup.toJSON(message.root);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ConditionalData>, I>>(base?: I): ConditionalData {
    return ConditionalData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConditionalData>, I>>(object: I): ConditionalData {
    const message = createBaseConditionalData();
    message.root = (object.root !== undefined && object.root !== null)
      ? BoolExprGroup.fromPartial(object.root)
      : undefined;
    return message;
  },
};

function createBaseLBEdge(): LBEdge {
  return { id: "", source: "", target: "", edge_order: undefined, source_handle: undefined, target_handle: undefined };
}

export const LBEdge: MessageFns<LBEdge> = {
  encode(message: LBEdge, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.source !== "") {
      writer.uint32(18).string(message.source);
    }
    if (message.target !== "") {
      writer.uint32(26).string(message.target);
    }
    if (message.edge_order !== undefined) {
      writer.uint32(48).int32(message.edge_order);
    }
    if (message.source_handle !== undefined) {
      writer.uint32(34).string(message.source_handle);
    }
    if (message.target_handle !== undefined) {
      writer.uint32(42).string(message.target_handle);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LBEdge {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseLBEdge();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.id = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.source = reader.string();
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.target = reader.string();
            continue;
          }
          case 6: {
            if (tag !== 48) {
              break;
            }

            message.edge_order = reader.int32();
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.source_handle = reader.string();
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.target_handle = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): LBEdge {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      source: isSet(object.source) ? globalThis.String(object.source) : "",
      target: isSet(object.target) ? globalThis.String(object.target) : "",
      edge_order: isSet(object.edgeOrder)
        ? globalThis.Number(object.edgeOrder)
        : isSet(object.edge_order)
        ? globalThis.Number(object.edge_order)
        : undefined,
      source_handle: isSet(object.sourceHandle)
        ? globalThis.String(object.sourceHandle)
        : isSet(object.source_handle)
        ? globalThis.String(object.source_handle)
        : undefined,
      target_handle: isSet(object.targetHandle)
        ? globalThis.String(object.targetHandle)
        : isSet(object.target_handle)
        ? globalThis.String(object.target_handle)
        : undefined,
    };
  },

  toJSON(message: LBEdge): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.source !== "") {
      obj.source = message.source;
    }
    if (message.target !== "") {
      obj.target = message.target;
    }
    if (message.edge_order !== undefined) {
      obj.edgeOrder = Math.round(message.edge_order);
    }
    if (message.source_handle !== undefined) {
      obj.sourceHandle = message.source_handle;
    }
    if (message.target_handle !== undefined) {
      obj.targetHandle = message.target_handle;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LBEdge>, I>>(base?: I): LBEdge {
    return LBEdge.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LBEdge>, I>>(object: I): LBEdge {
    const message = createBaseLBEdge();
    message.id = object.id ?? "";
    message.source = object.source ?? "";
    message.target = object.target ?? "";
    message.edge_order = object.edge_order ?? undefined;
    message.source_handle = object.source_handle ?? undefined;
    message.target_handle = object.target_handle ?? undefined;
    return message;
  },
};

function createBaseDeprecated_FilteredShipmentsLoopData(): Deprecated_FilteredShipmentsLoopData {
  return { subgraph_index: 0, status_ids: [], origin_location_ids: [], destination_location_ids: [] };
}

export const Deprecated_FilteredShipmentsLoopData: MessageFns<Deprecated_FilteredShipmentsLoopData> = {
  encode(message: Deprecated_FilteredShipmentsLoopData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.subgraph_index !== 0) {
      writer.uint32(8).int32(message.subgraph_index);
    }
    for (const v of message.status_ids) {
      writer.uint32(18).string(v!);
    }
    for (const v of message.origin_location_ids) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.destination_location_ids) {
      writer.uint32(34).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Deprecated_FilteredShipmentsLoopData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDeprecated_FilteredShipmentsLoopData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.subgraph_index = reader.int32();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.status_ids.push(reader.string());
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.origin_location_ids.push(reader.string());
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.destination_location_ids.push(reader.string());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): Deprecated_FilteredShipmentsLoopData {
    return {
      subgraph_index: isSet(object.subgraphIndex)
        ? globalThis.Number(object.subgraphIndex)
        : isSet(object.subgraph_index)
        ? globalThis.Number(object.subgraph_index)
        : 0,
      status_ids: globalThis.Array.isArray(object?.statusIds)
        ? object.statusIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.status_ids)
        ? object.status_ids.map((e: any) => globalThis.String(e))
        : [],
      origin_location_ids: globalThis.Array.isArray(object?.originLocationIds)
        ? object.originLocationIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.origin_location_ids)
        ? object.origin_location_ids.map((e: any) => globalThis.String(e))
        : [],
      destination_location_ids: globalThis.Array.isArray(object?.destinationLocationIds)
        ? object.destinationLocationIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.destination_location_ids)
        ? object.destination_location_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: Deprecated_FilteredShipmentsLoopData): unknown {
    const obj: any = {};
    if (message.subgraph_index !== 0) {
      obj.subgraphIndex = Math.round(message.subgraph_index);
    }
    if (message.status_ids?.length) {
      obj.statusIds = message.status_ids;
    }
    if (message.origin_location_ids?.length) {
      obj.originLocationIds = message.origin_location_ids;
    }
    if (message.destination_location_ids?.length) {
      obj.destinationLocationIds = message.destination_location_ids;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Deprecated_FilteredShipmentsLoopData>, I>>(
    base?: I,
  ): Deprecated_FilteredShipmentsLoopData {
    return Deprecated_FilteredShipmentsLoopData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Deprecated_FilteredShipmentsLoopData>, I>>(
    object: I,
  ): Deprecated_FilteredShipmentsLoopData {
    const message = createBaseDeprecated_FilteredShipmentsLoopData();
    message.subgraph_index = object.subgraph_index ?? 0;
    message.status_ids = object.status_ids?.map((e) => e) || [];
    message.origin_location_ids = object.origin_location_ids?.map((e) => e) || [];
    message.destination_location_ids = object.destination_location_ids?.map((e) => e) || [];
    return message;
  },
};

function createBaseManualExecutionTriggerData(): ManualExecutionTriggerData {
  return { external_trigger: "", execution_keyword: "" };
}

export const ManualExecutionTriggerData: MessageFns<ManualExecutionTriggerData> = {
  encode(message: ManualExecutionTriggerData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.external_trigger !== "") {
      writer.uint32(10).string(message.external_trigger);
    }
    if (message.execution_keyword !== "") {
      writer.uint32(18).string(message.execution_keyword);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ManualExecutionTriggerData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseManualExecutionTriggerData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.external_trigger = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.execution_keyword = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): ManualExecutionTriggerData {
    return {
      external_trigger: isSet(object.externalTrigger)
        ? globalThis.String(object.externalTrigger)
        : isSet(object.external_trigger)
        ? globalThis.String(object.external_trigger)
        : "",
      execution_keyword: isSet(object.executionKeyword)
        ? globalThis.String(object.executionKeyword)
        : isSet(object.execution_keyword)
        ? globalThis.String(object.execution_keyword)
        : "",
    };
  },

  toJSON(message: ManualExecutionTriggerData): unknown {
    const obj: any = {};
    if (message.external_trigger !== "") {
      obj.externalTrigger = message.external_trigger;
    }
    if (message.execution_keyword !== "") {
      obj.executionKeyword = message.execution_keyword;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ManualExecutionTriggerData>, I>>(base?: I): ManualExecutionTriggerData {
    return ManualExecutionTriggerData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ManualExecutionTriggerData>, I>>(object: I): ManualExecutionTriggerData {
    const message = createBaseManualExecutionTriggerData();
    message.external_trigger = object.external_trigger ?? "";
    message.execution_keyword = object.execution_keyword ?? "";
    return message;
  },
};

function createBaseFilterDateRange(): FilterDateRange {
  return { period: "", start: "", end: "" };
}

export const FilterDateRange: MessageFns<FilterDateRange> = {
  encode(message: FilterDateRange, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.period !== "") {
      writer.uint32(10).string(message.period);
    }
    if (message.start !== "") {
      writer.uint32(18).string(message.start);
    }
    if (message.end !== "") {
      writer.uint32(26).string(message.end);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FilterDateRange {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseFilterDateRange();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.period = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.start = reader.string();
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.end = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): FilterDateRange {
    return {
      period: isSet(object.period) ? globalThis.String(object.period) : "",
      start: isSet(object.start) ? globalThis.String(object.start) : "",
      end: isSet(object.end) ? globalThis.String(object.end) : "",
    };
  },

  toJSON(message: FilterDateRange): unknown {
    const obj: any = {};
    if (message.period !== "") {
      obj.period = message.period;
    }
    if (message.start !== "") {
      obj.start = message.start;
    }
    if (message.end !== "") {
      obj.end = message.end;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FilterDateRange>, I>>(base?: I): FilterDateRange {
    return FilterDateRange.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FilterDateRange>, I>>(object: I): FilterDateRange {
    const message = createBaseFilterDateRange();
    message.period = object.period ?? "";
    message.start = object.start ?? "";
    message.end = object.end ?? "";
    return message;
  },
};

function createBaseFilterControlFlowData(): FilterControlFlowData {
  return {
    subgraph_index: 0,
    team: [],
    from_location: [],
    to_location: [],
    origin_state: [],
    destination_state: [],
    location_type: [],
    alert_types: [],
    type: [],
    last_open_alert_aging: [],
    status: [],
    delivery_status: [],
    pod_status: [],
    product: [],
    product_type: [],
    project_id: [],
    temperature: [],
    courier: [],
    link_code: [],
    scheduled_pickup_date: {},
    scheduled_delivery_date: {},
    created_at: {},
    archived: "",
    team_logic: "",
    location_type_logic: "",
    alert_types_logic: "",
    product_logic: "",
    product_type_logic: "",
    project_id_logic: "",
  };
}

export const FilterControlFlowData: MessageFns<FilterControlFlowData> = {
  encode(message: FilterControlFlowData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.subgraph_index !== 0) {
      writer.uint32(8).int32(message.subgraph_index);
    }
    for (const v of message.team) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.from_location) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.to_location) {
      writer.uint32(42).string(v!);
    }
    for (const v of message.origin_state) {
      writer.uint32(50).string(v!);
    }
    for (const v of message.destination_state) {
      writer.uint32(58).string(v!);
    }
    for (const v of message.location_type) {
      writer.uint32(66).string(v!);
    }
    for (const v of message.alert_types) {
      writer.uint32(74).string(v!);
    }
    for (const v of message.type) {
      writer.uint32(82).string(v!);
    }
    for (const v of message.last_open_alert_aging) {
      writer.uint32(90).string(v!);
    }
    for (const v of message.status) {
      writer.uint32(98).string(v!);
    }
    for (const v of message.delivery_status) {
      writer.uint32(106).string(v!);
    }
    for (const v of message.pod_status) {
      writer.uint32(114).string(v!);
    }
    for (const v of message.product) {
      writer.uint32(122).string(v!);
    }
    for (const v of message.product_type) {
      writer.uint32(130).string(v!);
    }
    for (const v of message.project_id) {
      writer.uint32(138).string(v!);
    }
    for (const v of message.temperature) {
      writer.uint32(146).string(v!);
    }
    for (const v of message.courier) {
      writer.uint32(154).string(v!);
    }
    for (const v of message.link_code) {
      writer.uint32(162).string(v!);
    }
    globalThis.Object.entries(message.scheduled_pickup_date).forEach(([key, value]: [string, FilterDateRange]) => {
      FilterControlFlowData_ScheduledPickupDateEntry.encode({ key: key as any, value }, writer.uint32(170).fork())
        .join();
    });
    globalThis.Object.entries(message.scheduled_delivery_date).forEach(([key, value]: [string, FilterDateRange]) => {
      FilterControlFlowData_ScheduledDeliveryDateEntry.encode({ key: key as any, value }, writer.uint32(178).fork())
        .join();
    });
    globalThis.Object.entries(message.created_at).forEach(([key, value]: [string, FilterDateRange]) => {
      FilterControlFlowData_CreatedAtEntry.encode({ key: key as any, value }, writer.uint32(186).fork()).join();
    });
    if (message.archived !== "") {
      writer.uint32(194).string(message.archived);
    }
    if (message.team_logic !== "") {
      writer.uint32(202).string(message.team_logic);
    }
    if (message.location_type_logic !== "") {
      writer.uint32(210).string(message.location_type_logic);
    }
    if (message.alert_types_logic !== "") {
      writer.uint32(218).string(message.alert_types_logic);
    }
    if (message.product_logic !== "") {
      writer.uint32(226).string(message.product_logic);
    }
    if (message.product_type_logic !== "") {
      writer.uint32(234).string(message.product_type_logic);
    }
    if (message.project_id_logic !== "") {
      writer.uint32(242).string(message.project_id_logic);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FilterControlFlowData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseFilterControlFlowData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.subgraph_index = reader.int32();
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.team.push(reader.string());
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.from_location.push(reader.string());
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.to_location.push(reader.string());
            continue;
          }
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.origin_state.push(reader.string());
            continue;
          }
          case 7: {
            if (tag !== 58) {
              break;
            }

            message.destination_state.push(reader.string());
            continue;
          }
          case 8: {
            if (tag !== 66) {
              break;
            }

            message.location_type.push(reader.string());
            continue;
          }
          case 9: {
            if (tag !== 74) {
              break;
            }

            message.alert_types.push(reader.string());
            continue;
          }
          case 10: {
            if (tag !== 82) {
              break;
            }

            message.type.push(reader.string());
            continue;
          }
          case 11: {
            if (tag !== 90) {
              break;
            }

            message.last_open_alert_aging.push(reader.string());
            continue;
          }
          case 12: {
            if (tag !== 98) {
              break;
            }

            message.status.push(reader.string());
            continue;
          }
          case 13: {
            if (tag !== 106) {
              break;
            }

            message.delivery_status.push(reader.string());
            continue;
          }
          case 14: {
            if (tag !== 114) {
              break;
            }

            message.pod_status.push(reader.string());
            continue;
          }
          case 15: {
            if (tag !== 122) {
              break;
            }

            message.product.push(reader.string());
            continue;
          }
          case 16: {
            if (tag !== 130) {
              break;
            }

            message.product_type.push(reader.string());
            continue;
          }
          case 17: {
            if (tag !== 138) {
              break;
            }

            message.project_id.push(reader.string());
            continue;
          }
          case 18: {
            if (tag !== 146) {
              break;
            }

            message.temperature.push(reader.string());
            continue;
          }
          case 19: {
            if (tag !== 154) {
              break;
            }

            message.courier.push(reader.string());
            continue;
          }
          case 20: {
            if (tag !== 162) {
              break;
            }

            message.link_code.push(reader.string());
            continue;
          }
          case 21: {
            if (tag !== 170) {
              break;
            }

            const entry21 = FilterControlFlowData_ScheduledPickupDateEntry.decode(reader, reader.uint32());
            if (entry21.value !== undefined) {
              message.scheduled_pickup_date[entry21.key] = entry21.value;
            }
            continue;
          }
          case 22: {
            if (tag !== 178) {
              break;
            }

            const entry22 = FilterControlFlowData_ScheduledDeliveryDateEntry.decode(reader, reader.uint32());
            if (entry22.value !== undefined) {
              message.scheduled_delivery_date[entry22.key] = entry22.value;
            }
            continue;
          }
          case 23: {
            if (tag !== 186) {
              break;
            }

            const entry23 = FilterControlFlowData_CreatedAtEntry.decode(reader, reader.uint32());
            if (entry23.value !== undefined) {
              message.created_at[entry23.key] = entry23.value;
            }
            continue;
          }
          case 24: {
            if (tag !== 194) {
              break;
            }

            message.archived = reader.string();
            continue;
          }
          case 25: {
            if (tag !== 202) {
              break;
            }

            message.team_logic = reader.string();
            continue;
          }
          case 26: {
            if (tag !== 210) {
              break;
            }

            message.location_type_logic = reader.string();
            continue;
          }
          case 27: {
            if (tag !== 218) {
              break;
            }

            message.alert_types_logic = reader.string();
            continue;
          }
          case 28: {
            if (tag !== 226) {
              break;
            }

            message.product_logic = reader.string();
            continue;
          }
          case 29: {
            if (tag !== 234) {
              break;
            }

            message.product_type_logic = reader.string();
            continue;
          }
          case 30: {
            if (tag !== 242) {
              break;
            }

            message.project_id_logic = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): FilterControlFlowData {
    return {
      subgraph_index: isSet(object.subgraphIndex)
        ? globalThis.Number(object.subgraphIndex)
        : isSet(object.subgraph_index)
        ? globalThis.Number(object.subgraph_index)
        : 0,
      team: globalThis.Array.isArray(object?.team) ? object.team.map((e: any) => globalThis.String(e)) : [],
      from_location: globalThis.Array.isArray(object?.fromLocation)
        ? object.fromLocation.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.from_location)
        ? object.from_location.map((e: any) => globalThis.String(e))
        : [],
      to_location: globalThis.Array.isArray(object?.toLocation)
        ? object.toLocation.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.to_location)
        ? object.to_location.map((e: any) => globalThis.String(e))
        : [],
      origin_state: globalThis.Array.isArray(object?.originState)
        ? object.originState.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.origin_state)
        ? object.origin_state.map((e: any) => globalThis.String(e))
        : [],
      destination_state: globalThis.Array.isArray(object?.destinationState)
        ? object.destinationState.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.destination_state)
        ? object.destination_state.map((e: any) => globalThis.String(e))
        : [],
      location_type: globalThis.Array.isArray(object?.locationType)
        ? object.locationType.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.location_type)
        ? object.location_type.map((e: any) => globalThis.String(e))
        : [],
      alert_types: globalThis.Array.isArray(object?.alertTypes)
        ? object.alertTypes.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.alert_types)
        ? object.alert_types.map((e: any) => globalThis.String(e))
        : [],
      type: globalThis.Array.isArray(object?.type)
        ? object.type.map((e: any) => globalThis.String(e))
        : [],
      last_open_alert_aging: globalThis.Array.isArray(object?.lastOpenAlertAging)
        ? object.lastOpenAlertAging.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.last_open_alert_aging)
        ? object.last_open_alert_aging.map((e: any) => globalThis.String(e))
        : [],
      status: globalThis.Array.isArray(object?.status)
        ? object.status.map((e: any) => globalThis.String(e))
        : [],
      delivery_status: globalThis.Array.isArray(object?.deliveryStatus)
        ? object.deliveryStatus.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.delivery_status)
        ? object.delivery_status.map((e: any) => globalThis.String(e))
        : [],
      pod_status: globalThis.Array.isArray(object?.podStatus)
        ? object.podStatus.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.pod_status)
        ? object.pod_status.map((e: any) => globalThis.String(e))
        : [],
      product: globalThis.Array.isArray(object?.product) ? object.product.map((e: any) => globalThis.String(e)) : [],
      product_type: globalThis.Array.isArray(object?.productType)
        ? object.productType.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.product_type)
        ? object.product_type.map((e: any) => globalThis.String(e))
        : [],
      project_id: globalThis.Array.isArray(object?.projectId)
        ? object.projectId.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.project_id)
        ? object.project_id.map((e: any) => globalThis.String(e))
        : [],
      temperature: globalThis.Array.isArray(object?.temperature)
        ? object.temperature.map((e: any) => globalThis.String(e))
        : [],
      courier: globalThis.Array.isArray(object?.courier) ? object.courier.map((e: any) => globalThis.String(e)) : [],
      link_code: globalThis.Array.isArray(object?.linkCode)
        ? object.linkCode.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.link_code)
        ? object.link_code.map((e: any) => globalThis.String(e))
        : [],
      scheduled_pickup_date: isObject(object.scheduledPickupDate)
        ? (globalThis.Object.entries(object.scheduledPickupDate) as [string, any][]).reduce(
          (acc: { [key: number]: FilterDateRange }, [key, value]: [string, any]) => {
            globalThis.Object.defineProperty(acc, globalThis.Number(key), {
              value: FilterDateRange.fromJSON(value),
              enumerable: true,
              configurable: true,
              writable: true,
            });
            return acc;
          },
          {},
        )
        : isObject(object.scheduled_pickup_date)
        ? (globalThis.Object.entries(object.scheduled_pickup_date) as [string, any][]).reduce(
          (acc: { [key: number]: FilterDateRange }, [key, value]: [string, any]) => {
            globalThis.Object.defineProperty(acc, globalThis.Number(key), {
              value: FilterDateRange.fromJSON(value),
              enumerable: true,
              configurable: true,
              writable: true,
            });
            return acc;
          },
          {},
        )
        : {},
      scheduled_delivery_date: isObject(object.scheduledDeliveryDate)
        ? (globalThis.Object.entries(object.scheduledDeliveryDate) as [string, any][]).reduce(
          (acc: { [key: number]: FilterDateRange }, [key, value]: [string, any]) => {
            globalThis.Object.defineProperty(acc, globalThis.Number(key), {
              value: FilterDateRange.fromJSON(value),
              enumerable: true,
              configurable: true,
              writable: true,
            });
            return acc;
          },
          {},
        )
        : isObject(object.scheduled_delivery_date)
        ? (globalThis.Object.entries(object.scheduled_delivery_date) as [string, any][]).reduce(
          (acc: { [key: number]: FilterDateRange }, [key, value]: [string, any]) => {
            globalThis.Object.defineProperty(acc, globalThis.Number(key), {
              value: FilterDateRange.fromJSON(value),
              enumerable: true,
              configurable: true,
              writable: true,
            });
            return acc;
          },
          {},
        )
        : {},
      created_at: isObject(object.createdAt)
        ? (globalThis.Object.entries(object.createdAt) as [string, any][]).reduce(
          (acc: { [key: number]: FilterDateRange }, [key, value]: [string, any]) => {
            globalThis.Object.defineProperty(acc, globalThis.Number(key), {
              value: FilterDateRange.fromJSON(value),
              enumerable: true,
              configurable: true,
              writable: true,
            });
            return acc;
          },
          {},
        )
        : isObject(object.created_at)
        ? (globalThis.Object.entries(object.created_at) as [string, any][]).reduce(
          (acc: { [key: number]: FilterDateRange }, [key, value]: [string, any]) => {
            globalThis.Object.defineProperty(acc, globalThis.Number(key), {
              value: FilterDateRange.fromJSON(value),
              enumerable: true,
              configurable: true,
              writable: true,
            });
            return acc;
          },
          {},
        )
        : {},
      archived: isSet(object.archived) ? globalThis.String(object.archived) : "",
      team_logic: isSet(object.teamLogic)
        ? globalThis.String(object.teamLogic)
        : isSet(object.team_logic)
        ? globalThis.String(object.team_logic)
        : "",
      location_type_logic: isSet(object.locationTypeLogic)
        ? globalThis.String(object.locationTypeLogic)
        : isSet(object.location_type_logic)
        ? globalThis.String(object.location_type_logic)
        : "",
      alert_types_logic: isSet(object.alertTypesLogic)
        ? globalThis.String(object.alertTypesLogic)
        : isSet(object.alert_types_logic)
        ? globalThis.String(object.alert_types_logic)
        : "",
      product_logic: isSet(object.productLogic)
        ? globalThis.String(object.productLogic)
        : isSet(object.product_logic)
        ? globalThis.String(object.product_logic)
        : "",
      product_type_logic: isSet(object.productTypeLogic)
        ? globalThis.String(object.productTypeLogic)
        : isSet(object.product_type_logic)
        ? globalThis.String(object.product_type_logic)
        : "",
      project_id_logic: isSet(object.projectIdLogic)
        ? globalThis.String(object.projectIdLogic)
        : isSet(object.project_id_logic)
        ? globalThis.String(object.project_id_logic)
        : "",
    };
  },

  toJSON(message: FilterControlFlowData): unknown {
    const obj: any = {};
    if (message.subgraph_index !== 0) {
      obj.subgraphIndex = Math.round(message.subgraph_index);
    }
    if (message.team?.length) {
      obj.team = message.team;
    }
    if (message.from_location?.length) {
      obj.fromLocation = message.from_location;
    }
    if (message.to_location?.length) {
      obj.toLocation = message.to_location;
    }
    if (message.origin_state?.length) {
      obj.originState = message.origin_state;
    }
    if (message.destination_state?.length) {
      obj.destinationState = message.destination_state;
    }
    if (message.location_type?.length) {
      obj.locationType = message.location_type;
    }
    if (message.alert_types?.length) {
      obj.alertTypes = message.alert_types;
    }
    if (message.type?.length) {
      obj.type = message.type;
    }
    if (message.last_open_alert_aging?.length) {
      obj.lastOpenAlertAging = message.last_open_alert_aging;
    }
    if (message.status?.length) {
      obj.status = message.status;
    }
    if (message.delivery_status?.length) {
      obj.deliveryStatus = message.delivery_status;
    }
    if (message.pod_status?.length) {
      obj.podStatus = message.pod_status;
    }
    if (message.product?.length) {
      obj.product = message.product;
    }
    if (message.product_type?.length) {
      obj.productType = message.product_type;
    }
    if (message.project_id?.length) {
      obj.projectId = message.project_id;
    }
    if (message.temperature?.length) {
      obj.temperature = message.temperature;
    }
    if (message.courier?.length) {
      obj.courier = message.courier;
    }
    if (message.link_code?.length) {
      obj.linkCode = message.link_code;
    }
    if (message.scheduled_pickup_date) {
      const entries = globalThis.Object.entries(message.scheduled_pickup_date) as [string, FilterDateRange][];
      if (entries.length > 0) {
        obj.scheduledPickupDate = {};
        entries.forEach(([k, v]) => {
          obj.scheduledPickupDate[k] = FilterDateRange.toJSON(v);
        });
      }
    }
    if (message.scheduled_delivery_date) {
      const entries = globalThis.Object.entries(message.scheduled_delivery_date) as [string, FilterDateRange][];
      if (entries.length > 0) {
        obj.scheduledDeliveryDate = {};
        entries.forEach(([k, v]) => {
          obj.scheduledDeliveryDate[k] = FilterDateRange.toJSON(v);
        });
      }
    }
    if (message.created_at) {
      const entries = globalThis.Object.entries(message.created_at) as [string, FilterDateRange][];
      if (entries.length > 0) {
        obj.createdAt = {};
        entries.forEach(([k, v]) => {
          obj.createdAt[k] = FilterDateRange.toJSON(v);
        });
      }
    }
    if (message.archived !== "") {
      obj.archived = message.archived;
    }
    if (message.team_logic !== "") {
      obj.teamLogic = message.team_logic;
    }
    if (message.location_type_logic !== "") {
      obj.locationTypeLogic = message.location_type_logic;
    }
    if (message.alert_types_logic !== "") {
      obj.alertTypesLogic = message.alert_types_logic;
    }
    if (message.product_logic !== "") {
      obj.productLogic = message.product_logic;
    }
    if (message.product_type_logic !== "") {
      obj.productTypeLogic = message.product_type_logic;
    }
    if (message.project_id_logic !== "") {
      obj.projectIdLogic = message.project_id_logic;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FilterControlFlowData>, I>>(base?: I): FilterControlFlowData {
    return FilterControlFlowData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FilterControlFlowData>, I>>(object: I): FilterControlFlowData {
    const message = createBaseFilterControlFlowData();
    message.subgraph_index = object.subgraph_index ?? 0;
    message.team = object.team?.map((e) => e) || [];
    message.from_location = object.from_location?.map((e) => e) || [];
    message.to_location = object.to_location?.map((e) => e) || [];
    message.origin_state = object.origin_state?.map((e) => e) || [];
    message.destination_state = object.destination_state?.map((e) => e) || [];
    message.location_type = object.location_type?.map((e) => e) || [];
    message.alert_types = object.alert_types?.map((e) => e) || [];
    message.type = object.type?.map((e) => e) || [];
    message.last_open_alert_aging = object.last_open_alert_aging?.map((e) => e) || [];
    message.status = object.status?.map((e) => e) || [];
    message.delivery_status = object.delivery_status?.map((e) => e) || [];
    message.pod_status = object.pod_status?.map((e) => e) || [];
    message.product = object.product?.map((e) => e) || [];
    message.product_type = object.product_type?.map((e) => e) || [];
    message.project_id = object.project_id?.map((e) => e) || [];
    message.temperature = object.temperature?.map((e) => e) || [];
    message.courier = object.courier?.map((e) => e) || [];
    message.link_code = object.link_code?.map((e) => e) || [];
    message.scheduled_pickup_date =
      (globalThis.Object.entries(object.scheduled_pickup_date ?? {}) as [string, FilterDateRange][]).reduce(
        (acc: { [key: number]: FilterDateRange }, [key, value]: [string, FilterDateRange]) => {
          if (value !== undefined) {
            acc[globalThis.Number(key)] = FilterDateRange.fromPartial(value);
          }
          return acc;
        },
        {},
      );
    message.scheduled_delivery_date =
      (globalThis.Object.entries(object.scheduled_delivery_date ?? {}) as [string, FilterDateRange][]).reduce(
        (acc: { [key: number]: FilterDateRange }, [key, value]: [string, FilterDateRange]) => {
          if (value !== undefined) {
            acc[globalThis.Number(key)] = FilterDateRange.fromPartial(value);
          }
          return acc;
        },
        {},
      );
    message.created_at = (globalThis.Object.entries(object.created_at ?? {}) as [string, FilterDateRange][]).reduce(
      (acc: { [key: number]: FilterDateRange }, [key, value]: [string, FilterDateRange]) => {
        if (value !== undefined) {
          acc[globalThis.Number(key)] = FilterDateRange.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.archived = object.archived ?? "";
    message.team_logic = object.team_logic ?? "";
    message.location_type_logic = object.location_type_logic ?? "";
    message.alert_types_logic = object.alert_types_logic ?? "";
    message.product_logic = object.product_logic ?? "";
    message.product_type_logic = object.product_type_logic ?? "";
    message.project_id_logic = object.project_id_logic ?? "";
    return message;
  },
};

function createBaseFilterControlFlowData_ScheduledPickupDateEntry(): FilterControlFlowData_ScheduledPickupDateEntry {
  return { key: 0, value: undefined };
}

export const FilterControlFlowData_ScheduledPickupDateEntry: MessageFns<
  FilterControlFlowData_ScheduledPickupDateEntry
> = {
  encode(
    message: FilterControlFlowData_ScheduledPickupDateEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== 0) {
      writer.uint32(8).int32(message.key);
    }
    if (message.value !== undefined) {
      FilterDateRange.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FilterControlFlowData_ScheduledPickupDateEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseFilterControlFlowData_ScheduledPickupDateEntry();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.key = reader.int32();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.value = FilterDateRange.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): FilterControlFlowData_ScheduledPickupDateEntry {
    return {
      key: isSet(object.key) ? globalThis.Number(object.key) : 0,
      value: isSet(object.value) ? FilterDateRange.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: FilterControlFlowData_ScheduledPickupDateEntry): unknown {
    const obj: any = {};
    if (message.key !== 0) {
      obj.key = Math.round(message.key);
    }
    if (message.value !== undefined) {
      obj.value = FilterDateRange.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FilterControlFlowData_ScheduledPickupDateEntry>, I>>(
    base?: I,
  ): FilterControlFlowData_ScheduledPickupDateEntry {
    return FilterControlFlowData_ScheduledPickupDateEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FilterControlFlowData_ScheduledPickupDateEntry>, I>>(
    object: I,
  ): FilterControlFlowData_ScheduledPickupDateEntry {
    const message = createBaseFilterControlFlowData_ScheduledPickupDateEntry();
    message.key = object.key ?? 0;
    message.value = (object.value !== undefined && object.value !== null)
      ? FilterDateRange.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseFilterControlFlowData_ScheduledDeliveryDateEntry(): FilterControlFlowData_ScheduledDeliveryDateEntry {
  return { key: 0, value: undefined };
}

export const FilterControlFlowData_ScheduledDeliveryDateEntry: MessageFns<
  FilterControlFlowData_ScheduledDeliveryDateEntry
> = {
  encode(
    message: FilterControlFlowData_ScheduledDeliveryDateEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== 0) {
      writer.uint32(8).int32(message.key);
    }
    if (message.value !== undefined) {
      FilterDateRange.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FilterControlFlowData_ScheduledDeliveryDateEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseFilterControlFlowData_ScheduledDeliveryDateEntry();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.key = reader.int32();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.value = FilterDateRange.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): FilterControlFlowData_ScheduledDeliveryDateEntry {
    return {
      key: isSet(object.key) ? globalThis.Number(object.key) : 0,
      value: isSet(object.value) ? FilterDateRange.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: FilterControlFlowData_ScheduledDeliveryDateEntry): unknown {
    const obj: any = {};
    if (message.key !== 0) {
      obj.key = Math.round(message.key);
    }
    if (message.value !== undefined) {
      obj.value = FilterDateRange.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FilterControlFlowData_ScheduledDeliveryDateEntry>, I>>(
    base?: I,
  ): FilterControlFlowData_ScheduledDeliveryDateEntry {
    return FilterControlFlowData_ScheduledDeliveryDateEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FilterControlFlowData_ScheduledDeliveryDateEntry>, I>>(
    object: I,
  ): FilterControlFlowData_ScheduledDeliveryDateEntry {
    const message = createBaseFilterControlFlowData_ScheduledDeliveryDateEntry();
    message.key = object.key ?? 0;
    message.value = (object.value !== undefined && object.value !== null)
      ? FilterDateRange.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseFilterControlFlowData_CreatedAtEntry(): FilterControlFlowData_CreatedAtEntry {
  return { key: 0, value: undefined };
}

export const FilterControlFlowData_CreatedAtEntry: MessageFns<FilterControlFlowData_CreatedAtEntry> = {
  encode(message: FilterControlFlowData_CreatedAtEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== 0) {
      writer.uint32(8).int32(message.key);
    }
    if (message.value !== undefined) {
      FilterDateRange.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FilterControlFlowData_CreatedAtEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseFilterControlFlowData_CreatedAtEntry();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.key = reader.int32();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.value = FilterDateRange.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): FilterControlFlowData_CreatedAtEntry {
    return {
      key: isSet(object.key) ? globalThis.Number(object.key) : 0,
      value: isSet(object.value) ? FilterDateRange.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: FilterControlFlowData_CreatedAtEntry): unknown {
    const obj: any = {};
    if (message.key !== 0) {
      obj.key = Math.round(message.key);
    }
    if (message.value !== undefined) {
      obj.value = FilterDateRange.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FilterControlFlowData_CreatedAtEntry>, I>>(
    base?: I,
  ): FilterControlFlowData_CreatedAtEntry {
    return FilterControlFlowData_CreatedAtEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FilterControlFlowData_CreatedAtEntry>, I>>(
    object: I,
  ): FilterControlFlowData_CreatedAtEntry {
    const message = createBaseFilterControlFlowData_CreatedAtEntry();
    message.key = object.key ?? 0;
    message.value = (object.value !== undefined && object.value !== null)
      ? FilterDateRange.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseWorkflowTestRunData(): WorkflowTestRunData {
  return { workflow: undefined, shipment_id: "", alert_id: "", email_recipients: [], skip_delays: false };
}

export const WorkflowTestRunData: MessageFns<WorkflowTestRunData> = {
  encode(message: WorkflowTestRunData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.workflow !== undefined) {
      LBWorkflow.encode(message.workflow, writer.uint32(10).fork()).join();
    }
    if (message.shipment_id !== "") {
      writer.uint32(18).string(message.shipment_id);
    }
    if (message.alert_id !== "") {
      writer.uint32(26).string(message.alert_id);
    }
    for (const v of message.email_recipients) {
      writer.uint32(34).string(v!);
    }
    if (message.skip_delays !== false) {
      writer.uint32(40).bool(message.skip_delays);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WorkflowTestRunData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseWorkflowTestRunData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.workflow = LBWorkflow.decode(reader, reader.uint32());
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.shipment_id = reader.string();
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.alert_id = reader.string();
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.email_recipients.push(reader.string());
            continue;
          }
          case 5: {
            if (tag !== 40) {
              break;
            }

            message.skip_delays = reader.bool();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): WorkflowTestRunData {
    return {
      workflow: isSet(object.workflow) ? LBWorkflow.fromJSON(object.workflow) : undefined,
      shipment_id: isSet(object.shipmentId)
        ? globalThis.String(object.shipmentId)
        : isSet(object.shipment_id)
        ? globalThis.String(object.shipment_id)
        : "",
      alert_id: isSet(object.alertId)
        ? globalThis.String(object.alertId)
        : isSet(object.alert_id)
        ? globalThis.String(object.alert_id)
        : "",
      email_recipients: globalThis.Array.isArray(object?.emailRecipients)
        ? object.emailRecipients.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.email_recipients)
        ? object.email_recipients.map((e: any) => globalThis.String(e))
        : [],
      skip_delays: isSet(object.skipDelays)
        ? globalThis.Boolean(object.skipDelays)
        : isSet(object.skip_delays)
        ? globalThis.Boolean(object.skip_delays)
        : false,
    };
  },

  toJSON(message: WorkflowTestRunData): unknown {
    const obj: any = {};
    if (message.workflow !== undefined) {
      obj.workflow = LBWorkflow.toJSON(message.workflow);
    }
    if (message.shipment_id !== "") {
      obj.shipmentId = message.shipment_id;
    }
    if (message.alert_id !== "") {
      obj.alertId = message.alert_id;
    }
    if (message.email_recipients?.length) {
      obj.emailRecipients = message.email_recipients;
    }
    if (message.skip_delays !== false) {
      obj.skipDelays = message.skip_delays;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WorkflowTestRunData>, I>>(base?: I): WorkflowTestRunData {
    return WorkflowTestRunData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WorkflowTestRunData>, I>>(object: I): WorkflowTestRunData {
    const message = createBaseWorkflowTestRunData();
    message.workflow = (object.workflow !== undefined && object.workflow !== null)
      ? LBWorkflow.fromPartial(object.workflow)
      : undefined;
    message.shipment_id = object.shipment_id ?? "";
    message.alert_id = object.alert_id ?? "";
    message.email_recipients = object.email_recipients?.map((e) => e) || [];
    message.skip_delays = object.skip_delays ?? false;
    return message;
  },
};

function createBaseExecutionState(): ExecutionState {
  return { stack: [], suspended: false, parent_graph_frames: [], delay_loops: [] };
}

export const ExecutionState: MessageFns<ExecutionState> = {
  encode(message: ExecutionState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.stack) {
      ExecutionFrame.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.suspended !== false) {
      writer.uint32(16).bool(message.suspended);
    }
    for (const v of message.parent_graph_frames) {
      ExecutionFrame.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.delay_loops) {
      DelayLoopState.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExecutionState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseExecutionState();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.stack.push(ExecutionFrame.decode(reader, reader.uint32()));
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.suspended = reader.bool();
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.parent_graph_frames.push(ExecutionFrame.decode(reader, reader.uint32()));
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.delay_loops.push(DelayLoopState.decode(reader, reader.uint32()));
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): ExecutionState {
    return {
      stack: globalThis.Array.isArray(object?.stack) ? object.stack.map((e: any) => ExecutionFrame.fromJSON(e)) : [],
      suspended: isSet(object.suspended) ? globalThis.Boolean(object.suspended) : false,
      parent_graph_frames: globalThis.Array.isArray(object?.parentGraphFrames)
        ? object.parentGraphFrames.map((e: any) => ExecutionFrame.fromJSON(e))
        : globalThis.Array.isArray(object?.parent_graph_frames)
        ? object.parent_graph_frames.map((e: any) => ExecutionFrame.fromJSON(e))
        : [],
      delay_loops: globalThis.Array.isArray(object?.delayLoops)
        ? object.delayLoops.map((e: any) => DelayLoopState.fromJSON(e))
        : globalThis.Array.isArray(object?.delay_loops)
        ? object.delay_loops.map((e: any) => DelayLoopState.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ExecutionState): unknown {
    const obj: any = {};
    if (message.stack?.length) {
      obj.stack = message.stack.map((e) => ExecutionFrame.toJSON(e));
    }
    if (message.suspended !== false) {
      obj.suspended = message.suspended;
    }
    if (message.parent_graph_frames?.length) {
      obj.parentGraphFrames = message.parent_graph_frames.map((e) => ExecutionFrame.toJSON(e));
    }
    if (message.delay_loops?.length) {
      obj.delayLoops = message.delay_loops.map((e) => DelayLoopState.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExecutionState>, I>>(base?: I): ExecutionState {
    return ExecutionState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExecutionState>, I>>(object: I): ExecutionState {
    const message = createBaseExecutionState();
    message.stack = object.stack?.map((e) => ExecutionFrame.fromPartial(e)) || [];
    message.suspended = object.suspended ?? false;
    message.parent_graph_frames = object.parent_graph_frames?.map((e) => ExecutionFrame.fromPartial(e)) || [];
    message.delay_loops = object.delay_loops?.map((e) => DelayLoopState.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDelayLoopState(): DelayLoopState {
  return { node_id: "", returns: 0, look_back_since_unix_millis: 0, deadline_unix_millis: 0 };
}

export const DelayLoopState: MessageFns<DelayLoopState> = {
  encode(message: DelayLoopState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.node_id !== "") {
      writer.uint32(10).string(message.node_id);
    }
    if (message.returns !== 0) {
      writer.uint32(16).int32(message.returns);
    }
    if (message.look_back_since_unix_millis !== 0) {
      writer.uint32(24).int64(message.look_back_since_unix_millis);
    }
    if (message.deadline_unix_millis !== 0) {
      writer.uint32(32).int64(message.deadline_unix_millis);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DelayLoopState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDelayLoopState();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.node_id = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.returns = reader.int32();
            continue;
          }
          case 3: {
            if (tag !== 24) {
              break;
            }

            message.look_back_since_unix_millis = longToNumber(reader.int64());
            continue;
          }
          case 4: {
            if (tag !== 32) {
              break;
            }

            message.deadline_unix_millis = longToNumber(reader.int64());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): DelayLoopState {
    return {
      node_id: isSet(object.nodeId)
        ? globalThis.String(object.nodeId)
        : isSet(object.node_id)
        ? globalThis.String(object.node_id)
        : "",
      returns: isSet(object.returns) ? globalThis.Number(object.returns) : 0,
      look_back_since_unix_millis: isSet(object.lookBackSinceUnixMillis)
        ? globalThis.Number(object.lookBackSinceUnixMillis)
        : isSet(object.look_back_since_unix_millis)
        ? globalThis.Number(object.look_back_since_unix_millis)
        : 0,
      deadline_unix_millis: isSet(object.deadlineUnixMillis)
        ? globalThis.Number(object.deadlineUnixMillis)
        : isSet(object.deadline_unix_millis)
        ? globalThis.Number(object.deadline_unix_millis)
        : 0,
    };
  },

  toJSON(message: DelayLoopState): unknown {
    const obj: any = {};
    if (message.node_id !== "") {
      obj.nodeId = message.node_id;
    }
    if (message.returns !== 0) {
      obj.returns = Math.round(message.returns);
    }
    if (message.look_back_since_unix_millis !== 0) {
      obj.lookBackSinceUnixMillis = Math.round(message.look_back_since_unix_millis);
    }
    if (message.deadline_unix_millis !== 0) {
      obj.deadlineUnixMillis = Math.round(message.deadline_unix_millis);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DelayLoopState>, I>>(base?: I): DelayLoopState {
    return DelayLoopState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DelayLoopState>, I>>(object: I): DelayLoopState {
    const message = createBaseDelayLoopState();
    message.node_id = object.node_id ?? "";
    message.returns = object.returns ?? 0;
    message.look_back_since_unix_millis = object.look_back_since_unix_millis ?? 0;
    message.deadline_unix_millis = object.deadline_unix_millis ?? 0;
    return message;
  },
};

function createBaseExecutionFrame(): ExecutionFrame {
  return { node_id: "", next_child_index: 0, node_variables: {}, user_variables: {} };
}

export const ExecutionFrame: MessageFns<ExecutionFrame> = {
  encode(message: ExecutionFrame, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.node_id !== "") {
      writer.uint32(10).string(message.node_id);
    }
    if (message.next_child_index !== 0) {
      writer.uint32(16).int32(message.next_child_index);
    }
    globalThis.Object.entries(message.node_variables).forEach(([key, value]: [string, VariableValue]) => {
      ExecutionFrame_NodeVariablesEntry.encode({ key: key as any, value }, writer.uint32(26).fork()).join();
    });
    globalThis.Object.entries(message.user_variables).forEach(([key, value]: [string, VariableValue]) => {
      ExecutionFrame_UserVariablesEntry.encode({ key: key as any, value }, writer.uint32(34).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExecutionFrame {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseExecutionFrame();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.node_id = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.next_child_index = reader.int32();
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            const entry3 = ExecutionFrame_NodeVariablesEntry.decode(reader, reader.uint32());
            if (entry3.value !== undefined) {
              message.node_variables[entry3.key] = entry3.value;
            }
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            const entry4 = ExecutionFrame_UserVariablesEntry.decode(reader, reader.uint32());
            if (entry4.value !== undefined) {
              message.user_variables[entry4.key] = entry4.value;
            }
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): ExecutionFrame {
    return {
      node_id: isSet(object.nodeId)
        ? globalThis.String(object.nodeId)
        : isSet(object.node_id)
        ? globalThis.String(object.node_id)
        : "",
      next_child_index: isSet(object.nextChildIndex)
        ? globalThis.Number(object.nextChildIndex)
        : isSet(object.next_child_index)
        ? globalThis.Number(object.next_child_index)
        : 0,
      node_variables: isObject(object.nodeVariables)
        ? (globalThis.Object.entries(object.nodeVariables) as [string, any][]).reduce(
          (acc: { [key: string]: VariableValue }, [key, value]: [string, any]) => {
            globalThis.Object.defineProperty(acc, key, {
              value: VariableValue.fromJSON(value),
              enumerable: true,
              configurable: true,
              writable: true,
            });
            return acc;
          },
          {},
        )
        : isObject(object.node_variables)
        ? (globalThis.Object.entries(object.node_variables) as [string, any][]).reduce(
          (acc: { [key: string]: VariableValue }, [key, value]: [string, any]) => {
            globalThis.Object.defineProperty(acc, key, {
              value: VariableValue.fromJSON(value),
              enumerable: true,
              configurable: true,
              writable: true,
            });
            return acc;
          },
          {},
        )
        : {},
      user_variables: isObject(object.userVariables)
        ? (globalThis.Object.entries(object.userVariables) as [string, any][]).reduce(
          (acc: { [key: string]: VariableValue }, [key, value]: [string, any]) => {
            globalThis.Object.defineProperty(acc, key, {
              value: VariableValue.fromJSON(value),
              enumerable: true,
              configurable: true,
              writable: true,
            });
            return acc;
          },
          {},
        )
        : isObject(object.user_variables)
        ? (globalThis.Object.entries(object.user_variables) as [string, any][]).reduce(
          (acc: { [key: string]: VariableValue }, [key, value]: [string, any]) => {
            globalThis.Object.defineProperty(acc, key, {
              value: VariableValue.fromJSON(value),
              enumerable: true,
              configurable: true,
              writable: true,
            });
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: ExecutionFrame): unknown {
    const obj: any = {};
    if (message.node_id !== "") {
      obj.nodeId = message.node_id;
    }
    if (message.next_child_index !== 0) {
      obj.nextChildIndex = Math.round(message.next_child_index);
    }
    if (message.node_variables) {
      const entries = globalThis.Object.entries(message.node_variables) as [string, VariableValue][];
      if (entries.length > 0) {
        obj.nodeVariables = {};
        entries.forEach(([k, v]) => {
          obj.nodeVariables[k] = VariableValue.toJSON(v);
        });
      }
    }
    if (message.user_variables) {
      const entries = globalThis.Object.entries(message.user_variables) as [string, VariableValue][];
      if (entries.length > 0) {
        obj.userVariables = {};
        entries.forEach(([k, v]) => {
          obj.userVariables[k] = VariableValue.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExecutionFrame>, I>>(base?: I): ExecutionFrame {
    return ExecutionFrame.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExecutionFrame>, I>>(object: I): ExecutionFrame {
    const message = createBaseExecutionFrame();
    message.node_id = object.node_id ?? "";
    message.next_child_index = object.next_child_index ?? 0;
    message.node_variables = (globalThis.Object.entries(object.node_variables ?? {}) as [string, VariableValue][])
      .reduce((acc: { [key: string]: VariableValue }, [key, value]: [string, VariableValue]) => {
        if (value !== undefined) {
          acc[key] = VariableValue.fromPartial(value);
        }
        return acc;
      }, {});
    message.user_variables = (globalThis.Object.entries(object.user_variables ?? {}) as [string, VariableValue][])
      .reduce((acc: { [key: string]: VariableValue }, [key, value]: [string, VariableValue]) => {
        if (value !== undefined) {
          acc[key] = VariableValue.fromPartial(value);
        }
        return acc;
      }, {});
    return message;
  },
};

function createBaseExecutionFrame_NodeVariablesEntry(): ExecutionFrame_NodeVariablesEntry {
  return { key: "", value: undefined };
}

export const ExecutionFrame_NodeVariablesEntry: MessageFns<ExecutionFrame_NodeVariablesEntry> = {
  encode(message: ExecutionFrame_NodeVariablesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      VariableValue.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExecutionFrame_NodeVariablesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseExecutionFrame_NodeVariablesEntry();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.key = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.value = VariableValue.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): ExecutionFrame_NodeVariablesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? VariableValue.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: ExecutionFrame_NodeVariablesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = VariableValue.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExecutionFrame_NodeVariablesEntry>, I>>(
    base?: I,
  ): ExecutionFrame_NodeVariablesEntry {
    return ExecutionFrame_NodeVariablesEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExecutionFrame_NodeVariablesEntry>, I>>(
    object: I,
  ): ExecutionFrame_NodeVariablesEntry {
    const message = createBaseExecutionFrame_NodeVariablesEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? VariableValue.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseExecutionFrame_UserVariablesEntry(): ExecutionFrame_UserVariablesEntry {
  return { key: "", value: undefined };
}

export const ExecutionFrame_UserVariablesEntry: MessageFns<ExecutionFrame_UserVariablesEntry> = {
  encode(message: ExecutionFrame_UserVariablesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      VariableValue.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExecutionFrame_UserVariablesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseExecutionFrame_UserVariablesEntry();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.key = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.value = VariableValue.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): ExecutionFrame_UserVariablesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? VariableValue.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: ExecutionFrame_UserVariablesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = VariableValue.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExecutionFrame_UserVariablesEntry>, I>>(
    base?: I,
  ): ExecutionFrame_UserVariablesEntry {
    return ExecutionFrame_UserVariablesEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExecutionFrame_UserVariablesEntry>, I>>(
    object: I,
  ): ExecutionFrame_UserVariablesEntry {
    const message = createBaseExecutionFrame_UserVariablesEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? VariableValue.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseDateTimeValue(): DateTimeValue {
  return { unix_millis: 0, iana_timezone: "" };
}

export const DateTimeValue: MessageFns<DateTimeValue> = {
  encode(message: DateTimeValue, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.unix_millis !== 0) {
      writer.uint32(8).int64(message.unix_millis);
    }
    if (message.iana_timezone !== "") {
      writer.uint32(18).string(message.iana_timezone);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DateTimeValue {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDateTimeValue();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.unix_millis = longToNumber(reader.int64());
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.iana_timezone = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): DateTimeValue {
    return {
      unix_millis: isSet(object.unixMillis)
        ? globalThis.Number(object.unixMillis)
        : isSet(object.unix_millis)
        ? globalThis.Number(object.unix_millis)
        : 0,
      iana_timezone: isSet(object.ianaTimezone)
        ? globalThis.String(object.ianaTimezone)
        : isSet(object.iana_timezone)
        ? globalThis.String(object.iana_timezone)
        : "",
    };
  },

  toJSON(message: DateTimeValue): unknown {
    const obj: any = {};
    if (message.unix_millis !== 0) {
      obj.unixMillis = Math.round(message.unix_millis);
    }
    if (message.iana_timezone !== "") {
      obj.ianaTimezone = message.iana_timezone;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DateTimeValue>, I>>(base?: I): DateTimeValue {
    return DateTimeValue.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DateTimeValue>, I>>(object: I): DateTimeValue {
    const message = createBaseDateTimeValue();
    message.unix_millis = object.unix_millis ?? 0;
    message.iana_timezone = object.iana_timezone ?? "";
    return message;
  },
};

function createBaseDateTimeRangeValue(): DateTimeRangeValue {
  return { start: undefined, end: undefined };
}

export const DateTimeRangeValue: MessageFns<DateTimeRangeValue> = {
  encode(message: DateTimeRangeValue, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.start !== undefined) {
      DateTimeValue.encode(message.start, writer.uint32(10).fork()).join();
    }
    if (message.end !== undefined) {
      DateTimeValue.encode(message.end, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DateTimeRangeValue {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDateTimeRangeValue();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.start = DateTimeValue.decode(reader, reader.uint32());
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.end = DateTimeValue.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): DateTimeRangeValue {
    return {
      start: isSet(object.start) ? DateTimeValue.fromJSON(object.start) : undefined,
      end: isSet(object.end) ? DateTimeValue.fromJSON(object.end) : undefined,
    };
  },

  toJSON(message: DateTimeRangeValue): unknown {
    const obj: any = {};
    if (message.start !== undefined) {
      obj.start = DateTimeValue.toJSON(message.start);
    }
    if (message.end !== undefined) {
      obj.end = DateTimeValue.toJSON(message.end);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DateTimeRangeValue>, I>>(base?: I): DateTimeRangeValue {
    return DateTimeRangeValue.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DateTimeRangeValue>, I>>(object: I): DateTimeRangeValue {
    const message = createBaseDateTimeRangeValue();
    message.start = (object.start !== undefined && object.start !== null)
      ? DateTimeValue.fromPartial(object.start)
      : undefined;
    message.end = (object.end !== undefined && object.end !== null) ? DateTimeValue.fromPartial(object.end) : undefined;
    return message;
  },
};

function createBaseLabeledIdValue(): LabeledIdValue {
  return { id: "", name: "" };
}

export const LabeledIdValue: MessageFns<LabeledIdValue> = {
  encode(message: LabeledIdValue, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LabeledIdValue {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseLabeledIdValue();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.id = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.name = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): LabeledIdValue {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
    };
  },

  toJSON(message: LabeledIdValue): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LabeledIdValue>, I>>(base?: I): LabeledIdValue {
    return LabeledIdValue.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LabeledIdValue>, I>>(object: I): LabeledIdValue {
    const message = createBaseLabeledIdValue();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    return message;
  },
};

function createBaseLabeledIdListValue(): LabeledIdListValue {
  return { items: [] };
}

export const LabeledIdListValue: MessageFns<LabeledIdListValue> = {
  encode(message: LabeledIdListValue, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      LabeledIdValue.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LabeledIdListValue {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseLabeledIdListValue();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.items.push(LabeledIdValue.decode(reader, reader.uint32()));
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): LabeledIdListValue {
    return {
      items: globalThis.Array.isArray(object?.items) ? object.items.map((e: any) => LabeledIdValue.fromJSON(e)) : [],
    };
  },

  toJSON(message: LabeledIdListValue): unknown {
    const obj: any = {};
    if (message.items?.length) {
      obj.items = message.items.map((e) => LabeledIdValue.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LabeledIdListValue>, I>>(base?: I): LabeledIdListValue {
    return LabeledIdListValue.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LabeledIdListValue>, I>>(object: I): LabeledIdListValue {
    const message = createBaseLabeledIdListValue();
    message.items = object.items?.map((e) => LabeledIdValue.fromPartial(e)) || [];
    return message;
  },
};

function createBaseVariableValue(): VariableValue {
  return {
    string_value: undefined,
    number_value: undefined,
    bool_value: undefined,
    datetime_value: undefined,
    date_time_range_value: undefined,
    labeled_id_value: undefined,
    labeled_id_list_value: undefined,
    type: 0,
  };
}

export const VariableValue: MessageFns<VariableValue> = {
  encode(message: VariableValue, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.string_value !== undefined) {
      writer.uint32(10).string(message.string_value);
    }
    if (message.number_value !== undefined) {
      writer.uint32(17).double(message.number_value);
    }
    if (message.bool_value !== undefined) {
      writer.uint32(24).bool(message.bool_value);
    }
    if (message.datetime_value !== undefined) {
      DateTimeValue.encode(message.datetime_value, writer.uint32(42).fork()).join();
    }
    if (message.date_time_range_value !== undefined) {
      DateTimeRangeValue.encode(message.date_time_range_value, writer.uint32(50).fork()).join();
    }
    if (message.labeled_id_value !== undefined) {
      LabeledIdValue.encode(message.labeled_id_value, writer.uint32(58).fork()).join();
    }
    if (message.labeled_id_list_value !== undefined) {
      LabeledIdListValue.encode(message.labeled_id_list_value, writer.uint32(66).fork()).join();
    }
    if (message.type !== 0) {
      writer.uint32(32).int32(message.type);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariableValue {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseVariableValue();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.string_value = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 17) {
              break;
            }

            message.number_value = reader.double();
            continue;
          }
          case 3: {
            if (tag !== 24) {
              break;
            }

            message.bool_value = reader.bool();
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.datetime_value = DateTimeValue.decode(reader, reader.uint32());
            continue;
          }
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.date_time_range_value = DateTimeRangeValue.decode(reader, reader.uint32());
            continue;
          }
          case 7: {
            if (tag !== 58) {
              break;
            }

            message.labeled_id_value = LabeledIdValue.decode(reader, reader.uint32());
            continue;
          }
          case 8: {
            if (tag !== 66) {
              break;
            }

            message.labeled_id_list_value = LabeledIdListValue.decode(reader, reader.uint32());
            continue;
          }
          case 4: {
            if (tag !== 32) {
              break;
            }

            message.type = reader.int32() as any;
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): VariableValue {
    return {
      string_value: isSet(object.stringValue)
        ? globalThis.String(object.stringValue)
        : isSet(object.string_value)
        ? globalThis.String(object.string_value)
        : undefined,
      number_value: isSet(object.numberValue)
        ? globalThis.Number(object.numberValue)
        : isSet(object.number_value)
        ? globalThis.Number(object.number_value)
        : undefined,
      bool_value: isSet(object.boolValue)
        ? globalThis.Boolean(object.boolValue)
        : isSet(object.bool_value)
        ? globalThis.Boolean(object.bool_value)
        : undefined,
      datetime_value: isSet(object.datetimeValue)
        ? DateTimeValue.fromJSON(object.datetimeValue)
        : isSet(object.datetime_value)
        ? DateTimeValue.fromJSON(object.datetime_value)
        : undefined,
      date_time_range_value: isSet(object.dateTimeRangeValue)
        ? DateTimeRangeValue.fromJSON(object.dateTimeRangeValue)
        : isSet(object.date_time_range_value)
        ? DateTimeRangeValue.fromJSON(object.date_time_range_value)
        : undefined,
      labeled_id_value: isSet(object.labeledIdValue)
        ? LabeledIdValue.fromJSON(object.labeledIdValue)
        : isSet(object.labeled_id_value)
        ? LabeledIdValue.fromJSON(object.labeled_id_value)
        : undefined,
      labeled_id_list_value: isSet(object.labeledIdListValue)
        ? LabeledIdListValue.fromJSON(object.labeledIdListValue)
        : isSet(object.labeled_id_list_value)
        ? LabeledIdListValue.fromJSON(object.labeled_id_list_value)
        : undefined,
      type: isSet(object.type) ? variableTypeFromJSON(object.type) : 0,
    };
  },

  toJSON(message: VariableValue): unknown {
    const obj: any = {};
    if (message.string_value !== undefined) {
      obj.stringValue = message.string_value;
    }
    if (message.number_value !== undefined) {
      obj.numberValue = floatToJson(message.number_value);
    }
    if (message.bool_value !== undefined) {
      obj.boolValue = message.bool_value;
    }
    if (message.datetime_value !== undefined) {
      obj.datetimeValue = DateTimeValue.toJSON(message.datetime_value);
    }
    if (message.date_time_range_value !== undefined) {
      obj.dateTimeRangeValue = DateTimeRangeValue.toJSON(message.date_time_range_value);
    }
    if (message.labeled_id_value !== undefined) {
      obj.labeledIdValue = LabeledIdValue.toJSON(message.labeled_id_value);
    }
    if (message.labeled_id_list_value !== undefined) {
      obj.labeledIdListValue = LabeledIdListValue.toJSON(message.labeled_id_list_value);
    }
    if (message.type !== 0) {
      obj.type = variableTypeToJSON(message.type);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VariableValue>, I>>(base?: I): VariableValue {
    return VariableValue.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VariableValue>, I>>(object: I): VariableValue {
    const message = createBaseVariableValue();
    message.string_value = object.string_value ?? undefined;
    message.number_value = object.number_value ?? undefined;
    message.bool_value = object.bool_value ?? undefined;
    message.datetime_value = (object.datetime_value !== undefined && object.datetime_value !== null)
      ? DateTimeValue.fromPartial(object.datetime_value)
      : undefined;
    message.date_time_range_value =
      (object.date_time_range_value !== undefined && object.date_time_range_value !== null)
        ? DateTimeRangeValue.fromPartial(object.date_time_range_value)
        : undefined;
    message.labeled_id_value = (object.labeled_id_value !== undefined && object.labeled_id_value !== null)
      ? LabeledIdValue.fromPartial(object.labeled_id_value)
      : undefined;
    message.labeled_id_list_value =
      (object.labeled_id_list_value !== undefined && object.labeled_id_list_value !== null)
        ? LabeledIdListValue.fromPartial(object.labeled_id_list_value)
        : undefined;
    message.type = object.type ?? 0;
    return message;
  },
};

function createBaseTransferToActionData(): TransferToActionData {
  return { primary_number: "", enable_escalation: false, escalation_option: 0, second_number: "", agent_id: "" };
}

export const TransferToActionData: MessageFns<TransferToActionData> = {
  encode(message: TransferToActionData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.primary_number !== "") {
      writer.uint32(10).string(message.primary_number);
    }
    if (message.enable_escalation !== false) {
      writer.uint32(16).bool(message.enable_escalation);
    }
    if (message.escalation_option !== 0) {
      writer.uint32(24).int32(message.escalation_option);
    }
    if (message.second_number !== "") {
      writer.uint32(34).string(message.second_number);
    }
    if (message.agent_id !== "") {
      writer.uint32(42).string(message.agent_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TransferToActionData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseTransferToActionData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.primary_number = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.enable_escalation = reader.bool();
            continue;
          }
          case 3: {
            if (tag !== 24) {
              break;
            }

            message.escalation_option = reader.int32() as any;
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.second_number = reader.string();
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.agent_id = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): TransferToActionData {
    return {
      primary_number: isSet(object.primaryNumber)
        ? globalThis.String(object.primaryNumber)
        : isSet(object.primary_number)
        ? globalThis.String(object.primary_number)
        : "",
      enable_escalation: isSet(object.enableEscalation)
        ? globalThis.Boolean(object.enableEscalation)
        : isSet(object.enable_escalation)
        ? globalThis.Boolean(object.enable_escalation)
        : false,
      escalation_option: isSet(object.escalationOption)
        ? transferToEscalationOptionFromJSON(object.escalationOption)
        : isSet(object.escalation_option)
        ? transferToEscalationOptionFromJSON(object.escalation_option)
        : 0,
      second_number: isSet(object.secondNumber)
        ? globalThis.String(object.secondNumber)
        : isSet(object.second_number)
        ? globalThis.String(object.second_number)
        : "",
      agent_id: isSet(object.agentId)
        ? globalThis.String(object.agentId)
        : isSet(object.agent_id)
        ? globalThis.String(object.agent_id)
        : "",
    };
  },

  toJSON(message: TransferToActionData): unknown {
    const obj: any = {};
    if (message.primary_number !== "") {
      obj.primaryNumber = message.primary_number;
    }
    if (message.enable_escalation !== false) {
      obj.enableEscalation = message.enable_escalation;
    }
    if (message.escalation_option !== 0) {
      obj.escalationOption = transferToEscalationOptionToJSON(message.escalation_option);
    }
    if (message.second_number !== "") {
      obj.secondNumber = message.second_number;
    }
    if (message.agent_id !== "") {
      obj.agentId = message.agent_id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TransferToActionData>, I>>(base?: I): TransferToActionData {
    return TransferToActionData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TransferToActionData>, I>>(object: I): TransferToActionData {
    const message = createBaseTransferToActionData();
    message.primary_number = object.primary_number ?? "";
    message.enable_escalation = object.enable_escalation ?? false;
    message.escalation_option = object.escalation_option ?? 0;
    message.second_number = object.second_number ?? "";
    message.agent_id = object.agent_id ?? "";
    return message;
  },
};

function floatToJson(value: number | null | undefined): number | string | null | undefined {
  return typeof value === "number" && !globalThis.Number.isFinite(value) ? globalThis.String(value) : value;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
